// return a list of school - school board name

const schoolBoardList = {
	'Simcoe County District School Board': [
		{value: 'Adjala Central Public School', text:'Adjala Central Public School'},
		{value: 'Admiral Collingwood Elementary School', text:'Admiral Collingwood Elementary School'},
		{value: 'Alcona Glen Elementary School', text:'Alcona Glen Elementary School'},
		{value: 'Algonquin Ridge Elementary School', text:'Algonquin Ridge Elementary School'},
		{value: 'Allandale Heights Public School', text:'Allandale Heights Public School'},
		{value: 'Alliston Learning Centre', text:'Alliston Learning Centre'},
		{value: 'Alliston Union Public School', text:'Alliston Union Public School'},
		{value: 'Andrew Hunter Elementary School', text:'Andrew Hunter Elementary School'},
		{value: 'Angus Morrison Elementary School', text:'Angus Morrison Elementary School'},
		{value: 'Ardagh Bluffs Public School', text:'Ardagh Bluffs Public School'},
		{value: 'Assikinack Public School', text:'Assikinack Public School'},
		{value: 'Banting Memorial High School', text:'Banting Memorial High School'},
		{value: 'Barrie Learning Centre', text:'Barrie Learning Centre'},
		{value: 'Barrie North Collegiate Institute', text:'Barrie North Collegiate Institute'},
		{value: 'Baxter Central Public School', text:'Baxter Central Public School'},
		{value: 'Bayview Public School', text:'Bayview Public School'},
		{value: 'Bear Creek Secondary School', text:'Bear Creek Secondary School'},
		{value: 'Birchview Dunes Elementary School', text:'Birchview Dunes Elementary School'},
		{value: 'Boyne River Public School', text:'Boyne River Public School'},
		{value: 'Bradford District High School', text:'Bradford District High School'},
		{value: 'Bradford Learning Centre', text:'Bradford Learning Centre'},
		{value: 'Brechin Public School', text:'Brechin Public School'},
		{value: 'Byng Public School', text:'Byng Public School'},
		{value: 'Cameron Street Public School', text:'Cameron Street Public School'},
		{value: 'Chris Hadfield Public School', text:'Chris Hadfield Public School'},
		{value: 'Clearview Meadows Elementary School', text:'Clearview Meadows Elementary School'},
		{value: 'Codrington Public School', text:'Codrington Public School'},
		{value: 'Coldwater Public School', text:'Coldwater Public School'},
		{value: 'Collingwood Collegiate Institute', text:'Collingwood Collegiate Institute'},
		{value: 'Collingwood Learning Centre', text:'Collingwood Learning Centre'},
		{value: 'Connaught Public School', text:'Connaught Public School'},
		{value: 'Cookstown Central Public School', text:'Cookstown Central Public School'},
		{value: 'Couchiching Heights Public School', text:'Couchiching Heights Public School'},
		{value: 'Cundles Heights Public School', text:'Cundles Heights Public School'},
		{value: 'East Oro Public School', text:'East Oro Public School'},
		{value: 'Eastview Secondary School', text:'Eastview Secondary School'},
		{value: 'Elmvale District High School', text:'Elmvale District High School'},
		{value: 'Emma King Elementary School', text:'Emma King Elementary School'},
		{value: 'Ernest Cumberland Elementary School', text:'Ernest Cumberland Elementary School'},
		{value: 'Ferndale Woods Elementary School', text:'Ferndale Woods Elementary School'},
		{value: 'Fieldcrest Elementary School', text:'Fieldcrest Elementary School'},
		{value: 'Forest Hill Public School', text:'Forest Hill Public School'},
		{value: 'Fred C. Cook Public School', text:'Fred C. Cook Public School'},
		{value: 'Georgian Bay District Secondary School', text:'Georgian Bay District Secondary School'},
		{value: 'Goodfellow Public School', text:'Goodfellow Public School'},
		{value: 'Guthrie Public School', text:'Guthrie Public School'},
		{value: 'Harriett Todd Public School', text:'Harriett Todd Public School'},
		{value: 'Hewitt\'s Creek Public School', text:'Hewitt\'s Creek Public School'},
		{value: 'Hillcrest Public School', text:'Hillcrest Public School'},
		{value: 'Hillsdale Elementary School', text:'Hillsdale Elementary School'},
		{value: 'Holly Meadows Elementary School', text:'Holly Meadows Elementary School'},
		{value: 'Honourable Earl Rowe Public School', text:'Honourable Earl Rowe Public School'},
		{value: 'Huron Park Public School', text:'Huron Park Public School'},
		{value: 'Huronia Centennial Elementary School', text:'Huronia Centennial Elementary School'},
		{value: 'Hyde Park Public School', text:'Hyde Park Public School'},
		{value: 'Innisdale Secondary School', text:'Innisdale Secondary School'},
		{value: 'Innisfil Central Public School', text:'Innisfil Central Public School'},
		{value: 'James Keating Elementarty School', text:'James Keating Elementarty School'},
		{value: 'Johnson Street Public School', text:'Johnson Street Public School'},
		{value: 'Killarney Beach Public School', text:'Killarney Beach Public School'},
		{value: 'Lake Simcoe Public School', text:'Lake Simcoe Public School'},
		{value: 'Lions Oval Public School', text:'Lions Oval Public School'},
		{value: 'Maple Grove Public School', text:'Maple Grove Public School'},
		{value: 'Maple Ridge Secondary School', text:'Maple Ridge Secondary School'},
		{value: 'Mapleview Heights Elementary School', text:'Mapleview Heights Elementary School'},
		{value: 'Marchmont Public School', text:'Marchmont Public School'},
		{value: 'Minesing Central Public School', text:'Minesing Central Public School'},
		{value: 'Moonstone Elementary School', text:'Moonstone Elementary School'},
		{value: 'Mountain View Elementary School', text:'Mountain View Elementary School'},
		{value: 'Mundy\'s Bay Public School', text:'Mundy\'s Bay Public School'},
		{value: 'Nantyr Shores Secondary School', text:'Nantyr Shores Secondary School'},
		{value: 'New Lowell Central Public School', text:'New Lowell Central Public School'},
		{value: 'North Simcoe Learning Centre', text:'North Simcoe Learning Centre'},
		{value: 'Nottawa Elementary School', text:'Nottawa Elementary School'},
		{value: 'Nottawasaga & Creemore Public School', text:'Nottawasaga & Creemore Public School'},
		{value: 'Nottawasaga Pines Secondary School', text:'Nottawasaga Pines Secondary School'},
		{value: 'Oakley Park Public School', text:'Oakley Park Public School'},
		{value: 'Orchard Park Public School', text:'Orchard Park Public School'},
		{value: 'Orillia Learning Centre', text:'Orillia Learning Centre'},
		{value: 'Orillia Secondary School', text:'Orillia Secondary School'},
		{value: 'Pine River Elementary School', text:'Pine River Elementary School'},
		{value: 'Portage View Public School', text:'Portage View Public School'},
		{value: 'Rama Central Public School', text:'Rama Central Public School'},
		{value: 'Regent Park Public School', text:'Regent Park Public School'},
		{value: 'Severn Shores Public School', text:'Severn Shores Public School'},
		{value: 'Shanty Bay Public School', text:'Shanty Bay Public School'},
		{value: 'Simcoe Shores Secondary School - Alliston Campus', text:'Simcoe Shores Secondary School - Alliston Campus'},
		{value: 'Simcoe Shores Secondary School - Bradford Campus', text:'Simcoe Shores Secondary School - Bradford Campus'},
		{value: 'Simcoe Shores Secondary School - Collingwood Campus', text:'Simcoe Shores Secondary School - Collingwood Campus'},
		{value: 'Simcoe Shores Secondary School - Essa Campus', text:'Simcoe Shores Secondary School - Essa Campus'},
		{value: 'Simcoe Shores Secondary School - Innisfil Campus', text:'Simcoe Shores Secondary School - Innisfil Campus'},
		{value: 'Simcoe Shores Secondary School - Midland Campus', text:'Simcoe Shores Secondary School - Midland Campus'},
		{value: 'Simcoe Shores Secondary School - North Barrie Campus', text:'Simcoe Shores Secondary School - North Barrie Campus'},
		{value: 'Simcoe Shores Secondary School - Orillia Campus', text:'Simcoe Shores Secondary School - Orillia Campus'},
		{value: 'Simcoe Shores Secondary School - South Barrie Campus', text:'Simcoe Shores Secondary School - South Barrie Campus'},
		{value: 'Sir William Osler Public School', text:'Sir William Osler Public School'},
		{value: 'Stayner Collegiate Institute', text:'Stayner Collegiate Institute'},
		{value: 'Steele Street Public School', text:'Steele Street Public School'},
		{value: 'Sunnybrae Public School', text:'Sunnybrae Public School'},
		{value: 'Tay Shores Public School', text:'Tay Shores Public School'},
		{value: 'Tecumseth Beeton Elementary School', text:'Tecumseth Beeton Elementary School'},
		{value: 'Tecumseth South Central Public School', text:'Tecumseth South Central Public School'},
		{value: 'Terry Fox Elementary School', text:'Terry Fox Elementary School'},
		{value: 'Tosorontio Central Public School', text:'Tosorontio Central Public School'},
		{value: 'Tottenham Public School', text:'Tottenham Public School'},
		{value: 'Trillium Woods Elementary School', text:'Trillium Woods Elementary School'},
		{value: 'Twin Lakes Secondary School', text:'Twin Lakes Secondary School'},
		{value: 'Uptergrove Public School', text:'Uptergrove Public School'},
		{value: 'W.C. Little Elementary School', text:'W.C. Little Elementary School'},
		{value: 'W.H. Day Elementary School', text:'W.H. Day Elementary School'},
		{value: 'W.R. Best Memorial Public School', text:'W.R. Best Memorial Public School'},
		{value: 'Warminster Elementary School', text:'Warminster Elementary School'},
		{value: 'Warnica Public School', text:'Warnica Public School'},
		{value: 'West Bayfield Elementary School', text:'West Bayfield Elementary School'},
		{value: 'Willow Landing Elementary School', text:'Willow Landing Elementary School'},
		{value: 'Worsley Elementary School', text:'Worsley Elementary School'},
		{value: 'Wyevale Central Public School', text:'Wyevale Central Public School'},
		{value: 'Horseshoe Heights Public School', text:'Horseshoe Heights Public School'},
    ],
    'Thames Valley District School Board': [
		{value: 'A.B Lucas Secondary School', text:'A.B Lucas Secondary School'},
		{value: 'A.J Baker Public School', text:'A.J Baker Public School'},
		{value: 'Aberdeen Public School', text:'Aberdeen Public School'},
		{value: 'Adelaide-W.G. MacDonald P.S', text:'Adelaide-W.G. MacDonald P.S'},
		{value: 'Aldborough Public School', text:'Aldborough Public School'},
		{value: 'Algonquin Public School', text:'Algonquin Public School'},
		{value: 'Annandale Public School', text:'Annandale Public School'},
		{value: 'Arthur Ford Public School', text:'Arthur Ford Public School'},
		{value: 'Arthur Stringer Public School', text:'Arthur Stringer Public School'},
		{value: 'Arthur Voaden Secondary School', text:'Arthur Voaden Secondary School'},
		{value: 'Ashley Oaks Public School', text:'Ashley Oaks Public School'},
		{value: 'B. Davidson Secondary School', text:'B. Davidson Secondary School'},
		{value: 'Balaclava St. Learning Centre', text:'Balaclava St. Learning Centre'},
		{value: 'Blenheim District Public School', text:'Blenheim District Public School'},
		{value: 'Blossom Park Learning Centre', text:'Blossom Park Learning Centre'},
		{value: 'Bonaventure Meadows Public School', text:'Bonaventure Meadows Public School'},
		{value: 'Byron Northview Public School', text:'Byron Northview Public School'},
		{value: 'Byron Somerset Public School', text:'Byron Somerset Public School'},
		{value: 'Byron Southwood Public School', text:'Byron Southwood Public School'},
		{value: 'C.C Carrothers Public School', text:'C.C Carrothers Public School'},
		{value: 'Caradoc North Public School', text:'Caradoc North Public School'},
		{value: 'Cedar Hollow Public School', text:'Cedar Hollow Public School'},
		{value: 'Centennial Central Public School', text:'Centennial Central Public School'},
		{value: 'Central Elgin Collegiate Institute', text:'Central Elgin Collegiate Institute'},
		{value: 'Central Public School', text:'Central Public School'},
		{value: 'Central Secondary School', text:'Central Secondary School'},
		{value: 'Chippewa Public School', text:'Chippewa Public School'},
		{value: 'Clara Brenton Public School', text:'Clara Brenton Public School'},
		{value: 'Clarke Road Secondary School', text:'Clarke Road Secondary School'},
		{value: 'Cleardale Public School', text:'Cleardale Public School'},
		{value: 'College Avenue Secondary School', text:'College Avenue Secondary School'},
		{value: 'Davenport Public School', text:'Davenport Public School'},
		{value: 'Delaware Central Public School', text:'Delaware Central Public School'},
		{value: 'Dunwich-Dutton Public School', text:'Dunwich-Dutton Public School'},
		{value: 'Eagle Heights Public School', text:'Eagle Heights Public School'},
		{value: 'Ealing Public School', text:'Ealing Public School'},
		{value: 'East Carling Public School', text:'East Carling Public School'},
		{value: 'East Elgin Secondary School', text:'East Elgin Secondary School'},
		{value: 'East Oxford Central Public School', text:'East Oxford Central Public School'},
		{value: 'East Williams Memorial Public School', text:'East Williams Memorial Public School'},
		{value: 'Eastdale Public School', text:'Eastdale Public School'},
		{value: 'Ekcoe Cental Public School', text:'Ekcoe Cental Public School'},
		{value: 'Elgin Court Public School', text:'Elgin Court Public School'},
		{value: 'Emily Carr Public School', text:'Emily Carr Public School'},
		{value: 'Emily Stowe Public School', text:'Emily Stowe Public School'},
		{value: 'Éva Circé-Côté French Immersion Public School', text:'Éva Circé-Côté French Immersion Public School'},
		{value: 'Evelyn Harrison Public School', text:'Evelyn Harrison Public School'},
		{value: 'F.D. Roosevelt Public School', text:'F.D. Roosevelt Public School'},
		{value: 'Fairmont Public School', text:'Fairmont Public School'},
		{value: 'Forest Park Public School', text:'Forest Park Public School'},
		{value: 'G.A Wheable Centre', text:'G.A Wheable Centre'},
		{value: 'Glen Cairn Public School', text:'Glen Cairn Public School'},
		{value: 'Glencoe District High School', text:'Glencoe District High School'},
		{value: 'Glendale High School', text:'Glendale High School'},
		{value: 'HB Beal Secondary School', text:'HB Beal Secondary School'},
		{value: 'Harrisfield Public School', text:'Harrisfield Public School'},
		{value: 'Hickson Central Public School', text:'Hickson Central Public School'},
		{value: 'Hillcreast Public School (Central)', text:'Hillcreast Public School (Central)'},
		{value: 'Huron Park Secondary School', text:'Huron Park Secondary School'},
		{value: 'Ingersoll District Collegiate Institute', text:'Ingersoll District Collegiate Institute'},
		{value: 'Innerkip Central Public School', text:'Innerkip Central Public School'},
		{value: 'J.S. Buchanan French Immersion Public School', text:'J.S. Buchanan French Immersion Public School'},
		{value: 'Jack Chambers Public School', text:'Jack Chambers Public School'},
		{value: 'Jaffa Environmental Education Centre', text:'Jaffa Environmental Education Centre'},
		{value: 'Jeanne Sauve French Immersion School', text:'Jeanne Sauve French Immersion School'},
		{value: 'John Dearness Public School', text:'John Dearness Public School'},
		{value: 'John P Robarts Public School', text:'John P Robarts Public School'},
		{value: 'John Wise Public School', text:'John Wise Public School'},
		{value: 'June Rose Callwood Public School', text:'June Rose Callwood Public School'},
		{value: 'Kensal Park Imm French Public School', text:'Kensal Park Imm French Public School'},
		{value: 'Kettle Creek Public School', text:'Kettle Creek Public School'},
		{value: 'Knollwood Park Public School', text:'Knollwood Park Public School'},
		{value: 'Lambeth Public School', text:'Lambeth Public School'},
		{value: 'Laurie Hawkins Public School', text:'Laurie Hawkins Public School'},
		{value: 'Lester B Pearson School for Arts', text:'Lester B Pearson School for Arts'},
		{value: 'Locke\'s Public School', text:'Locke\'s Public School'},
		{value: 'London Environmental Education Centre', text:'London Environmental Education Centre'},
		{value: 'London South Collegiate Institute', text:'London South Collegiate Institute'},
		{value: 'Lord Dorchester Secondary School', text:'Lord Dorchester Secondary School'},
		{value: 'Lord Elgin Public School', text:'Lord Elgin Public School'},
		{value: 'Lord Nelson Public School', text:'Lord Nelson Public School'},
		{value: 'Lord Roberts Imm French Public School', text:'Lord Roberts Imm French Public School'},
		{value: 'Louise Arbour Fr Imm Public School', text:'Louise Arbour Fr Imm Public School'},
		{value: 'Mary Wright Public School', text:'Mary Wright Public School'},
		{value: 'Masonville Public School', text:'Masonville Public School'},
		{value: 'McGillivray Central Public School', text:'McGillivray Central Public School'},
		{value: 'McGregor Public School', text:'McGregor Public School'},
		{value: 'Medway High School', text:'Medway High School'},
		{value: 'Mitchell Hepburn Public School', text:'Mitchell Hepburn Public School'},
		{value: 'Montcalm Secondary School', text:'Montcalm Secondary School'},
		{value: 'Mosa Central Pubic School', text:'Mosa Central Pubic School'},
		{value: 'Mountsfield Public School', text:'Mountsfield Public School'},
		{value: 'New Sarum Public School', text:'New Sarum Public School'},
		{value: 'Nicholas Wilson Public School', text:'Nicholas Wilson Public School'},
		{value: 'North Meadows Public School', text:'North Meadows Public School'},
		{value: 'North Middlesex District High School', text:'North Middlesex District High School'},
		{value: 'Northbrae Public School', text:'Northbrae Public School'},
		{value: 'Northdale Central Public School', text:'Northdale Central Public School'},
		{value: 'Northdale Public School (East)', text:'Northdale Public School (East)'},
		{value: 'Northridge Public School', text:'Northridge Public School'},
		{value: 'Oakridge Secondary School', text:'Oakridge Secondary School'},
		{value: 'Oliver Stephens Public School', text:'Oliver Stephens Public School'},
		{value: 'Orchard Park Public School', text:'Orchard Park Public School'},
		{value: 'Oxbow Public School', text:'Oxbow Public School'},
		{value: 'Parkhill-West Williams Public School', text:'Parkhill-West Williams Public School'},
		{value: 'Parkside Collegiate Institute', text:'Parkside Collegiate Institute'},
		{value: 'Parkview Public School', text:'Parkview Public School'},
		{value: 'Pierre Elliott Trudeau F.I.P.S', text:'Pierre Elliott Trudeau F.I.P.S'},
		{value: 'Plattsville & District Public School', text:'Plattsville & District Public School'},
		{value: 'Port Burwell Public School', text:'Port Burwell Public School'},
		{value: 'Prince Charles Public School', text:'Prince Charles Public School'},
		{value: 'Princess Anne French Imm', text:'Princess Anne French Imm'},
		{value: 'Princess Elizabeth Public School', text:'Princess Elizabeth Public School'},
		{value: 'Rick Hansen Public School', text:'Rick Hansen Public School'},
		{value: 'River Heights Public School', text:'River Heights Public School'},
		{value: 'Riverside Public School', text:'Riverside Public School'},
		{value: 'Roch Carrier French Imm Public School', text:'Roch Carrier French Imm Public School'},
		{value: 'Royal Roads Public School', text:'Royal Roads Public School'},
		{value: 'Ryerson Public School', text:'Ryerson Public School'},
		{value: 'Saunders Secondary School', text:'Saunders Secondary School'},
		{value: 'Sir Arthur Currie Public School', text:'Sir Arthur Currie Public School'},
		{value: 'Sir Frederick Banting Secondary School', text:'Sir Frederick Banting Secondary School'},
		{value: 'Sir Georges Etienne Cartier Public', text:'Sir Georges Etienne Cartier Public'},
		{value: 'Sir Isaac Brock Public School', text:'Sir Isaac Brock Public School'},
		{value: 'Sir John A Macdonald Public School', text:'Sir John A Macdonald Public School'},
		{value: 'Sir Wilfrid Laurier Secondary School', text:'Sir Wilfrid Laurier Secondary School'},
		{value: 'South Dorchester Public School', text:'South Dorchester Public School'},
		{value: 'South Ridge Public School', text:'South Ridge Public School'},
		{value: 'Southside Public School', text:'Southside Public School'},
		{value: 'Southwold Public School', text:'Southwold Public School'},
		{value: 'Springbank Public School', text:'Springbank Public School'},
		{value: 'Springfield Public School', text:'Springfield Public School'},
		{value: 'St.George\'s Public School', text:'St.George\'s Public School'},
		{value: 'Stoney Creek Public School', text:'Stoney Creek Public School'},
		{value: 'Stoneybrook Public School', text:'Stoneybrook Public School'},
		{value: 'Straffordville Public School', text:'Straffordville Public School'},
		{value: 'Strathroy District Collegiate Institute', text:'Strathroy District Collegiate Institute'},
		{value: 'Strathroy Learning Centre', text:'Strathroy Learning Centre'},
		{value: 'Summers\' Corners Public School', text:'Summers\' Corners Public School'},
		{value: 'Tavistock Public School', text:'Tavistock Public School'},
		{value: 'Tecumseh Public School', text:'Tecumseh Public School'},
		{value: 'Thamesford Public School', text:'Thamesford Public School'},
		{value: 'Tillson Avenue Learning Centre', text:'Tillson Avenue Learning Centre'},
		{value: 'Trafalgar Public School', text:'Trafalgar Public School'},
		{value: 'Tweedsmuir Public School', text:'Tweedsmuir Public School'},
		{value: 'University Heights Public School', text:'University Heights Public School'},
		{value: 'Valleyview Public School', text:'Valleyview Public School'},
		{value: 'Vasittart Woods Environmental Education Centre', text:'Vasittart Woods Environmental Education Centre'},
		{value: 'Victoria Public School', text:'Victoria Public School'},
		{value: 'W Sherwood Fox Public School', text:'W Sherwood Fox Public School'},
		{value: 'West Elgin Secondary School', text:'West Elgin Secondary School'},
		{value: 'West Nissouri Public School', text:'West Nissouri Public School'},
		{value: 'West Oaks French Imm Public School', text:'West Oaks French Imm Public School'},
		{value: 'Westfield Public School', text:'Westfield Public School'},
		{value: 'Westminster Central Public School', text:'Westminster Central Public School'},
		{value: 'WestMinster Secondary School', text:'WestMinster Secondary School'},
		{value: 'Westmount Public School', text:'Westmount Public School'},
		{value: 'White Oaks Public School', text:'White Oaks Public School'},
		{value: 'Wilberforce Public School', text:'Wilberforce Public School'},
		{value: 'Wilfrid Jury Public School', text:'Wilfrid Jury Public School'},
		{value: 'Wilton Grove Public School', text:'Wilton Grove Public School'},
		{value: 'Winchester Street Public School', text:'Winchester Street Public School'},
		{value: 'Woodland Heights Public School', text:'Woodland Heights Public School'},
		{value: 'Woodstock Collegiate Institute', text:'Woodstock Collegiate Institute'},
		{value: 'Wortley Road Public School', text:'Wortley Road Public School'},
		{value: 'Zorra Highland Park Public School', text:'Zorra Highland Park Public School'},
    ],
    'Halton Catholic District School Board': [
		{value: 'Ascension Catholic Elementary School', text:'Ascension Catholic Elementary School'},
		{value: 'Assumption Catholic Secondary School', text:'Assumption Catholic Secondary School'},
		{value: 'Bishop P. F. Reding Catholic Secondary School', text:'Bishop P. F. Reding Catholic Secondary School'},
		{value: 'Canadian Martyrs Catholic Elementary School', text:'Canadian Martyrs Catholic Elementary School'},
		{value: 'Christ the King Catholic Secondary School', text:'Christ the King Catholic Secondary School'},
		{value: 'Corpus Christi Catholic Secondary School', text:'Corpus Christi Catholic Secondary School'},
		{value: 'Guardian Angels Catholic Elementary School', text:'Guardian Angels Catholic Elementary School'},
		{value: 'Holy Cross Catholic Elementary School', text:'Holy Cross Catholic Elementary School'},
		{value: 'Holy Family Catholic Elementary School', text:'Holy Family Catholic Elementary School'},
		{value: 'Holy Rosary (Burlington) Catholic Elementary School', text:'Holy Rosary (Burlington) Catholic Elementary School'},
		{value: 'Holy Rosary (Milton) Catholic Elementary School', text:'Holy Rosary (Milton) Catholic Elementary School'},
		{value: 'Holy Trinity Catholic Secondary School', text:'Holy Trinity Catholic Secondary School'},
		{value: 'Lumen Christi Catholic Elementary School', text:'Lumen Christi Catholic Elementary School'},
		{value: 'Notre Dame Catholic Secondary School', text:'Notre Dame Catholic Secondary School'},
		{value: 'Our Lady of Fatima Catholic Elementary School', text:'Our Lady of Fatima Catholic Elementary School'},
		{value: 'Our Lady of Peace Catholic Elementary School', text:'Our Lady of Peace Catholic Elementary School'},
		{value: 'Our Lady of Victory Catholic Elementary School', text:'Our Lady of Victory Catholic Elementary School'},
		{value: 'Queen of Heaven Catholic Elementary School', text:'Queen of Heaven Catholic Elementary School'},
		{value: 'Sacred Heart of Jesus Catholic Elementary School', text:'Sacred Heart of Jesus Catholic Elementary School'},
		{value: 'St. Andrew Catholic Elementary School', text:'St. Andrew Catholic Elementary School'},
		{value: 'St. Anne Catholic Elementary School', text:'St. Anne Catholic Elementary School'},
		{value: 'St. Anthony of Padua Catholic Elementary School', text:'St. Anthony of Padua Catholic Elementary School'},
		{value: 'St. Benedict Catholic Elementary School', text:'St. Benedict Catholic Elementary School'},
		{value: 'St. Bernadette Catholic Elementary School', text:'St. Bernadette Catholic Elementary School'},
		{value: 'St. Brigid Catholic Elementary School', text:'St. Brigid Catholic Elementary School'},
		{value: 'St. Catherine of Alexandria Catholic Elementary School', text:'St. Catherine of Alexandria Catholic Elementary School'},
		{value: 'St. Christopher Catholic Elementary School', text:'St. Christopher Catholic Elementary School'},
		{value: 'St. Dominic Catholic Elementary School', text:'St. Dominic Catholic Elementary School'},
		{value: 'St. Elizabeth Seton Catholic Elementary School', text:'St. Elizabeth Seton Catholic Elementary School'},
		{value: 'St. Francis of Assisi Catholic Elementary School', text:'St. Francis of Assisi Catholic Elementary School'},
		{value: 'St. Francix Xavier Catholic Secondary School', text:'St. Francix Xavier Catholic Secondary School'},
		{value: 'St. Gabriel Catholic Elementary School', text:'St. Gabriel Catholic Elementary School'},
		{value: 'St. Gregory the Great Catholic Elementary School', text:'St. Gregory the Great Catholic Elementary School'},
		{value: 'St. Ignatius of Loyola Catholic Secondary School', text:'St. Ignatius of Loyola Catholic Secondary School'},
		{value: 'St. Joan of Arc Catholic Elementary School', text:'St. Joan of Arc Catholic Elementary School'},
		{value: 'St. John Catholic Elementary School', text:'St. John Catholic Elementary School'},
		{value: 'St. John Paul II Catholic Elementary School', text:'St. John Paul II Catholic Elementary School'},
		{value: 'St. Joseph Catholic Elementary School', text:'St. Joseph Catholic Elementary School'},
		{value: 'St. Luke Catholic Elementary School', text:'St. Luke Catholic Elementary School'},
		{value: 'St. Marguerite d’Youville Catholic Elementary School', text:'St. Marguerite d’Youville Catholic Elementary School'},
		{value: 'St. Mark Catholic Elementary School', text:'St. Mark Catholic Elementary School'},
		{value: 'St. Mary Catholic Elementary School', text:'St. Mary Catholic Elementary School'},
		{value: 'St. Matthew Catholic Elementary School', text:'St. Matthew Catholic Elementary School'},
		{value: 'St. Michael Catholic Elementary School', text:'St. Michael Catholic Elementary School'},
		{value: 'St. Nicholas Catholic Elementary School', text:'St. Nicholas Catholic Elementary School'},
		{value: 'St. Patrick Catholic Elementary School', text:'St. Patrick Catholic Elementary School'},
		{value: 'St. Peter Catholic Elementary School', text:'St. Peter Catholic Elementary School'},
		{value: 'St. Raphael Catholic Elementary School', text:'St. Raphael Catholic Elementary School'},
		{value: 'St. Scholastica Catholic Elementary School', text:'St. Scholastica Catholic Elementary School'},
		{value: 'St. Teresa of Calcutta Catholic Elementary School', text:'St. Teresa of Calcutta Catholic Elementary School'},
		{value: 'St. Thomas Aquinas Catholic Secondary School', text:'St. Thomas Aquinas Catholic Secondary School'},
		{value: 'St. Timothy Catholic Elementary School', text:'St. Timothy Catholic Elementary School'},
		{value: 'St. Vincent Catholic Elementary School', text:'St. Vincent Catholic Elementary School'},
		{value: 'St.Paul Catholic Elementary School', text:'St.Paul Catholic Elementary School'},
		{value: 'Thomas Merton Centre for ConEd (Burlington)', text:'Thomas Merton Centre for ConEd (Burlington)'},
		{value: 'Thomas Merton Centre for ConEd (Milton)', text:'Thomas Merton Centre for ConEd (Milton)'},
		{value: 'Thomas Merton Centre for ConEd (Oakville)', text:'Thomas Merton Centre for ConEd (Oakville)'},
		{value: 'Virtual Elementary School', text:'Virtual Elementary School'},
	],
    'Toronto District School Board': [
		{value: 'Adam Beck Junior Public School', text: 'Adam Beck Junior Public School'},
		{value: 'A Y Jackson Secondary School', text: 'A Y Jackson Secondary School'},
		{value: 'Africentric Alternative School', text: 'Africentric Alternative School'},
		{value: 'Agincourt Collegiate Institute', text: 'Agincourt Collegiate Institute'},
		{value: 'Agincourt Junior Public School', text: 'Agincourt Junior Public School'},
		{value: 'Agnes Macphail Public School', text: 'Agnes Macphail Public School'},
		{value: 'Albert Campbell Collegiate Institute', text: 'Albert Campbell Collegiate Institute'},
		{value: 'Albion Heights Junior Middle School', text: 'Albion Heights Junior Middle School'},
		{value: 'Alexander Muir/Gladstone Ave Junior and Senior Public School', text: 'Alexander Muir/Gladstone Ave Junior and Senior Public School'},
		{value: 'Alexander Stirling Public School', text: 'Alexander Stirling Public School'},
		{value: 'Alexmuir Junior Public School', text: 'Alexmuir Junior Public School'},
		{value: 'Allenby Junior Public School', text: 'Allenby Junior Public School'},
		{value: 'ALPHA Alternative Junior School', text: 'ALPHA Alternative Junior School'},
		{value: 'ALPHA II Alternative School (Elementary)', text: 'ALPHA II Alternative School (Elementary)'},
		{value: 'ALPHA II Alternative School (Secondary)', text: 'ALPHA II Alternative School (Secondary)'},
		{value: 'Alternative Scarborough Education 1', text: 'Alternative Scarborough Education 1'},
		{value: 'Alvin Curling Public School', text: 'Alvin Curling Public School'},
		{value: 'Amesbury Middle School', text: 'Amesbury Middle School'},
		{value: 'Ancaster Public School', text: 'Ancaster Public School'},
		{value: 'Annette Street Junior and Senior Public School', text: 'Annette Street Junior and Senior Public School'},
		{value: 'Anson Park Public School', text: 'Anson Park Public School'},
		{value: 'Anson S Taylor Junior Public School', text: 'Anson S Taylor Junior Public School'},
		{value: 'Arbor Glen Public School', text: 'Arbor Glen Public School'},
		{value: 'Armour Heights Public School', text: 'Armour Heights Public School'},
		{value: 'Avondale Elementary Alternative School', text: 'Avondale Elementary Alternative School'},
		{value: 'Avondale Public School', text: 'Avondale Public School'},
		{value: 'Avondale Secondary Alternative School', text: 'Avondale Secondary Alternative School'},
		{value: 'Bala Avenue Community School', text: 'Bala Avenue Community School'},
		{value: 'Balmy Beach Community School', text: 'Balmy Beach Community School'},
		{value: 'Banting and Best Public School', text: 'Banting and Best Public School'},
		{value: 'Baycrest Public School', text: 'Baycrest Public School'},
		{value: 'Bayview Middle School', text: 'Bayview Middle School'},
		{value: 'Beaches Alternative Junior School', text: 'Beaches Alternative Junior School'},
		{value: 'Beaumonde Heights Junior Middle School', text: 'Beaumonde Heights Junior Middle School'},
		{value: 'Bedford Park Public School', text: 'Bedford Park Public School'},
		{value: 'Bellmere Junior Public School', text: 'Bellmere Junior Public School'},
		{value: 'Ben Heppner Vocal Music Academy', text: 'Ben Heppner Vocal Music Academy'},
		{value: 'Bendale Junior Public School', text: 'Bendale Junior Public School'},
		{value: 'Bennington Heights Elementary School', text: 'Bennington Heights Elementary School'},
		{value: 'Berner Trail Junior Public School', text: 'Berner Trail Junior Public School'},
		{value: 'Bessborough Drive Elementary and Middle School', text: 'Bessborough Drive Elementary and Middle School'},
		{value: 'Beverley Heights Middle School', text: 'Beverley Heights Middle School'},
		{value: 'Beverley School', text: 'Beverley School'},
		{value: 'Beverly Glen Junior Public School', text: 'Beverly Glen Junior Public School'},
		{value: 'Birch Cliff Heights Public School', text: 'Birch Cliff Heights Public School'},
		{value: 'Birch Cliff Public School', text: 'Birch Cliff Public School'},
		{value: 'Birchmount Park Collegiate Institute', text: 'Birchmount Park Collegiate Institute'},
		{value: 'Blacksmith Public School', text: 'Blacksmith Public School'},
		{value: 'Blake Street Junior Public School', text: 'Blake Street Junior Public School'},
		{value: 'Blantyre Public School', text: 'Blantyre Public School'},
		{value: 'Blaydon Public School', text: 'Blaydon Public School'},
		{value: 'Bliss Carman Senior Public School', text: 'Bliss Carman Senior Public School'},
		{value: 'Bloor Collegiate Institute', text: 'Bloor Collegiate Institute'},
		{value: 'Bloordale Middle School', text: 'Bloordale Middle School'},
		{value: 'Bloorlea Middle School', text: 'Bloorlea Middle School'},
		{value: 'Blythwood Junior Public School', text: 'Blythwood Junior Public School'},
		{value: 'Bowmore Road Junior and Senior Public School', text: 'Bowmore Road Junior and Senior Public School'},
		{value: 'Braeburn Junior School', text: 'Braeburn Junior School'},
		{value: 'Brian Public School', text: 'Brian Public School'},
		{value: 'Briarcrest Junior School', text: 'Briarcrest Junior School'},
		{value: 'Bridlewood Junior Public School', text: 'Bridlewood Junior Public School'},
		{value: 'Brimwood Boulevard Junior Public School', text: 'Brimwood Boulevard Junior Public School'},
		{value: 'Broadacres Junior School', text: 'Broadacres Junior School'},
		{value: 'Broadlands Public School', text: 'Broadlands Public School'},
		{value: 'Brock Public School', text: 'Brock Public School'},
		{value: 'Brookhaven Public School', text: 'Brookhaven Public School'},
		{value: 'Brookmill Boulevard Junior Public School', text: 'Brookmill Boulevard Junior Public School'},
		{value: 'Brookside Public School', text: 'Brookside Public School'},
		{value: 'Brookview Middle School', text: 'Brookview Middle School'},
		{value: 'Brown Junior Public School', text: 'Brown Junior Public School'},
		{value: 'Bruce Public School', text: 'Bruce Public School'},
		{value: 'Buchanan Public School', text: 'Buchanan Public School'},
		{value: 'Burnhamthorpe Collegiate Institute', text: 'Burnhamthorpe Collegiate Institute'},
		{value: 'Burrows Hall Junior Public School', text: 'Burrows Hall Junior Public School'},
		{value: 'C D Farquharson Junior Public School', text: 'C D Farquharson Junior Public School'},
		{value: 'C R Marchant Middle School', text: 'C R Marchant Middle School'},
		{value: 'C W Jefferys Collegiate Institute', text: 'C W Jefferys Collegiate Institute'},
		{value: 'CALC Secondary School', text: 'CALC Secondary School'},
		{value: 'Calico Public School', text: 'Calico Public School'},
		{value: 'Cameron Public School', text: 'Cameron Public School'},
		{value: 'Caring and Safe School LC1', text: 'Caring and Safe School LC1'},
		{value: 'Caring and Safe School LC2', text: 'Caring and Safe School LC2'},
		{value: 'Caring and Safe School LC3', text: 'Caring and Safe School LC3'},
		{value: 'Caring and Safe School LC4', text: 'Caring and Safe School LC4'},
		{value: 'Carleton Village Junior and Senior Sports and Wellness Academy', text: 'Carleton Village Junior and Senior Sports and Wellness Academy'},
		{value: 'Cassandra Public School', text: 'Cassandra Public School'},
		{value: 'Castlebar Junior School', text: 'Castlebar Junior School'},
		{value: 'Cedar Drive Junior Public School', text: 'Cedar Drive Junior Public School'},
		{value: 'Cedarbrae Collegiate Institute', text: 'Cedarbrae Collegiate Institute'},
		{value: 'Cedarbrook Public School', text: 'Cedarbrook Public School'},
		{value: 'Cedarvale Community School', text: 'Cedarvale Community School'},
		{value: 'Centennial Road Junior Public School', text: 'Centennial Road Junior Public School'},
		{value: 'Central Etobicoke High School', text: 'Central Etobicoke High School'},
		{value: 'Central Technical School', text: 'Central Technical School'},
		{value: 'Central Toronto Academy', text: 'Central Toronto Academy'},
		{value: 'Chalkfarm Public School', text: 'Chalkfarm Public School'},
		{value: 'Charles E Webster Public School', text: 'Charles E Webster Public School'},
		{value: 'Charles G Fraser Junior Public School', text: 'Charles G Fraser Junior Public School'},
		{value: 'Charles Gordon Senior Public School', text: 'Charles Gordon Senior Public School'},
		{value: 'Charles H Best Junior Middle School', text: 'Charles H Best Junior Middle School'},
		{value: 'Charlottetown Junior Public School', text: 'Charlottetown Junior Public School'},
		{value: 'Chartland Junior Public School', text: 'Chartland Junior Public School'},
		{value: 'Cherokee Public School', text: 'Cherokee Public School'},
		{value: 'Chester Elementary School', text: 'Chester Elementary School'},
		{value: 'Chester Le Junior Public School', text: 'Chester Le Junior Public School'},
		{value: 'Chief Dan George Public School', text: 'Chief Dan George Public School'},
		{value: 'Chine Drive Public School', text: 'Chine Drive Public School'},
		{value: 'Church Street Junior Public School', text: 'Church Street Junior Public School'},
		{value: 'Churchill Heights Public School', text: 'Churchill Heights Public School'},
		{value: 'Churchill Public School', text: 'Churchill Public School'},
		{value: 'City School', text: 'City School'},
		{value: 'City View Alternative Senior School', text: 'City View Alternative Senior School'},
		{value: 'Claireville Junior School', text: 'Claireville Junior School'},
		{value: 'Clairlea Public School', text: 'Clairlea Public School'},
		{value: 'Claude Watson School for the Arts', text: 'Claude Watson School for the Arts'},
		{value: 'Cliffside Public School', text: 'Cliffside Public School'},
		{value: 'Cliffwood Public School', text: 'Cliffwood Public School'},
		{value: 'Clinton Street Junior Public School', text: 'Clinton Street Junior Public School'},
		{value: 'Contact Alternative School', text: 'Contact Alternative School'},
		{value: 'Cordella Junior Public School', text: 'Cordella Junior Public School'},
		{value: 'Cornell Junior Public School', text: 'Cornell Junior Public School'},
		{value: 'Corvette Junior Public School', text: 'Corvette Junior Public School'},
		{value: 'Cosburn Middle School', text: 'Cosburn Middle School'},
		{value: 'Cottingham Junior Public School', text: 'Cottingham Junior Public School'},
		{value: 'Courcelette Public School', text: 'Courcelette Public School'},
		{value: 'Crescent Town Elementary School', text: 'Crescent Town Elementary School'},
		{value: 'Cresthaven Public School', text: 'Cresthaven Public School'},
		{value: 'Crestview Public School', text: 'Crestview Public School'},
		{value: 'Cummer Valley Middle School', text: 'Cummer Valley Middle School'},
		{value: 'D A Morrison Middle School', text: 'D A Morrison Middle School'},
		{value: 'da Vinci School', text: 'da Vinci School'},
		{value: 'Dallington Public School', text: 'Dallington Public School'},
		{value: 'Danforth Collegiate and Technical Institute', text: 'Danforth Collegiate and Technical Institute'},
		{value: 'Danforth Gardens Public School', text: 'Danforth Gardens Public School'},
		{value: 'David and Mary Thomson Collegiate Institute', text: 'David and Mary Thomson Collegiate Institute'},
		{value: 'David Hornell Junior School', text: 'David Hornell Junior School'},
		{value: 'David Lewis Public School', text: 'David Lewis Public School'},
		{value: 'Davisville Junior Public School', text: 'Davisville Junior Public School'},
		{value: 'Daystrom Public School', text: 'Daystrom Public School'},
		{value: 'Deer Park Junior and Senior Public School', text: 'Deer Park Junior and Senior Public School'},
		{value: 'Delphi Secondary Alternative School', text: 'Delphi Secondary Alternative School'},
		{value: 'Delta Alternative Senior School', text: 'Delta Alternative Senior School'},
		{value: 'Denlow Public School', text: 'Denlow Public School'},
		{value: 'Dennis Avenue Community School', text: 'Dennis Avenue Community School'},
		{value: 'Derrydown Public School', text: 'Derrydown Public School'},
		{value: 'Dewson Street Junior Public School', text: 'Dewson Street Junior Public School'},
		{value: 'Diefenbaker Elementary School', text: 'Diefenbaker Elementary School'},
		{value: 'Dixon Grove Junior Middle School', text: 'Dixon Grove Junior Middle School'},
		{value: 'Don Mills Collegiate Institute', text: 'Don Mills Collegiate Institute'},
		{value: 'Don Mills Middle School', text: 'Don Mills Middle School'},
		{value: 'Don Valley Middle School', text: 'Don Valley Middle School'},
		{value: 'Donview Middle Health and Wellness Academy', text: 'Donview Middle Health and Wellness Academy'},
		{value: 'Donwood Park Public School', text: 'Donwood Park Public School'},
		{value: 'Dorset Park Public School', text: 'Dorset Park Public School'},
		{value: 'Dovercourt Public School', text: 'Dovercourt Public School'},
		{value: 'Downsview Public School', text: 'Downsview Public School'},
		{value: 'Downsview Secondary School', text: 'Downsview Secondary School'},
		{value: 'Downtown Alternative School', text: 'Downtown Alternative School'},
		{value: 'Downtown Vocal Music Academy of Toronto', text: 'Downtown Vocal Music Academy of Toronto'},
		{value: 'Dr Marion Hilliard Senior Public School', text: 'Dr Marion Hilliard Senior Public School'},
		{value: 'Dr Norman Bethune Collegiate Institute', text: 'Dr Norman Bethune Collegiate Institute'},
		{value: 'Drewry Secondary School', text: 'Drewry Secondary School'},
		{value: 'Driftwood Public School', text: 'Driftwood Public School'},
		{value: 'Dublin Heights Elementary and Middle School', text: 'Dublin Heights Elementary and Middle School'},
		{value: 'Duke of Connaught Junior and Senior Public School', text: 'Duke of Connaught Junior and Senior Public School'},
		{value: 'Dundas Junior Public School', text: 'Dundas Junior Public School'},
		{value: 'Dunlace Public School', text: 'Dunlace Public School'},
		{value: 'Earl Beatty Junior and Senior Public School', text: 'Earl Beatty Junior and Senior Public School'},
		{value: 'Earl Grey Senior Public School', text: 'Earl Grey Senior Public School'},
		{value: 'Earl Haig Public School', text: 'Earl Haig Public School'},
		{value: 'Earl Haig Secondary School', text: 'Earl Haig Secondary School'},
		{value: 'East Alternative School of Toronto', text: 'East Alternative School of Toronto'},
		{value: 'East York Alternative Secondary School', text: 'East York Alternative Secondary School'},
		{value: 'East York Collegiate Institute', text: 'East York Collegiate Institute'},
		{value: 'Eastdale Collegiate Institute', text: 'Eastdale Collegiate Institute'},
		{value: 'Eastview Public School', text: 'Eastview Public School'},
		{value: 'Eatonville Junior School', text: 'Eatonville Junior School'},
		{value: 'Edgewood Public School', text: 'Edgewood Public School'},
		{value: 'Eglinton Junior Public School', text: 'Eglinton Junior Public School'},
		{value: 'Elia Middle School', text: 'Elia Middle School'},
		{value: 'Elizabeth Simcoe Junior Public School', text: 'Elizabeth Simcoe Junior Public School'},
		{value: 'Elkhorn Public School', text: 'Elkhorn Public School'},
		{value: 'Ellesmere-Statton Public School', text: 'Ellesmere-Statton Public School'},
		{value: 'Elmbank Junior Middle Academy', text: 'Elmbank Junior Middle Academy'},
		{value: 'Elmlea Junior School', text: 'Elmlea Junior School'},
		{value: 'Emery Collegiate Institute', text: 'Emery Collegiate Institute'},
		{value: 'Emery EdVance Secondary School', text: 'Emery EdVance Secondary School'},
		{value: 'Emily Carr Public School', text: 'Emily Carr Public School'},
		{value: 'Equinox Holistic Alternative School', text: 'Equinox Holistic Alternative School'},
		{value: 'Ernest Public School', text: 'Ernest Public School'},
		{value: 'Essex Junior and Senior Public School', text: 'Essex Junior and Senior Public School'},
		{value: 'Étienne Brûlé Junior School', text: 'Étienne Brûlé Junior School'},
		{value: 'Etobicoke Collegiate Institute', text: 'Etobicoke Collegiate Institute'},
		{value: 'Etobicoke School of the Arts', text: 'Etobicoke School of the Arts'},
		{value: 'Etobicoke Year Round Alternative Centre', text: 'Etobicoke Year Round Alternative Centre'},
		{value: 'F H Miller Junior Public School', text: 'F H Miller Junior Public School'},
		{value: 'Fairbank Memorial Community School', text: 'Fairbank Memorial Community School'},
		{value: 'Fairbank Public School', text: 'Fairbank Public School'},
		{value: 'Fairglen Junior Public School', text: 'Fairglen Junior Public School'},
		{value: 'Fairmount Public School', text: 'Fairmount Public School'},
		{value: 'Faywood Arts-Based Curriculum School', text: 'Faywood Arts-Based Curriculum School'},
		{value: 'Fenside Public School', text: 'Fenside Public School'},
		{value: 'Fern Avenue Junior and Senior Public School', text: 'Fern Avenue Junior and Senior Public School'},
		{value: 'Finch Public School', text: 'Finch Public School'},
		{value: 'Firgrove Public School', text: 'Firgrove Public School'},
		{value: 'Fisherville Senior Public School', text: 'Fisherville Senior Public School'},
		{value: 'Fleming Public School', text: 'Fleming Public School'},
		{value: 'Flemington Public School', text: 'Flemington Public School'},
		{value: 'Forest Hill Collegiate Institute', text: 'Forest Hill Collegiate Institute'},
		{value: 'Forest Hill Junior and Senior Public School', text: 'Forest Hill Junior and Senior Public School'},
		{value: 'Forest Manor Public School', text: 'Forest Manor Public School'},
		{value: 'Frank Oke Secondary School', text: 'Frank Oke Secondary School'},
		{value: 'Frankland Community School', text: 'Frankland Community School'},
		{value: 'Fraser Mustard Early Learning Academy', text: 'Fraser Mustard Early Learning Academy'},
		{value: 'Galloway Road Public School', text: 'Galloway Road Public School'},
		{value: 'Garden Avenue Junior Public School', text: 'Garden Avenue Junior Public School'},
		{value: 'Gateway Public School', text: 'Gateway Public School'},
		{value: 'General Brock Public School', text: 'General Brock Public School'},
		{value: 'General Crerar Public School', text: 'General Crerar Public School'},
		{value: 'General Mercer Junior Public School', text: 'General Mercer Junior Public School'},
		{value: 'George Anderson Public School', text: 'George Anderson Public School'},
		{value: 'George B Little Public School', text: 'George B Little Public School'},
		{value: 'George Harvey Collegiate Institute', text: 'George Harvey Collegiate Institute'},
		{value: 'George P Mackie Junior Public School', text: 'George P Mackie Junior Public School'},
		{value: 'George Peck Public School', text: 'George Peck Public School'},
		{value: 'George R Gauld Junior School', text: 'George R Gauld Junior School'},
		{value: 'George S Henry Academy', text: 'George S Henry Academy'},
		{value: 'George Syme Community School', text: 'George Syme Community School'},
		{value: 'George Webster Elementary School', text: 'George Webster Elementary School'},
		{value: 'Georges Vanier Secondary School', text: 'Georges Vanier Secondary School'},
		{value: 'Givins/Shaw Junior Public School', text: 'Givins/Shaw Junior Public School'},
		{value: 'Glamorgan Junior Public School', text: 'Glamorgan Junior Public School'},
		{value: 'Gledhill Junior Public School', text: 'Gledhill Junior Public School'},
		{value: 'Glen Ames Senior Public School', text: 'Glen Ames Senior Public School'},
		{value: 'Glen Park Public School', text: 'Glen Park Public School'},
		{value: 'Glen Ravine Junior Public School', text: 'Glen Ravine Junior Public School'},
		{value: 'Glenview Senior Public School', text: 'Glenview Senior Public School'},
		{value: 'Golf Road Junior Public School', text: 'Golf Road Junior Public School'},
		{value: 'Gordon A Brown Middle School', text: 'Gordon A Brown Middle School'},
		{value: 'Gosford Public School', text: 'Gosford Public School'},
		{value: 'Gracedale Public School', text: 'Gracedale Public School'},
		{value: 'Gracefield Public School', text: 'Gracefield Public School'},
		{value: 'Greenholme Junior Middle School', text: 'Greenholme Junior Middle School'},
		{value: 'Greenland Public School', text: 'Greenland Public School'},
		{value: 'Greenwood Secondary School', text: 'Greenwood Secondary School'},
		{value: 'Grenoble Public School', text: 'Grenoble Public School'},
		{value: 'Grey Owl Junior Public School', text: 'Grey Owl Junior Public School'},
		{value: 'Guildwood Junior Public School', text: 'Guildwood Junior Public School'},
		{value: 'Gulfstream Public School', text: 'Gulfstream Public School'},
		{value: 'H A Halbert Junior Public School', text: 'H A Halbert Junior Public School'},
		{value: 'H J Alexander Community School', text: 'H J Alexander Community School'},
		{value: 'Harbord Collegiate Institute', text: 'Harbord Collegiate Institute'},
		{value: 'Harrison Public School', text: 'Harrison Public School'},
		{value: 'Harwood Public School', text: 'Harwood Public School'},
		{value: 'Hawthorne II Bilingual Alternative Junior School', text: 'Hawthorne II Bilingual Alternative Junior School'},
		{value: 'Heather Heights Junior Public School', text: 'Heather Heights Junior Public School'},
		{value: 'Henry Hudson Senior Public School', text: 'Henry Hudson Senior Public School'},
		{value: 'Henry Kelsey Senior Public School', text: 'Henry Kelsey Senior Public School'},
		{value: 'Heritage Park Public School', text: 'Heritage Park Public School'},
		{value: 'Heydon Park Secondary School', text: 'Heydon Park Secondary School'},
		{value: 'High Park Alternative Junior School', text: 'High Park Alternative Junior School'},
		{value: 'Highcastle Public School', text: 'Highcastle Public School'},
		{value: 'Highfield Junior School', text: 'Highfield Junior School'},
		{value: 'Highland Creek Public School', text: 'Highland Creek Public School'},
		{value: 'Highland Heights Junior Public School', text: 'Highland Heights Junior Public School'},
		{value: 'Highland Middle School', text: 'Highland Middle School'},
		{value: 'Highview Public School', text: 'Highview Public School'},
		{value: 'Hillcrest Community School', text: 'Hillcrest Community School'},
		{value: 'Hillmount Public School', text: 'Hillmount Public School'},
		{value: 'Hilltop Middle School', text: 'Hilltop Middle School'},
		{value: 'Hodgson Middle School', text: 'Hodgson Middle School'},
		{value: 'Hollycrest Middle School', text: 'Hollycrest Middle School'},
		{value: 'Hollywood Public School', text: 'Hollywood Public School'},
		{value: 'Horizon Alternative Senior School', text: 'Horizon Alternative Senior School'},
		{value: 'Howard Junior Public School', text: 'Howard Junior Public School'},
		{value: 'Humber Summit Middle School', text: 'Humber Summit Middle School'},
		{value: 'Humber Valley Village Junior Middle School', text: 'Humber Valley Village Junior Middle School'},
		{value: 'Humbercrest Public School', text: 'Humbercrest Public School'},
		{value: 'Humberside Collegiate Institute', text: 'Humberside Collegiate Institute'},
		{value: 'Humberwood Downs Junior Middle Academy', text: 'Humberwood Downs Junior Middle Academy'},
		{value: 'Humewood Community School', text: 'Humewood Community School'},
		{value: 'Hunter\'s Glen Junior Public School', text: 'Hunter\'s Glen Junior Public School'},
		{value: 'Huron Street Junior Public School', text: 'Huron Street Junior Public School'},
		{value: 'Indian Road Crescent Junior Public School', text: 'Indian Road Crescent Junior Public School'},
		{value: 'Inglenook Community School', text: 'Inglenook Community School'},
		{value: 'Inglewood Heights Junior Public School', text: 'Inglewood Heights Junior Public School'},
		{value: 'Ionview Public School', text: 'Ionview Public School'},
		{value: 'Iroquois Junior Public School', text: 'Iroquois Junior Public School'},
		{value: 'Island Public/Natural Science School', text: 'Island Public/Natural Science School'},
		{value: 'Islington Junior Middle School', text: 'Islington Junior Middle School'},
		{value: 'J B Tyrrell Senior Public School', text: 'J B Tyrrell Senior Public School'},
		{value: 'J G Workman Public School', text: 'J G Workman Public School'},
		{value: 'J R Wilcox Community School', text: 'J R Wilcox Community School'},
		{value: 'Jack Miner Senior Public School', text: 'Jack Miner Senior Public School'},
		{value: 'Jackman Avenue Junior Public School', text: 'Jackman Avenue Junior Public School'},
		{value: 'James S Bell Junior Middle Sports and Wellness Academy', text: 'James S Bell Junior Middle Sports and Wellness Academy'},
		{value: 'Jarvis Collegiate Institute', text: 'Jarvis Collegiate Institute'},
		{value: 'Jean Lumb Public School', text: 'Jean Lumb Public School'},
		{value: 'Jesse Ketchum Junior and Senior Public School', text: 'Jesse Ketchum Junior and Senior Public School'},
		{value: 'John A Leslie Public School', text: 'John A Leslie Public School'},
		{value: 'John Buchan Senior Public School', text: 'John Buchan Senior Public School'},
		{value: 'John D Parker Junior School', text: 'John D Parker Junior School'},
		{value: 'John English Junior Middle School', text: 'John English Junior Middle School'},
		{value: 'John Fisher Junior Public School', text: 'John Fisher Junior Public School'},
		{value: 'John G Althouse Middle School', text: 'John G Althouse Middle School'},
		{value: 'John G Diefenbaker Public School', text: 'John G Diefenbaker Public School'},
		{value: 'John McCrae Public School', text: 'John McCrae Public School'},
		{value: 'John Polanyi Collegiate Institute', text: 'John Polanyi Collegiate Institute'},
		{value: 'John Ross Robertson Junior Public School', text: 'John Ross Robertson Junior Public School'},
		{value: 'John Wanless Junior Public School', text: 'John Wanless Junior Public School'},
		{value: 'Joseph Brant Public School', text: 'Joseph Brant Public School'},
		{value: 'Joseph Howe Senior Public School', text: 'Joseph Howe Senior Public School'},
		{value: 'Joyce Public School', text: 'Joyce Public School'},
		{value: 'Kapapamahchakwew - Wandering Spirit School (Elementary)', text: 'Kapapamahchakwew - Wandering Spirit School (Elementary)'},
		{value: 'Kapapamahchakwew - Wandering Spirit School (Secondary)', text: 'Kapapamahchakwew - Wandering Spirit School (Secondary)'},
		{value: 'Karen Kain School of the Arts', text: 'Karen Kain School of the Arts'},
		{value: 'Keele Street Public School', text: 'Keele Street Public School'},
		{value: 'Keelesdale Junior Public School', text: 'Keelesdale Junior Public School'},
		{value: 'Kennedy Public School', text: 'Kennedy Public School'},
		{value: 'Kensington Community School', text: 'Kensington Community School'},
		{value: 'Kew Beach Junior Public School', text: 'Kew Beach Junior Public School'},
		{value: 'Kimberley Junior Public School', text: 'Kimberley Junior Public School'},
		{value: 'King Edward Junior and Senior Public School', text: 'King Edward Junior and Senior Public School'},
		{value: 'King George Junior Public School', text: 'King George Junior Public School'},
		{value: 'Kingslake Public School', text: 'Kingslake Public School'},
		{value: 'Kingsview Village Junior School', text: 'Kingsview Village Junior School'},
		{value: 'Kipling Collegiate Institute', text: 'Kipling Collegiate Institute'},
		{value: 'Knob Hill Public School', text: 'Knob Hill Public School'},
		{value: 'L\'Amoreaux Collegiate Institute', text: 'L\'Amoreaux Collegiate Institute'},
		{value: 'Lakeshore Collegiate Institute', text: 'Lakeshore Collegiate Institute'},
		{value: 'Lamberton Public School', text: 'Lamberton Public School'},
		{value: 'Lambton Park Community School', text: 'Lambton Park Community School'},
		{value: 'Lambton-Kingsway Junior Middle School', text: 'Lambton-Kingsway Junior Middle School'},
		{value: 'Lanor Junior Middle School', text: 'Lanor Junior Middle School'},
		{value: 'Lawrence Heights Middle School', text: 'Lawrence Heights Middle School'},
		{value: 'Lawrence Park Collegiate Institute', text: 'Lawrence Park Collegiate Institute'},
		{value: 'Leaside High School', text: 'Leaside High School'},
		{value: 'Ledbury Park Elementary and Middle School', text: 'Ledbury Park Elementary and Middle School'},
		{value: 'Lescon Public School', text: 'Lescon Public School'},
		{value: 'Leslieville Junior Public School', text: 'Leslieville Junior Public School'},
		{value: 'Lester B Pearson Collegiate Institute', text: 'Lester B Pearson Collegiate Institute'},
		{value: 'Lester B Pearson Elementary School', text: 'Lester B Pearson Elementary School'},
		{value: 'Lillian Public School', text: 'Lillian Public School'},
		{value: 'Lord Dufferin Junior and Senior Public School', text: 'Lord Dufferin Junior and Senior Public School'},
		{value: 'Lord Lansdowne Junior Public School', text: 'Lord Lansdowne Junior Public School'},
		{value: 'Lord Roberts Junior Public School', text: 'Lord Roberts Junior Public School'},
		{value: 'Lucy Maud Montgomery Public School', text: 'Lucy Maud Montgomery Public School'},
		{value: 'Lucy McCormick Senior School', text: 'Lucy McCormick Senior School'},
		{value: 'Lynngate Junior Public School', text: 'Lynngate Junior Public School'},
		{value: 'Lynnwood Heights Junior Public School', text: 'Lynnwood Heights Junior Public School'},
		{value: 'Macklin Public School', text: 'Macklin Public School'},
		{value: 'Malvern Collegiate Institute', text: 'Malvern Collegiate Institute'},
		{value: 'Malvern Junior Public School', text: 'Malvern Junior Public School'},
		{value: 'Manhattan Park Junior Public School', text: 'Manhattan Park Junior Public School'},
		{value: 'Maple Leaf Public School', text: 'Maple Leaf Public School'},
		{value: 'Maplewood High School', text: 'Maplewood High School'},
		{value: 'Marc Garneau Collegiate Institute', text: 'Marc Garneau Collegiate Institute'},
		{value: 'Market Lane Junior and Senior Public School', text: 'Market Lane Junior and Senior Public School'},
		{value: 'Martingrove Collegiate Institute', text: 'Martingrove Collegiate Institute'},
		{value: 'Mary Shadd Public School', text: 'Mary Shadd Public School'},
		{value: 'Maryvale Public School', text: 'Maryvale Public School'},
		{value: 'Mason Road Junior Public School', text: 'Mason Road Junior Public School'},
		{value: 'Maurice Cody Junior Public School', text: 'Maurice Cody Junior Public School'},
		{value: 'McKee Public School', text: 'McKee Public School'},
		{value: 'McMurrich Junior Public School', text: 'McMurrich Junior Public School'},
		{value: 'Meadowvale Public School', text: 'Meadowvale Public School'},
		{value: 'Melody Village Junior School', text: 'Melody Village Junior School'},
		{value: 'Military Trail Public School', text: 'Military Trail Public School'},
		{value: 'Mill Valley Junior School', text: 'Mill Valley Junior School'},
		{value: 'Milliken Public School', text: 'Milliken Public School'},
		{value: 'Millwood Junior School', text: 'Millwood Junior School'},
		{value: 'Milne Valley Middle School', text: 'Milne Valley Middle School'},
		{value: 'Monarch Park Collegiate Institute', text: 'Monarch Park Collegiate Institute'},
		{value: 'Montrose Junior Public School', text: 'Montrose Junior Public School'},
		{value: 'Morrish Public School', text: 'Morrish Public School'},
		{value: 'Morse Street Junior Public School', text: 'Morse Street Junior Public School'},
		{value: 'Mountview Alternative School', text: 'Mountview Alternative School'},
		{value: 'Muirhead Public School', text: 'Muirhead Public School'},
		{value: 'Native Learning Centre East', text: 'Native Learning Centre East'},
		{value: 'Native Learning Centre', text: 'Native Learning Centre'},
		{value: 'Nelson Mandela Park Public School', text: 'Nelson Mandela Park Public School'},
		{value: 'Newtonbrook Secondary School', text: 'Newtonbrook Secondary School'},
		{value: 'Niagara Street Junior Public School', text: 'Niagara Street Junior Public School'},
		{value: 'Norman Cook Junior Public School', text: 'Norman Cook Junior Public School'},
		{value: 'Norman Ingram Public School', text: 'Norman Ingram Public School'},
		{value: 'Norseman Junior Middle School', text: 'Norseman Junior Middle School'},
		{value: 'North Agincourt Junior Public School', text: 'North Agincourt Junior Public School'},
		{value: 'North Albion Collegiate Institute', text: 'North Albion Collegiate Institute'},
		{value: 'North Bendale Junior Public School', text: 'North Bendale Junior Public School'},
		{value: 'North Bridlewood Junior Public School', text: 'North Bridlewood Junior Public School'},
		{value: 'North East Year Round Alternative Centre', text: 'North East Year Round Alternative Centre'},
		{value: 'North Kipling Junior Middle School', text: 'North Kipling Junior Middle School'},
		{value: 'North Preparatory Junior Public School', text: 'North Preparatory Junior Public School'},
		{value: 'North Toronto Collegiate Institute', text: 'North Toronto Collegiate Institute'},
		{value: 'North West Year Round Alternative Centre', text: 'North West Year Round Alternative Centre'},
		{value: 'Northern Secondary School', text: 'Northern Secondary School'},
		{value: 'Northlea Elementary and Middle School', text: 'Northlea Elementary and Middle School'},
		{value: 'Northview Heights Secondary School', text: 'Northview Heights Secondary School'},
		{value: 'Norway Junior Public School', text: 'Norway Junior Public School'},
		{value: 'O\'Connor Public School', text: 'O\'Connor Public School'},
		{value: 'Oakdale Park Middle School', text: 'Oakdale Park Middle School'},
		{value: 'Oakridge Junior Public School', text: 'Oakridge Junior Public School'},
		{value: 'Oakwood Collegiate Institute', text: 'Oakwood Collegiate Institute'},
		{value: 'Oasis Alternative Secondary School', text: 'Oasis Alternative Secondary School'},
		{value: 'Ogden Junior Public School', text: 'Ogden Junior Public School'},
		{value: 'Orde Street Public School', text: 'Orde Street Public School'},
		{value: 'Oriole Park Junior Public School', text: 'Oriole Park Junior Public School'},
		{value: 'Ossington/Old Orchard Junior Public School', text: 'Ossington/Old Orchard Junior Public School'},
		{value: 'Owen Public School', text: 'Owen Public School'},
		{value: 'Palmerston Avenue Junior Public School', text: 'Palmerston Avenue Junior Public School'},
		{value: 'Pape Avenue Junior Public School', text: 'Pape Avenue Junior Public School'},
		{value: 'Park Lane Public School', text: 'Park Lane Public School'},
		{value: 'Park Lawn Junior Middle School', text: 'Park Lawn Junior Middle School'},
		{value: 'Parkdale Collegiate Institute', text: 'Parkdale Collegiate Institute'},
		{value: 'Parkdale Junior and Senior Public School', text: 'Parkdale Junior and Senior Public School'},
		{value: 'Parkfield Junior School', text: 'Parkfield Junior School'},
		{value: 'Parkside Elementary School', text: 'Parkside Elementary School'},
		{value: 'Parkview Alternative School', text: 'Parkview Alternative School'},
		{value: 'Pauline Johnson Junior Public School', text: 'Pauline Johnson Junior Public School'},
		{value: 'Pauline Junior Public School', text: 'Pauline Junior Public School'},
		{value: 'Pelmo Park Public School', text: 'Pelmo Park Public School'},
		{value: 'Percy Williams Junior Public School', text: 'Percy Williams Junior Public School'},
		{value: 'Perth Avenue Junior Public School', text: 'Perth Avenue Junior Public School'},
		{value: 'Pierre Laporte Middle School', text: 'Pierre Laporte Middle School'},
		{value: 'Pineway Public School', text: 'Pineway Public School'},
		{value: 'Pleasant Public School', text: 'Pleasant Public School'},
		{value: 'Pleasant View Middle School', text: 'Pleasant View Middle School'},
		{value: 'Poplar Road Junior Public School', text: 'Poplar Road Junior Public School'},
		{value: 'Port Royal Public School', text: 'Port Royal Public School'},
		{value: 'Portage Trail Community School', text: 'Portage Trail Community School'},
		{value: 'Presteign Heights Elementary School', text: 'Presteign Heights Elementary School'},
		{value: 'Princess Margaret Junior School', text: 'Princess Margaret Junior School'},
		{value: 'Queen Alexandra Middle School', text: 'Queen Alexandra Middle School'},
		{value: 'Queen Victoria Public School', text: 'Queen Victoria Public School'},
		{value: 'Quest Alternative Senior School', text: 'Quest Alternative Senior School'},
		{value: 'R H King Academy', text: 'R H King Academy'},
		{value: 'R H McGregor Elementary School', text: 'R H McGregor Elementary School'},
		{value: 'R J Lang Elementary and Middle School', text: 'R J Lang Elementary and Middle School'},
		{value: 'Ranchdale Public School', text: 'Ranchdale Public School'},
		{value: 'Rawlinson Community School', text: 'Rawlinson Community School'},
		{value: 'Regal Road Junior Public School', text: 'Regal Road Junior Public School'},
		{value: 'Regent Heights Public School', text: 'Regent Heights Public School'},
		{value: 'Rene Gordon Health and Wellness Academy', text: 'Rene Gordon Health and Wellness Academy'},
		{value: 'Richview Collegiate Institute', text: 'Richview Collegiate Institute'},
		{value: 'Rippleton Public School', text: 'Rippleton Public School'},
		{value: 'Rivercrest Junior School', text: 'Rivercrest Junior School'},
		{value: 'Riverdale Collegiate Institute', text: 'Riverdale Collegiate Institute'},
		{value: 'Robert Service Senior Public School', text: 'Robert Service Senior Public School'},
		{value: 'Rockcliffe Middle School', text: 'Rockcliffe Middle School'},
		{value: 'Rockford Public School', text: 'Rockford Public School'},
		{value: 'Roden Public School', text: 'Roden Public School'},
		{value: 'Rolph Road Elementary School', text: 'Rolph Road Elementary School'},
		{value: 'Rose Avenue Junior Public School', text: 'Rose Avenue Junior Public School'},
		{value: 'Rosedale Heights School of the Arts', text: 'Rosedale Heights School of the Arts'},
		{value: 'Rosedale Junior Public School', text: 'Rosedale Junior Public School'},
		{value: 'Roselands Junior Public School', text: 'Roselands Junior Public School'},
		{value: 'Rosethorn Junior School', text: 'Rosethorn Junior School'},
		{value: 'Rouge Valley Public School', text: 'Rouge Valley Public School'},
		{value: 'Roywood Public School', text: 'Roywood Public School'},
		{value: 'Runnymede Collegiate Institute', text: 'Runnymede Collegiate Institute'},
		{value: 'Runnymede Junior and Senior Public School', text: 'Runnymede Junior and Senior Public School'},
		{value: 'Ryerson Community School', text: 'Ryerson Community School'},
		{value: 'Samuel Hearne Middle School', text: 'Samuel Hearne Middle School'},
		{value: 'SATEC @ WA Porter Collegiate Institute', text: 'SATEC @ WA Porter Collegiate Institute'},
		{value: 'Scarborough Centre for Alternative Studies', text: 'Scarborough Centre for Alternative Studies'},
		{value: 'Scarborough Village Public School', text: 'Scarborough Village Public School'},
		{value: 'School of Experiential Education', text: 'School of Experiential Education'},
		{value: 'School of Life Experience', text: 'School of Life Experience'},
		{value: 'Second Street Junior Middle School', text: 'Second Street Junior Middle School'},
		{value: 'Secord Elementary School', text: 'Secord Elementary School'},
		{value: 'SEED Alternative School', text: 'SEED Alternative School'},
		{value: 'Selwyn Elementary School', text: 'Selwyn Elementary School'},
		{value: 'Seneca Hill Public School', text: 'Seneca Hill Public School'},
		{value: 'Seneca School', text: 'Seneca School'},
		{value: 'Seventh Street Junior School', text: 'Seventh Street Junior School'},
		{value: 'Shaughnessy Public School', text: 'Shaughnessy Public School'},
		{value: 'Sheppard Public School', text: 'Sheppard Public School'},
		{value: 'Shirley Street Junior Public School', text: 'Shirley Street Junior Public School'},
		{value: 'Shoreham Public Sports and Wellness Academy', text: 'Shoreham Public Sports and Wellness Academy'},
		{value: 'Silver Springs Public School', text: 'Silver Springs Public School'},
		{value: 'Silverthorn Collegiate Institute', text: 'Silverthorn Collegiate Institute'},
		{value: 'Silverthorn Community School', text: 'Silverthorn Community School'},
		{value: 'Sir Adam Beck Junior School', text: 'Sir Adam Beck Junior School'},
		{value: 'Sir Alexander Mackenzie Senior Public School', text: 'Sir Alexander Mackenzie Senior Public School'},
		{value: 'Sir Ernest MacMillan Senior Public School', text: 'Sir Ernest MacMillan Senior Public School'},
		{value: 'Sir John A Macdonald Collegiate Institute', text: 'Sir John A Macdonald Collegiate Institute'},
		{value: 'Sir Oliver Mowat Collegiate Institute', text: 'Sir Oliver Mowat Collegiate Institute'},
		{value: 'Sir Samuel B Steele Junior Public School', text: 'Sir Samuel B Steele Junior Public School'},
		{value: 'Sir Wilfrid Laurier Collegiate Institute', text: 'Sir Wilfrid Laurier Collegiate Institute'},
		{value: 'Sir William Osler High School', text: 'Sir William Osler High School'},
		{value: 'Sloane Public School', text: 'Sloane Public School'},
		{value: 'Smithfield Middle School', text: 'Smithfield Middle School'},
		{value: 'South East Year Round Alternative Centre', text: 'South East Year Round Alternative Centre'},
		{value: 'Spectrum Alternative Senior School', text: 'Spectrum Alternative Senior School'},
		{value: 'Sprucecourt Public School', text: 'Sprucecourt Public School'},
		{value: 'St Andrew\'s Middle School', text: 'St Andrew\'s Middle School'},
		{value: 'St Andrews Public School', text: 'St Andrews Public School'},
		{value: 'St George\'s Junior School', text: 'St George\'s Junior School'},
		{value: 'St Margaret\'s Public School', text: 'St Margaret\'s Public School'},
		{value: 'Stanley Public School', text: 'Stanley Public School'},
		{value: 'Steelesview Public School', text: 'Steelesview Public School'},
		{value: 'Stephen Leacock Collegiate Institute', text: 'Stephen Leacock Collegiate Institute'},
		{value: 'Stilecroft Public School', text: 'Stilecroft Public School'},
		{value: 'Subway Academy I', text: 'Subway Academy I'},
		{value: 'Subway Academy II', text: 'Subway Academy II'},
		{value: 'Summit Heights Public School', text: 'Summit Heights Public School'},
		{value: 'Sunny View Junior and Senior Public School', text: 'Sunny View Junior and Senior Public School'},
		{value: 'Sunnylea Junior School', text: 'Sunnylea Junior School'},
		{value: 'Swansea Junior and Senior Public School', text: 'Swansea Junior and Senior Public School'},
		{value: 'Tam O\'Shanter Junior Public School', text: 'Tam O\'Shanter Junior Public School'},
		{value: 'Taylor Creek Public School', text: 'Taylor Creek Public School'},
		{value: 'Tecumseh Senior Public School', text: 'Tecumseh Senior Public School'},
		{value: 'Terraview-Willowfield Public School', text: 'Terraview-Willowfield Public School'},
		{value: 'Terry Fox Public School', text: 'Terry Fox Public School'},
		{value: 'The Elms Junior Middle School', text: 'The Elms Junior Middle School'},
		{value: 'The Grove Community School', text: 'The Grove Community School'},
		{value: 'The Waterfront School', text: 'The Waterfront School'},
		{value: 'THESTUDENTSCHOOL', text: 'THESTUDENTSCHOOL'},
		{value: 'Thistletown Collegiate Institute', text: 'Thistletown Collegiate Institute'},
		{value: 'Thomas L Wells Public School', text: 'Thomas L Wells Public School'},
		{value: 'Thorncliffe Park Public School', text: 'Thorncliffe Park Public School'},
		{value: 'Three Valleys Public School', text: 'Three Valleys Public School'},
		{value: 'Timberbank Junior Public School', text: 'Timberbank Junior Public School'},
		{value: 'Tom Longboat Junior Public School', text: 'Tom Longboat Junior Public School'},
		{value: 'Topcliff Public School', text: 'Topcliff Public School'},
		{value: 'Tredway Woodsworth Public School', text: 'Tredway Woodsworth Public School'},
		{value: 'Tumpane Public School', text: 'Tumpane Public School'},
		{value: 'Twentieth Street Junior School', text: 'Twentieth Street Junior School'},
		{value: 'Ursula Franklin Academy', text: 'Ursula Franklin Academy'},
		{value: 'Valley Park Middle School', text: 'Valley Park Middle School'},
		{value: 'Valleyfield Junior School', text: 'Valleyfield Junior School'},
		{value: 'Victoria Park Collegiate Institute', text: 'Victoria Park Collegiate Institute'},
		{value: 'Victoria Park Elementary School', text: 'Victoria Park Elementary School'},
		{value: 'Victoria Village Public School', text: 'Victoria Village Public School'},
		{value: 'Vradenburg Junior Public School', text: 'Vradenburg Junior Public School'},
		{value: 'Walter Perry Junior Public School', text: 'Walter Perry Junior Public School'},
		{value: 'Warren Park Junior Public School', text: 'Warren Park Junior Public School'},
		{value: 'Wedgewood Junior School', text: 'Wedgewood Junior School'},
		{value: 'Wellesworth Junior School', text: 'Wellesworth Junior School'},
		{value: 'West End Alternative School', text: 'West End Alternative School'},
		{value: 'West Glen Junior School', text: 'West Glen Junior School'},
		{value: 'West Hill Collegiate Institute', text: 'West Hill Collegiate Institute'},
		{value: 'West Hill Public School', text: 'West Hill Public School'},
		{value: 'West Humber Collegiate Institute', text: 'West Humber Collegiate Institute'},
		{value: 'West Humber Junior Middle School', text: 'West Humber Junior Middle School'},
		{value: 'West Preparatory Junior Public School', text: 'West Preparatory Junior Public School'},
		{value: 'West Rouge Junior Public School', text: 'West Rouge Junior Public School'},
		{value: 'Western Technical-Commercial School', text: 'Western Technical-Commercial School'},
		{value: 'Westmount Junior School', text: 'Westmount Junior School'},
		{value: 'Weston Collegiate Institute', text: 'Weston Collegiate Institute'},
		{value: 'Weston Memorial Junior Public School', text: 'Weston Memorial Junior Public School'},
		{value: 'Westview Centennial Secondary School', text: 'Westview Centennial Secondary School'},
		{value: 'Westway Junior School', text: 'Westway Junior School'},
		{value: 'Westwood Middle School', text: 'Westwood Middle School'},
		{value: 'Wexford Collegiate School for the Arts', text: 'Wexford Collegiate School for the Arts'},
		{value: 'Wexford Public School', text: 'Wexford Public School'},
		{value: 'White Haven Public School', text: 'White Haven Public School'},
		{value: 'Whitney Junior Public School', text: 'Whitney Junior Public School'},
		{value: 'Wilkinson Junior Public School', text: 'Wilkinson Junior Public School'},
		{value: 'William Burgess Elementary School', text: 'William Burgess Elementary School'},
		{value: 'William G Davis Junior Public School', text: 'William G Davis Junior Public School'},
		{value: 'William G Miller Public School', text: 'William G Miller Public School'},
		{value: 'William J McCordic School', text: 'William J McCordic School'},
		{value: 'William Lyon Mackenzie Collegiate Institute', text: 'William Lyon Mackenzie Collegiate Institute'},
		{value: 'Williamson Road Junior Public School', text: 'Williamson Road Junior Public School'},
		{value: 'Willow Park Junior Public School', text: 'Willow Park Junior Public School'},
		{value: 'Willowdale Middle School', text: 'Willowdale Middle School'},
		{value: 'Wilmington Elementary School', text: 'Wilmington Elementary School'},
		{value: 'Winchester Junior and Senior Public School', text: 'Winchester Junior and Senior Public School'},
		{value: 'Windfields Middle School', text: 'Windfields Middle School'},
		{value: 'Winona Drive Senior Public School', text: 'Winona Drive Senior Public School'},
		{value: 'Winston Churchill Collegiate Institute', text: 'Winston Churchill Collegiate Institute'},
		{value: 'Withrow Avenue Junior Public School', text: 'Withrow Avenue Junior Public School'},
		{value: 'Woburn Collegiate Institute', text: 'Woburn Collegiate Institute'},
		{value: 'Woburn Junior Public School', text: 'Woburn Junior Public School'},
		{value: 'Woodbine Middle School', text: 'Woodbine Middle School'},
		{value: 'York Humber High School', text: 'York Humber High School'},
		{value: 'York Memorial Collegiate Institute', text: 'York Memorial Collegiate Institute'},
		{value: 'York Mills Collegiate Institute', text: 'York Mills Collegiate Institute'},
		{value: 'Yorkdale Secondary School', text: 'Yorkdale Secondary School'},
		{value: 'Yorkview Public School', text: 'Yorkview Public School'},
		{value: 'Yorkwoods Public School', text: 'Yorkwoods Public School'},
		{value: 'Zion Heights Middle School', text: 'Zion Heights Middle School'},
    ],
    'Rockyview Schools': [
		{value: 'A.E. Bowers Elementary School', text: 'A.E. Bowers Elementary School'},
		{value: 'Bert Church High School', text: 'Bert Church High School'},
		{value: 'C.W. Perry School', text: 'C.W. Perry School'},
		{value: 'Cooper\'s Crossing School', text: 'Cooper\'s Crossing School'},
		{value: 'École Airdrie Middle School', text: 'École Airdrie Middle School'},
		{value: 'École Edwards Elementary School', text: 'École Edwards Elementary School'},
		{value: 'George McDougall High School', text: 'George McDougall High School'},
		{value: 'Heloise Lorimer School', text: 'Heloise Lorimer School'},
		{value: 'Herons Crossing School', text: 'Herons Crossing School'},
		{value: 'Meadowbrook School', text: 'Meadowbrook School'},
		{value: 'Muriel Clayton Middle School', text: 'Muriel Clayton Middle School'},
		{value: 'Northcott Prairie School', text: 'Northcott Prairie School'},
		{value: 'Nose Creek Elementary School', text: 'Nose Creek Elementary School'},
		{value: 'R.J. Hawkey Elementary School', text: 'R.J. Hawkey Elementary School'},
		{value: 'Ralph McCall School', text: 'Ralph McCall School'},
		{value: 'RVS Community Learning Centre', text: 'RVS Community Learning Centre'},
		{value: 'W.H. Croxford High School', text: 'W.H. Croxford High School'},
		{value: 'Windsong Heights School', text: 'Windsong Heights School'},
		{value: 'Chestermere High School', text: 'Chestermere High School'},
		{value: 'Chestermere Lake Middle School', text: 'Chestermere Lake Middle School'},
		{value: 'East Lake School', text: 'East Lake School'},
		{value: 'Indus School', text: 'Indus School'},
		{value: 'Langdon School', text: 'Langdon School'},
		{value: 'Prairie Waters Elementary School', text: 'Prairie Waters Elementary School'},
		{value: 'Prince of Peace Lutheran School', text: 'Prince of Peace Lutheran School'},
		{value: 'Rainbow Creek Elementary School', text: 'Rainbow Creek Elementary School'},
		{value: 'RVS Community Learning Centre', text: 'RVS Community Learning Centre'},
		{value: 'Sarah Thompson School', text: 'Sarah Thompson School'},
		{value: 'Bearspaw School', text: 'Bearspaw School'},
		{value: 'Bow Valley High School', text: 'Bow Valley High School'},
		{value: 'Cochrane Christian Academy', text: 'Cochrane Christian Academy'},
		{value: 'Cochrane High School', text: 'Cochrane High School'},
		{value: 'Elizabeth Barrett Elementary School', text: 'Elizabeth Barrett Elementary School'},
		{value: 'Fireside School', text: 'Fireside School'},
		{value: 'Glenbow Elementary School', text: 'Glenbow Elementary School'},
		{value: 'Manachaban Middle School', text: 'Manachaban Middle School'},
		{value: 'Mitford School', text: 'Mitford School'},
		{value: 'RancheView School', text: 'RancheView School'},
		{value: 'RVS Community Learning Centre', text: 'RVS Community Learning Centre'},
		{value: 'Westbrook School', text: 'Westbrook School'},
		{value: 'Beiseker Colony School', text: 'Beiseker Colony School'},
		{value: 'Beiseker Community School', text: 'Beiseker Community School'},
		{value: 'Crossfield Elementary School', text: 'Crossfield Elementary School'},
		{value: 'Fairview Colony', text: 'Fairview Colony'},
		{value: 'Kathyrn School', text: 'Kathyrn School'},
		{value: 'Tschetter Colony School', text: 'Tschetter Colony School'},
		{value: 'W.G. Murdoch School', text: 'W.G. Murdoch School'},
		{value: 'Banded Peak School', text: 'Banded Peak School'},
		{value: 'Elbow Valley Elementary School', text: 'Elbow Valley Elementary School'},
		{value: 'Springbank Community High School', text: 'Springbank Community High School'},
		{value: 'Springbank Middle School', text: 'Springbank Middle School'},
		{value: 'RVS Online School', text: 'RVS Online School'},
		{value: 'Summit Trails Online High School', text: 'Summit Trails Online High School'},
	],
    'St. Albert Public Schools': [
		{value: 'Bellerose Composite High School', text: 'Bellerose Composite High School'},
		{value: 'Elmer S. Gish School', text: 'Elmer S. Gish School'},
		{value: 'Joseph M. Demko School', text: 'Joseph M. Demko School'},
		{value: 'Keenooshayo Elementary School', text: 'Keenooshayo Elementary School'},
		{value: 'Leo Nickerson Elementary School', text: 'Leo Nickerson Elementary School'},
		{value: 'Lois E. Hole Elementary School', text: 'Lois E. Hole Elementary School'},
		{value: 'Lorne Akins Jr High School', text: 'Lorne Akins Jr High School'},
		{value: 'Muriel Martin Elementary School', text: 'Muriel Martin Elementary School'},
		{value: 'Paul Kane High School', text: 'Paul Kane High School'},
		{value: 'Robert Rundle Elementary School', text: 'Robert Rundle Elementary School'},
		{value: 'Ronald Harvey Elementary School', text: 'Ronald Harvey Elementary School'},
		{value: 'Sir Alexander Mackenzie School', text: 'Sir Alexander Mackenzie School'},
		{value: 'Sir George Simpson School', text: 'Sir George Simpson School'},
		{value: 'Wild Rose Elementary School', text: 'Wild Rose Elementary School'},
		{value: 'William D. Cuts Jr. High School', text: 'William D. Cuts Jr. High School'},
		{value: 'Outreach High School', text: 'Outreach High School'},
	],
    'Red Deer Catholic Regional Schools': [
		{value: 'École Camille J. Lerouge School', text: 'École Camille J. Lerouge School'},
		{value: 'École Mother Teresa Catholic School', text: 'École Mother Teresa Catholic School'},
		{value: 'École Our Lady of the Rosary School', text: 'École Our Lady of the Rosary School'},
		{value: 'École Secondaire Notre Dame High School', text: 'École Secondaire Notre Dame High School'},
		{value: 'Father Henri Voisin School', text: 'Father Henri Voisin School'},
		{value: 'Holy Family School', text: 'Holy Family School'},
		{value: 'Holy Trinity Catholic School', text: 'Holy Trinity Catholic School'},
		{value: 'Maryview School', text: 'Maryview School'},
		{value: 'Red Deer Catholic International', text: 'Red Deer Catholic International'},
		{value: 'St. Benedict the Moor Centre', text: 'St. Benedict the Moor Centre'},
		{value: 'St. Dominic Catholic High School', text: 'St. Dominic Catholic High School'},
		{value: 'St. Elizabeth Seton School', text: 'St. Elizabeth Seton School'},
		{value: 'St. Francis of Assisi Middle School', text: 'St. Francis of Assisi Middle School'},
		{value: 'St. Gregory the Great Catholic School', text: 'St. Gregory the Great Catholic School'},
		{value: 'St. John Paul II Outreach School', text: 'St. John Paul II Outreach School'},
		{value: 'St. Joseph High School', text: 'St. Joseph High School'},
		{value: 'St. Marguerite Bourgeoys Catholic School', text: 'St. Marguerite Bourgeoys Catholic School'},
		{value: 'St. Martin de Porres School', text: 'St. Martin de Porres School'},
		{value: 'St. Matthew Catholic School', text: 'St. Matthew Catholic School'},
		{value: 'St. Patrick\'s Community School', text: 'St. Patrick\'s Community School'},
		{value: 'St. Teresa of Avila School', text: 'St. Teresa of Avila School'},
		{value: 'St. Thomas Aquinas Middle School', text: 'St. Thomas Aquinas Middle School'},
		{value: 'Notre Dame High School', text: 'Notre Dame High School'},
		{value: 'Our Lady of the Rosary School', text: 'Our Lady of the Rosary School'},
	],
    'Red Deer Public School District': [
		{value: 'Alternative School Centre', text: 'Alternative School Centre'},
		{value: 'Annie L Gaetz Elementary School', text: 'Annie L Gaetz Elementary School'},
		{value: 'Aspen Heights Elementary School', text: 'Aspen Heights Elementary School'},
		{value: 'Barrie Wilson Elementary School', text: 'Barrie Wilson Elementary School'},
		{value: 'Central Middle School', text: 'Central Middle School'},
		{value: 'Don Campbell Elementary School', text: 'Don Campbell Elementary School'},
		{value: 'Eastview Middle School', text: 'Eastview Middle School'},
		{value: 'Fairview Elementary School', text: 'Fairview Elementary School'},
		{value: 'GH Dawe Community School', text: 'GH Dawe Community School'},
		{value: 'Glendale School', text: 'Glendale School'},
		{value: 'GW Smith Elementary School', text: 'GW Smith Elementary School'},
		{value: 'Hunting Hills High School', text: 'Hunting Hills High School'},
		{value: 'Joseph Welsh Elementary School', text: 'Joseph Welsh Elementary School'},
		{value: 'Lindsay Thurber High School', text: 'Lindsay Thurber High School'},
		{value: 'Mattie McCullough School', text: 'Mattie McCullough School'},
		{value: 'Mountview Elementary School', text: 'Mountview Elementary School'},
		{value: 'Normandeau School', text: 'Normandeau School'},
		{value: 'North Cottage High School', text: 'North Cottage High School'},
		{value: 'Oriole Park Elementary School', text: 'Oriole Park Elementary School'},
		{value: 'School Within A College (SWAC)', text: 'School Within A College (SWAC)'},
		{value: 'West Park Elementary School', text: 'West Park Elementary School'},
		{value: 'West Park Middle School', text: 'West Park Middle School'},
		{value: 'Pines Campus', text: 'Pines Campus'},
		{value: 'Grandview Elementary School', text: 'Grandview Elementary School'},
		{value: 'St.Patrick\'s Community School', text: 'St.Patrick\'s Community School'},
	],
    'Lethbridge School Division': [
    	{value: 'Chinook High School', text: 'Chinook High School'},
		{value: 'Coalbanks Elementary Schol', text: 'Coalbanks Elementary Schol'},
		{value: 'Dr. Gerald B. Probe Elementary School', text: 'Dr. Gerald B. Probe Elementary School'},
		{value: 'École Agnes Davidson', text: 'École Agnes Davidson'},
		{value: 'École Nicholas Sheran', text: 'École Nicholas Sheran'},
		{value: 'Fleetwood-Bawden Elementary School', text: 'Fleetwood-Bawden Elementary School'},
		{value: 'G.S. Lakie Middle School', text: 'G.S. Lakie Middle School'},
		{value: 'Galbraith Elementary School', text: 'Galbraith Elementary School'},
		{value: 'General Stewart Elementary School', text: 'General Stewart Elementary School'},
		{value: 'Gilbert Paterson Middle School', text: 'Gilbert Paterson Middle School'},
		{value: 'Immanuel Christian Elementary School', text: 'Immanuel Christian Elementary School'},
		{value: 'Immanuel Christian Secondary School', text: 'Immanuel Christian Secondary School'},
		{value: 'Lakeview Elementary School', text: 'Lakeview Elementary School'},
		{value: 'Lethbridge Christian School', text: 'Lethbridge Christian School'},
		{value: 'Lethbridge Collegiate Institute', text: 'Lethbridge Collegiate Institute'},
		{value: 'Mike Mountain Horse Elementary School', text: 'Mike Mountain Horse Elementary School'},
		{value: 'Park Meadows Elementary School', text: 'Park Meadows Elementary School'},
		{value: 'Senator Buchanan Elementary School', text: 'Senator Buchanan Elementary School'},
		{value: 'Senator Joyce Fairbairn Middle School', text: 'Senator Joyce Fairbairn Middle School'},
		{value: 'Victoria Park High School', text: 'Victoria Park High School'},
		{value: 'Westminster Elementary School', text: 'Westminster Elementary School'},
		{value: 'Wilson Middle School', text: 'Wilson Middle School'},
		{value: 'Winston Churchill High School', text: 'Winston Churchill High School'},
	],
    'Medicine Hat Catholic Board of Education': [
		{value: 'École St. John Paul II School', text: 'École St. John Paul II School'},
		{value: 'Monsignor McCoy High School', text: 'Monsignor McCoy High School'},
		{value: 'Mother Teresa School', text: 'Mother Teresa School'},
		{value: 'Notre Dame Academy', text: 'Notre Dame Academy'},
		{value: 'St. Francis Xavier School', text: 'St. Francis Xavier School'},
		{value: 'St. Louis School', text: 'St. Louis School'},
		{value: 'St. Mary\'s School', text: 'St. Mary\'s School'},
		{value: 'St. Michael\'s School', text: 'St. Michael\'s School'},
		{value: 'St. Patrick\'s School', text: 'St. Patrick\'s School'},
		{value: 'Catholic Education Centre', text: 'Catholic Education Centre'},
	],
    'Medicine Hat Public School Division': [
		{value: 'Alexandra Middle School', text: 'Alexandra Middle School'},
		{value: 'Central High School', text: 'Central High School'},
		{value: 'Connaught School', text: 'Connaught School'},
		{value: 'Cresent Heights High School', text: 'Cresent Heights High School'},
		{value: 'Crestwood School', text: 'Crestwood School'},
		{value: 'Dr. Ken Sauer School', text: 'Dr. Ken Sauer School'},
		{value: 'Dr. Roy Wilson Learning Centre', text: 'Dr. Roy Wilson Learning Centre'},
		{value: 'Elm Street School', text: 'Elm Street School'},
		{value: 'George Davison School', text: 'George Davison School'},
		{value: 'Herald School', text: 'Herald School'},
		{value: 'Medicine Hat Christian School', text: 'Medicine Hat Christian School'},
		{value: 'Medicine Hat Outreach School', text: 'Medicine Hat Outreach School'},
		{value: 'PAS Palliser Health', text: 'PAS Palliser Health'},
		{value: 'River Heights School', text: 'River Heights School'},
		{value: 'Ross Glen School', text: 'Ross Glen School'},
		{value: 'Southview Community School', text: 'Southview Community School'},
		{value: 'Vincent Massey School', text: 'Vincent Massey School'},
		{value: 'Webster Niblock School', text: 'Webster Niblock School'},
		{value: 'Wilson Learning Centre', text: 'Wilson Learning Centre'},
	],
    'Holy Spirit Catholic School Division': [
		{value: 'Catholic Central High School', text: 'Catholic Central High School'},
		{value: 'Centre for Adolescent Responsibility Education', text: 'Centre for Adolescent Responsibility Education'},
		{value: 'Children of St. Martha School', text: 'Children of St. Martha School'},
		{value: 'École St. Mary School', text: 'École St. Mary School'},
		{value: 'Father Leonard Van Tighem School', text: 'Father Leonard Van Tighem School'},
		{value: 'Our Lady of the Assumption School', text: 'Our Lady of the Assumption School'},
		{value: 'St. Catherine School', text: 'St. Catherine School'},
		{value: 'St. Francis Junior High School', text: 'St. Francis Junior High School'},
		{value: 'St. Joseph School', text: 'St. Joseph School'},
		{value: 'St. Mary School', text: 'St. Mary School'},
		{value: 'St. Michael\'s School', text: 'St. Michael\'s School'},
		{value: 'St. Patrick Fine Arts School', text: 'St. Patrick Fine Arts School'},
		{value: 'St. Patrick School', text: 'St. Patrick School'},
		{value: 'St. Paul School', text: 'St. Paul School'},
		{value: 'St. Teresa of Calcutta School', text: 'St. Teresa of Calcutta School'},
		{value: 'Trinity Learning Centre (TLC)', text: 'Trinity Learning Centre (TLC)'},
		{value: 'St. Basil Education Centre', text: 'St. Basil Education Centre'},
	],
    'Grand Prairie Catholic Schools': [
		{value: 'Holy Cross Catholic School', text: 'Holy Cross Catholic School'},
		{value: 'Mother Teresa Catholic School', text: 'Mother Teresa Catholic School'},
		{value: 'O\'Brien Lake West Catholic School', text: 'O\'Brien Lake West Catholic School'},
		{value: 'St. Catherine Catholic School', text: 'St. Catherine Catholic School'},
		{value: 'St. Clement Catholic School', text: 'St. Clement Catholic School'},
		{value: 'École St. Gérard Catholic School', text: 'École St. Gérard Catholic School'},
		{value: 'St. John Bosco Catholic School', text: 'St. John Bosco Catholic School'},
		{value: 'St. John Paul II Catholic School / Faculté Jean-Paul II', text: 'St. John Paul II Catholic School / Faculté Jean-Paul II'},
		{value: 'St. Joseph Catholic High School', text: 'St. Joseph Catholic High School'},
		{value: 'St. Kateri Catholic School', text: 'St. Kateri Catholic School'},
		{value: 'St. Mary Catholic School', text: 'St. Mary Catholic School'},
		{value: 'St. Mary\'s Catholic School', text: 'St. Mary\'s Catholic School'},
		{value: 'Ste. Marie Catholic School', text: 'Ste. Marie Catholic School'},
		{value: 'St. Patrick Catholic School', text: 'St. Patrick Catholic School'},
		{value: 'St. Thomas More Catholic School', text: 'St. Thomas More Catholic School'},
		{value: 'St. Gerard Catholic School', text: 'St. Gerard Catholic School'},
	],
    'Grand Prairie Public School Division': [
    	{value: 'Alexander Forbes School', text: 'Alexander Forbes School'},
		{value: 'Aspen Grove School', text: 'Aspen Grove School'},
		{value: 'Avondale School', text: 'Avondale School'},
		{value: 'Bridge Network Outreach School', text: 'Bridge Network Outreach School'},
		{value: 'Charles Spencer High School', text: 'Charles Spencer High School'},
		{value: 'Crystal Park School', text: 'Crystal Park School'},
		{value: 'Derek Taylor Public School', text: 'Derek Taylor Public School'},
		{value: 'École Montrose', text: 'École Montrose'},
		{value: 'Grand Prairie Christian School', text: 'Grand Prairie Christian School'},
		{value: 'Grand Prairie Composite High School', text: 'Grand Prairie Composite High School'},
		{value: 'Hillside Community School', text: 'Hillside Community School'},
		{value: 'I.V. Macklin Public School', text: 'I.V. Macklin Public School'},
		{value: 'Isabel Campbell Public School', text: 'Isabel Campbell Public School'},
		{value: 'Maude Clifford Public School', text: 'Maude Clifford Public School'},
		{value: 'Parkside Montessori', text: 'Parkside Montessori'},
		{value: 'Riverstone Public School', text: 'Riverstone Public School'},
		{value: 'Roy Bickell Public School', text: 'Roy Bickell Public School'},
		{value: 'Swanavon School', text: 'Swanavon School'},
		{value: 'Lions Learning Centre', text: 'Lions Learning Centre'},
	],
    'Calgary Catholic Board of Education': [
		{value: 'All Saints High School', text: 'All Saints High School'},
		{value: 'Apostles of Jesus School', text: 'Apostles of Jesus School'},
		{value: 'Ascension of Our Lord School', text: 'Ascension of Our Lord School'},
		{value: 'St. Alphonsus School', text: 'St. Alphonsus School'},
		{value: 'St. Ambrose School', text: 'St. Ambrose School'},
		{value: 'St. Andrew School', text: 'St. Andrew School'},
		{value: 'St. Angela School', text: 'St. Angela School'},
		{value: 'St. Augustine School', text: 'St. Augustine School'},
		{value: 'Bishop Grandin High School', text: 'Bishop Grandin High School'},
		{value: 'Bishop Kidd School', text: 'Bishop Kidd School'},
		{value: 'Bishop McNally High School', text: 'Bishop McNally High School'},
		{value: 'Bishop O\'Byrne High School', text: 'Bishop O\'Byrne High School'},
		{value: 'Blessed Marie-Rose School', text: 'Blessed Marie-Rose School'},
		{value: 'St. Basil School', text: 'St. Basil School'},
		{value: 'St. Bede School', text: 'St. Bede School'},
		{value: 'St. Benedict School', text: 'St. Benedict School'},
		{value: 'St. Bernadette School', text: 'St. Bernadette School'},
		{value: 'St. Bonaventure School', text: 'St. Bonaventure School'},
		{value: 'St. Boniface School', text: 'St. Boniface School'},
		{value: 'St. Brigid School', text: 'St. Brigid School'},
		{value: 'Christ the King School', text: 'Christ the King School'},
		{value: 'Corpus Christi School', text: 'Corpus Christi School'},
		{value: 'St. Catherine School', text: 'St. Catherine School'},
		{value: 'St. Cecilia School', text: 'St. Cecilia School'},
		{value: 'St. Clare School', text: 'St. Clare School'},
		{value: 'St. Cyril School', text: 'St. Cyril School'},
		{value: 'Divine Mercy School', text: 'Divine Mercy School'},
		{value: 'Don Bosco School', text: 'Don Bosco School'},
		{value: 'St. Damien School', text: 'St. Damien School'},
		{value: 'St. Dominic School', text: 'St. Dominic School'},
		{value: 'St. Elizabeth Seton School', text: 'St. Elizabeth Seton School'},
		{value: 'Father Doucet School', text: 'Father Doucet School'},
		{value: 'Father Lacombe High School', text: 'Father Lacombe High School'},
		{value: 'Father Scollen School', text: 'Father Scollen School'},
		{value: 'Father Whelihan School', text: 'Father Whelihan School'},
		{value: 'St. Francis High School', text: 'St. Francis High School'},
		{value: 'Good Shepherd School', text: 'Good Shepherd School'},
		{value: 'Guardian Angel School', text: 'Guardian Angel School'},
		{value: 'St. Gabriel the Archangel School', text: 'St. Gabriel the Archangel School'},
		{value: 'St. Gerard School', text: 'St. Gerard School'},
		{value: 'St. Gregory School', text: 'St. Gregory School'},
		{value: 'Holy Angels School', text: 'Holy Angels School'},
		{value: 'Holy Child School', text: 'Holy Child School'},
		{value: 'Holy Cross School', text: 'Holy Cross School'},
		{value: 'Holy Family School', text: 'Holy Family School'},
		{value: 'Holy Name School', text: 'Holy Name School'},
		{value: 'Holy Spirit School', text: 'Holy Spirit School'},
		{value: 'Holy Trinity School', text: 'Holy Trinity School'},
		{value: 'St. Helena School', text: 'St. Helena School'},
		{value: 'St. Henry School', text: 'St. Henry School'},
		{value: 'St. Hubert School', text: 'St. Hubert School'},
		{value: 'St. Isabella School', text: 'St. Isabella School'},
		{value: 'John W Costello School', text: 'John W Costello School'},
		{value: 'St. John Henry Newman School', text: 'St. John Henry Newman School'},
		{value: 'St. James School', text: 'St. James School'},
		{value: 'St. Jean Brebeuf School', text: 'St. Jean Brebeuf School'},
		{value: 'St. Jerome School', text: 'St. Jerome School'},
		{value: 'St. Joan of Arc School', text: 'St. Joan of Arc School'},
		{value: 'St. John Paul II School', text: 'St. John Paul II School'},
		{value: 'St. John XXIII School', text: 'St. John XXIII School'},
		{value: 'St. Joseph School', text: 'St. Joseph School'},
		{value: 'St. Jude School', text: 'St. Jude School'},
		{value: 'St. Kateri Tekekwitha School', text: 'St. Kateri Tekekwitha School'},
		{value: 'Light of Christ School', text: 'Light of Christ School'},
		{value: 'St. Luke School', text: 'St. Luke School'},
		{value: 'Madeleine D\'Houet School', text: 'Madeleine D\'Houet School'},
		{value: 'Msgr. A.J. Hetherington', text: 'Msgr. A.J. Hetherington'},
		{value: 'Mother Mary Greene', text: 'Mother Mary Greene'},
		{value: 'Msgr. E. L. Doyle', text: 'Msgr. E. L. Doyle'},
		{value: 'Monsignor J.J. O\'Brien School', text: 'Monsignor J.J. O\'Brien School'},
		{value: 'Monsignor J.S. Smith School', text: 'Monsignor J.S. Smith School'},
		{value: 'Msgr. Neville Anderson', text: 'Msgr. Neville Anderson'},
		{value: 'St. Margaret School', text: 'St. Margaret School'},
		{value: 'St. Marguerite School', text: 'St. Marguerite School'},
		{value: 'St. Maria Goretti School', text: 'St. Maria Goretti School'},
		{value: 'St. Mark School', text: 'St. Mark School'},
		{value: 'St. Martha School', text: 'St. Martha School'},
		{value: 'St. Martin de Porres High School', text: 'St. Martin de Porres High School'},
		{value: 'St. Mary\'s High School', text: 'St. Mary\'s High School'},
		{value: 'St. Mathew School', text: 'St. Mathew School'},
		{value: 'St. Michael School', text: 'St. Michael School'},
		{value: 'St. Monica School', text: 'St. Monica School'},
		{value: 'Notre Dame High School', text: 'Notre Dame High School'},
		{value: 'Our Lady of Fatima School', text: 'Our Lady of Fatima School'},
		{value: 'Our Lady of Grace School', text: 'Our Lady of Grace School'},
		{value: 'Our Lady of Peace School', text: 'Our Lady of Peace School'},
		{value: 'Our Lady of the Assumption School', text: 'Our Lady of the Assumption School'},
		{value: 'Our Lady Queen of Peace School', text: 'Our Lady Queen of Peace School'},
		{value: 'Our Lady of the Evergreens', text: 'Our Lady of the Evergreens'},
		{value: 'Our Lady of the Rosary School', text: 'Our Lady of the Rosary School'},
		{value: 'Our Lady of Wisdom School', text: 'Our Lady of Wisdom School'},
		{value: 'Prince of Peace School', text: 'Prince of Peace School'},
		{value: 'St. Patrick School', text: 'St. Patrick School'},
		{value: 'St. Peter School', text: 'St. Peter School'},
		{value: 'St. Philip School', text: 'St. Philip School'},
		{value: 'St. Pius X School', text: 'St. Pius X School'},
		{value: 'St. Rita School', text: 'St. Rita School'},
		{value: 'St. Rose of Lima School', text: 'St. Rose of Lima School'},
		{value: 'St. Rupert School', text: 'St. Rupert School'},
		{value: 'Sacred Heart School', text: 'Sacred Heart School'},
		{value: 'St. Albert the Great School', text: 'St. Albert the Great School'},
		{value: 'St. Sebastian School', text: 'St. Sebastian School'},
		{value: 'St. Stephen School', text: 'St. Stephen School'},
		{value: 'St. Sylvester School', text: 'St. Sylvester School'},
		{value: 'St. Teresa of Calcutta School', text: 'St. Teresa of Calcutta School'},
		{value: 'St. Thomas Aquinas School', text: 'St. Thomas Aquinas School'},
		{value: 'St. Thomas More School', text: 'St. Thomas More School'},
		{value: 'St. Timothy School', text: 'St. Timothy School'},
		{value: 'St. Veronica', text: 'St. Veronica'},
		{value: 'St. Vincent de Paul School', text: 'St. Vincent de Paul School'},
		{value: 'St. Wilfrid School', text: 'St. Wilfrid School'},
		{value: 'St. William School', text: 'St. William School'},
	],
    'Fort McMurray Public Schools': [
		{value: 'Beacon Hill Public School', text: 'Beacon Hill Public School'},
		{value: 'Christina Gordon Public School', text: 'Christina Gordon Public School'},
		{value: 'Dave McNeilly Public School', text: 'Dave McNeilly Public School'},
		{value: 'Dr. K.A. Clark Public School', text: 'Dr. K.A. Clark Public School'},
		{value: 'École Dickinsfield School', text: 'École Dickinsfield School'},
		{value: 'École McTavish Public High School', text: 'École McTavish Public High School'},
		{value: 'Fort McMurray Christian School', text: 'Fort McMurray Christian School'},
		{value: 'Fort McMurray Composite High School', text: 'Fort McMurray Composite High School'},
		{value: 'Fort McMurray Islamic School', text: 'Fort McMurray Islamic School'},
		{value: 'Frank Spragins High School', text: 'Frank Spragins High School'},
		{value: 'Greely Road School', text: 'Greely Road School'},
		{value: 'Thickwood Heights School', text: 'Thickwood Heights School'},
		{value: 'Timberlea Public School', text: 'Timberlea Public School'},
		{value: 'Walter and Gladys Hill Public School', text: 'Walter and Gladys Hill Public School'},
		{value: 'Westview Public School', text: 'Westview Public School'},
		{value: 'Westwood Community High School', text: 'Westwood Community High School'},
		{value: 'Composite High School', text: 'Composite High School'},
		{value: 'Dickinsfield Public School', text: 'Dickinsfield Public School'},
		{value: 'École McTavish Jr. High School', text: 'École McTavish Jr. High School'},
	],
    'Edmonton Public School Board': [
		{value: 'A Blair Mcpherson School', text: 'A Blair Mcpherson School'},
		{value: 'Abbott School', text: 'Abbott School'},
		{value: 'Academy at King Edward', text: 'Academy at King Edward'},
		{value: 'Afton School', text: 'Afton School'},
		{value: 'Alberta School for the Deaf', text: 'Alberta School for the Deaf'},
		{value: 'Aldergrove School', text: 'Aldergrove School'},
		{value: 'Allendale School', text: 'Allendale School'},
		{value: 'Amiskwaciy Academy', text: 'Amiskwaciy Academy'},
		{value: 'Argyll Centre', text: 'Argyll Centre'},
		{value: 'Athlone School', text: 'Athlone School'},
		{value: 'Avalon School', text: 'Avalon School'},
		{value: 'Avonmore School', text: 'Avonmore School'},
		{value: 'Balwin School', text: 'Balwin School'},
		{value: 'Bannerman School', text: 'Bannerman School'},
		{value: 'Baturyn School', text: 'Baturyn School'},
		{value: 'Beacon Heights School', text: 'Beacon Heights School'},
		{value: 'Belgravia School', text: 'Belgravia School'},
		{value: 'Belmead School', text: 'Belmead School'},
		{value: 'Belmont School', text: 'Belmont School'},
		{value: 'Belvedere School', text: 'Belvedere School'},
		{value: 'Bessie Nichols School', text: 'Bessie Nichols School'},
		{value: 'Bisset School', text: 'Bisset School'},
		{value: 'Braemar School', text: 'Braemar School'},
		{value: 'Brander Gardens School', text: 'Brander Gardens School'},
		{value: 'Brightview School', text: 'Brightview School'},
		{value: 'Britannia School', text: 'Britannia School'},
		{value: 'Brookeside School', text: 'Brookeside School'},
		{value: 'Caenarvon School', text: 'Caenarvon School'},
		{value: 'Calder School', text: 'Calder School'},
		{value: 'Callingwood School', text: 'Callingwood School'},
		{value: 'Centennial School', text: 'Centennial School'},
		{value: 'Centre High Campus', text: 'Centre High Campus'},
		{value: 'Clara Tyner School', text: 'Clara Tyner School'},
		{value: 'Constable Daniel Woodall School', text: 'Constable Daniel Woodall School'},
		{value: 'Coronation School', text: 'Coronation School'},
		{value: 'Crawford Plains School', text: 'Crawford Plains School'},
		{value: 'Crestwood School', text: 'Crestwood School'},
		{value: 'DS Mackenzie School', text: 'DS Mackenzie School'},
		{value: 'Daly Grove School', text: 'Daly Grove School'},
		{value: 'Dan Knott School', text: 'Dan Knott School'},
		{value: 'David Thomas King School', text: 'David Thomas King School'},
		{value: 'Delton School', text: 'Delton School'},
		{value: 'Delwood School', text: 'Delwood School'},
		{value: 'Dickinsfield School', text: 'Dickinsfield School'},
		{value: 'Donald R Getty School', text: 'Donald R Getty School'},
		{value: 'Donnan School', text: 'Donnan School'},
		{value: 'Dovercourt School', text: 'Dovercourt School'},
		{value: 'Dr. Donald Massey School', text: 'Dr. Donald Massey School'},
		{value: 'Dr. Lila Fahlman School', text: 'Dr. Lila Fahlman School'},
		{value: 'Dr. Margaret-Ann Armour School', text: 'Dr. Margaret-Ann Armour School'},
		{value: 'Duggan School', text: 'Duggan School'},
		{value: 'Dunluce School', text: 'Dunluce School'},
		{value: 'Earl Buxton School', text: 'Earl Buxton School'},
		{value: 'Eastglen School', text: 'Eastglen School'},
		{value: 'Edith Rogers School', text: 'Edith Rogers School'},
		{value: 'Edmonton Christian High School', text: 'Edmonton Christian High School'},
		{value: 'Edmonton Christian Northeast School', text: 'Edmonton Christian Northeast School'},
		{value: 'Edmonton Christian West School', text: 'Edmonton Christian West School'},
		{value: 'Ekota School', text: 'Ekota School'},
		{value: 'Elizabeth Finch School', text: 'Elizabeth Finch School'},
		{value: 'Ellerslie Campus School', text: 'Ellerslie Campus School'},
		{value: 'Elmwood School', text: 'Elmwood School'},
		{value: 'Esther Starkman School', text: 'Esther Starkman School'},
		{value: 'Evansdale School', text: 'Evansdale School'},
		{value: 'Florence Hallock School', text: 'Florence Hallock School'},
		{value: 'Forest Heights School', text: 'Forest Heights School'},
		{value: 'Fraser School', text: 'Fraser School'},
		{value: 'Garneau School', text: 'Garneau School'},
		{value: 'George H Luck School', text: 'George H Luck School'},
		{value: 'George P Nicholson School', text: 'George P Nicholson School'},
		{value: 'Glendale School', text: 'Glendale School'},
		{value: 'Glengarry School', text: 'Glengarry School'},
		{value: 'Glenora School', text: 'Glenora School'},
		{value: 'Gold Bar School', text: 'Gold Bar School'},
		{value: 'Grace Martin School', text: 'Grace Martin School'},
		{value: 'Grandview Heights School', text: 'Grandview Heights School'},
		{value: 'Greenfield School', text: 'Greenfield School'},
		{value: 'Greenview School', text: 'Greenview School'},
		{value: 'Grovenor School', text: 'Grovenor School'},
		{value: 'Hardisty School', text: 'Hardisty School'},
		{value: 'Harry Ainley School', text: 'Harry Ainley School'},
		{value: 'Hazeldean School', text: 'Hazeldean School'},
		{value: 'Highlands School', text: 'Highlands School'},
		{value: 'Hillcrest School', text: 'Hillcrest School'},
		{value: 'Hillview School', text: 'Hillview School'},
		{value: 'Hilwie Hamdon School', text: 'Hilwie Hamdon School'},
		{value: 'Holyrood School', text: 'Holyrood School'},
		{value: 'Homesteader School', text: 'Homesteader School'},
		{value: 'Horse Hill School', text: 'Horse Hill School'},
		{value: 'Inglewood School', text: 'Inglewood School'},
		{value: 'Ivor Dent School', text: 'Ivor Dent School'},
		{value: 'J Percy Page School', text: 'J Percy Page School'},
		{value: 'JA Fife School', text: 'JA Fife School'},
		{value: 'Jackson Heights School', text: 'Jackson Heights School'},
		{value: 'James Gibbons School', text: 'James Gibbons School'},
		{value: 'Jan Reimer School', text: 'Jan Reimer School'},
		{value: 'Jasper Place School', text: 'Jasper Place School'},
		{value: 'John A Mcdougall School', text: 'John A Mcdougall School'},
		{value: 'John Barnett School', text: 'John Barnett School'},
		{value: 'John D Bracco School', text: 'John D Bracco School'},
		{value: 'Johnny Bright School', text: 'Johnny Bright School'},
		{value: 'Julia Kiniski School', text: 'Julia Kiniski School'},
		{value: 'Kameyosek School', text: 'Kameyosek School'},
		{value: 'Kate Chegwin School', text: 'Kate Chegwin School'},
		{value: 'Keheewin School', text: 'Keheewin School'},
		{value: 'Kenilworth School', text: 'Kenilworth School'},
		{value: 'Kensington School', text: 'Kensington School'},
		{value: 'Kildare School', text: 'Kildare School'},
		{value: 'Killarney School', text: 'Killarney School'},
		{value: 'Kim Hung School', text: 'Kim Hung School'},
		{value: 'King Edward School', text: 'King Edward School'},
		{value: 'Kirkness School', text: 'Kirkness School'},
		{value: 'LY Cairns School', text: 'LY Cairns School'},
		{value: 'Lago Lindo School', text: 'Lago Lindo School'},
		{value: 'Lansdowne School', text: 'Lansdowne School'},
		{value: 'Laperle School', text: 'Laperle School'},
		{value: 'Lauderdale School', text: 'Lauderdale School'},
		{value: 'Laurier Heights School', text: 'Laurier Heights School'},
		{value: 'Learning Store at Blue Quill', text: 'Learning Store at Blue Quill'},
		{value: 'Learning Store at Northgate', text: 'Learning Store at Northgate'},
		{value: 'Learning Store on Whyte', text: 'Learning Store on Whyte'},
		{value: 'Learning Store West Edmonton', text: 'Learning Store West Edmonton'},
		{value: 'Lee Ridge School', text: 'Lee Ridge School'},
		{value: 'Lendrum School', text: 'Lendrum School'},
		{value: 'Lillian Osbourne School', text: 'Lillian Osbourne School'},
		{value: 'Londonderry School', text: 'Londonderry School'},
		{value: 'Lorelei School', text: 'Lorelei School'},
		{value: 'Lymburn School', text: 'Lymburn School'},
		{value: 'Lynnwood School', text: 'Lynnwood School'},
		{value: 'ME Lazerte School', text: 'ME Lazerte School'},
		{value: 'Major-General Griesbach School', text: 'Major-General Griesbach School'},
		{value: 'Malcolm Tweddle School', text: 'Malcolm Tweddle School'},
		{value: 'Malmo School', text: 'Malmo School'},
		{value: 'Mary Butterworth School', text: 'Mary Butterworth School'},
		{value: 'Mayfield School', text: 'Mayfield School'},
		{value: 'McArthur School', text: 'McArthur School'},
		{value: 'McKee School', text: 'McKee School'},
		{value: 'McKernan School', text: 'McKernan School'},
		{value: 'McLeod School', text: 'McLeod School'},
		{value: 'McNally School', text: 'McNally School'},
		{value: 'Meadowlark School', text: 'Meadowlark School'},
		{value: 'Meadowlark Christian School', text: 'Meadowlark Christian School'},
		{value: 'Mee-Yah-Noh School', text: 'Mee-Yah-Noh School'},
		{value: 'Menisa School', text: 'Menisa School'},
		{value: 'Metro Continuing Edu', text: 'Metro Continuing Edu'},
		{value: 'Meyokumin School', text: 'Meyokumin School'},
		{value: 'Meyonohk School', text: 'Meyonohk School'},
		{value: 'Michael A Kostek School', text: 'Michael A Kostek School'},
		{value: 'Michael Phair School', text: 'Michael Phair School'},
		{value: 'Michael Strembitsky School', text: 'Michael Strembitsky School'},
		{value: 'Mill Creek School', text: 'Mill Creek School'},
		{value: 'Millwoods Christian School', text: 'Millwoods Christian School'},
		{value: 'Minchau School', text: 'Minchau School'},
		{value: 'Montrose School', text: 'Montrose School'},
		{value: 'Mount Pleasant School', text: 'Mount Pleasant School'},
		{value: 'Mount Royal School', text: 'Mount Royal School'},
		{value: 'Nellie Carlson School', text: 'Nellie Carlson School'},
		{value: 'Northmount School', text: 'Northmount School'},
		{value: 'Norwood School', text: 'Norwood School'},
		{value: 'Old Scona School', text: 'Old Scona School'},
		{value: 'Oliver School', text: 'Oliver School'},
		{value: 'Ormsby School', text: 'Ormsby School'},
		{value: 'Ottewell School', text: 'Ottewell School'},
		{value: 'Overlanders School', text: 'Overlanders School'},
		{value: 'Parkallen School', text: 'Parkallen School'},
		{value: 'Parkview School', text: 'Parkview School'},
		{value: 'Patricia Heights School', text: 'Patricia Heights School'},
		{value: 'Pollard Meadows School', text: 'Pollard Meadows School'},
		{value: 'Prince Charles School', text: 'Prince Charles School'},
		{value: 'Princeton School', text: 'Princeton School'},
		{value: 'Queen Alexandra School', text: 'Queen Alexandra School'},
		{value: 'Queen Elizabeth School', text: 'Queen Elizabeth School'},
		{value: 'Richard Secord School', text: 'Richard Secord School'},
		{value: 'Rideau Park School', text: 'Rideau Park School'},
		{value: 'Rio Terrace School', text: 'Rio Terrace School'},
		{value: 'Riverbend School', text: 'Riverbend School'},
		{value: 'Riverdale School', text: 'Riverdale School'},
		{value: 'Roberta MacAdams School', text: 'Roberta MacAdams School'},
		{value: 'Ross Sheppard School', text: 'Ross Sheppard School'},
		{value: 'Rosslyn School', text: 'Rosslyn School'},
		{value: 'Rutherford School', text: 'Rutherford School'},
		{value: 'S Bruce Smith School', text: 'S Bruce Smith School'},
		{value: 'Sakaw School', text: 'Sakaw School'},
		{value: 'Satoo School', text: 'Satoo School'},
		{value: 'Scott Robertson School', text: 'Scott Robertson School'},
		{value: 'Shauna May Seneca School', text: 'Shauna May Seneca School'},
		{value: 'Sherwood School', text: 'Sherwood School'},
		{value: 'Sifton School', text: 'Sifton School'},
		{value: 'Soraya Hafex School', text: 'Soraya Hafex School'},
		{value: 'Spruce Ave School', text: 'Spruce Ave School'},
		{value: 'Steele Heights School', text: 'Steele Heights School'},
		{value: 'Steinhauer School', text: 'Steinhauer School'},
		{value: 'Stratford School', text: 'Stratford School'},
		{value: 'Strathcona School', text: 'Strathcona School'},
		{value: 'Svend Hansen School', text: 'Svend Hansen School'},
		{value: 'Sweet Grass School', text: 'Sweet Grass School'},
		{value: 'TD Baker School', text: 'TD Baker School'},
		{value: 'Talmud Torah School', text: 'Talmud Torah School'},
		{value: 'Tevie Miller Heritage School Program', text: 'Tevie Miller Heritage School Program'},
		{value: 'Thelma Chalifoux School', text: 'Thelma Chalifoux School'},
		{value: 'Thorncliffe School', text: 'Thorncliffe School'},
		{value: 'Tipaskan School', text: 'Tipaskan School'},
		{value: 'Velma E Baker School', text: 'Velma E Baker School'},
		{value: 'Vernon Barford School', text: 'Vernon Barford School'},
		{value: 'Victoria School', text: 'Victoria School'},
		{value: 'Vimy Ridge Academy', text: 'Vimy Ridge Academy'},
		{value: 'Virginia Park School', text: 'Virginia Park School'},
		{value: 'WP Wagner School', text: 'WP Wagner School'},
		{value: 'Waverley School', text: 'Waverley School'},
		{value: 'Weinlos School', text: 'Weinlos School'},
		{value: 'Westbrook School', text: 'Westbrook School'},
		{value: 'Westglen School', text: 'Westglen School'},
		{value: 'Westlawn School', text: 'Westlawn School'},
		{value: 'Westminster School', text: 'Westminster School'},
		{value: 'Westmount School', text: 'Westmount School'},
		{value: 'Windsor Park School', text: 'Windsor Park School'},
		{value: 'Winterburn School', text: 'Winterburn School'},
		{value: 'York School', text: 'York School'},
		{value: 'Youngstown School', text: 'Youngstown School'},
	],
    'Calgary Board of Education': [
		{value: 'A. E. Cross School', text: 'A. E. Cross School'},
		{value: 'Abbeydale School', text: 'Abbeydale School'},
		{value: 'Acadia School', text: 'Acadia School'},
		{value: 'Alex Munro School', text: 'Alex Munro School'},
		{value: 'Alexander Ferguson School', text: 'Alexander Ferguson School'},
		{value: 'All Boys Program', text: 'All Boys Program'},
		{value: 'Altadore School', text: 'Altadore School'},
		{value: 'Alternative High School', text: 'Alternative High School'},
		{value: 'Andrew Sibbald School', text: 'Andrew Sibbald School'},
		{value: 'Annie Foote School', text: 'Annie Foote School'},
		{value: 'Annie Gale School', text: 'Annie Gale School'},
		{value: 'Arbour Lake School', text: 'Arbour Lake School'},
		{value: 'Auburn Bay School', text: 'Auburn Bay School'},
		{value: 'Balmoral School', text: 'Balmoral School'},
		{value: 'Banff Trail School', text: 'Banff Trail School'},
		{value: 'Banting and Best School', text: 'Banting and Best School'},
		{value: 'Battalion Park School', text: 'Battalion Park School'},
		{value: 'Beddington Heights School', text: 'Beddington Heights School'},
		{value: 'Belfast School', text: 'Belfast School'},
		{value: 'Belvedere Parkway School', text: 'Belvedere Parkway School'},
		{value: 'Bishop Pinkham School', text: 'Bishop Pinkham School'},
		{value: 'Bob Edwards School', text: 'Bob Edwards School'},
		{value: 'Bowcroft School', text: 'Bowcroft School'},
		{value: 'Bowness High School', text: 'Bowness High School'},
		{value: 'Braeside School', text: 'Braeside School'},
		{value: 'Branton School', text: 'Branton School'},
		{value: 'Brentwood School', text: 'Brentwood School'},
		{value: 'Briar Hill School', text: 'Briar Hill School'},
		{value: 'Bridlewood School', text: 'Bridlewood School'},
		{value: 'Buchanan School', text: 'Buchanan School'},
		{value: 'Buffalo Rubbing Stone School', text: 'Buffalo Rubbing Stone School'},
		{value: 'Cambrian Heights School', text: 'Cambrian Heights School'},
		{value: 'Canyon Meadows School', text: 'Canyon Meadows School'},
		{value: 'Capitol Hill School', text: 'Capitol Hill School'},
		{value: 'Cappy Smart School', text: 'Cappy Smart School'},
		{value: 'Captain John Palliser School', text: 'Captain John Palliser School'},
		{value: 'Captain Nichola Goddard School', text: 'Captain Nichola Goddard School'},
		{value: 'Catherine Nichols Gunn School', text: 'Catherine Nichols Gunn School'},
		{value: 'CBE Home Education', text: 'CBE Home Education'},
		{value: 'CBe-Learn', text: 'CBe-Learn'},
		{value: 'Cecil Swanson School', text: 'Cecil Swanson School'},
		{value: 'Cedarbrae School', text: 'Cedarbrae School'},
		{value: 'Centennial High School', text: 'Centennial High School'},
		{value: 'Central Memorial High School', text: 'Central Memorial High School'},
		{value: 'Chaparral School', text: 'Chaparral School'},
		{value: 'Chief Justice Milvain School', text: 'Chief Justice Milvain School'},
		{value: 'Children\'s Village School', text: 'Children\'s Village School'},
		{value: 'Chinook Park School', text: 'Chinook Park School'},
		{value: 'Chris Akkerman School', text: 'Chris Akkerman School'},
		{value: 'Christine Meikle School', text: 'Christine Meikle School'},
		{value: 'Citadel Park School', text: 'Citadel Park School'},
		{value: 'Clarence Sansom School', text: 'Clarence Sansom School'},
		{value: 'Collingwood School', text: 'Collingwood School'},
		{value: 'Colonel Irvine School', text: 'Colonel Irvine School'},
		{value: 'Colonel J. Fred Scott School', text: 'Colonel J. Fred Scott School'},
		{value: 'Colonel Macleod School', text: 'Colonel Macleod School'},
		{value: 'Colonel Sanders School', text: 'Colonel Sanders School'},
		{value: 'Colonel Walker School', text: 'Colonel Walker School'},
		{value: 'Connaught School', text: 'Connaught School'},
		{value: 'Copperfield School', text: 'Copperfield School'},
		{value: 'Coventry Hills School', text: 'Coventry Hills School'},
		{value: 'Cranston School', text: 'Cranston School'},
		{value: 'Crescent Heights High School', text: 'Crescent Heights High School'},
		{value: 'Crossing Park School', text: 'Crossing Park School'},
		{value: 'Dalhousie School', text: 'Dalhousie School'},
		{value: 'David Thompson School', text: 'David Thompson School'},
		{value: 'Deer Run School', text: 'Deer Run School'},
		{value: 'Discovering Choices - CACY', text: 'Discovering Choices - CACY'},
		{value: 'Discovering Choices II', text: 'Discovering Choices II'},
		{value: 'Douglas Harkness School', text: 'Douglas Harkness School'},
		{value: 'Douglasdale School', text: 'Douglasdale School'},
		{value: 'Dr. E.P. Scarlett High School', text: 'Dr. E.P. Scarlett High School'},
		{value: 'Dr. E.W. Coffin School', text: 'Dr. E.W. Coffin School'},
		{value: 'Dr. Freda Miller School', text: 'Dr. Freda Miller School'},
		{value: 'Dr. George Stanley School', text: 'Dr. George Stanley School'},
		{value: 'Dr. Gladys McKelvie Egbert School', text: 'Dr. Gladys McKelvie Egbert School'},
		{value: 'Dr. Gordon Higgins School', text: 'Dr. Gordon Higgins School'},
		{value: 'Dr. Gordon Townsend School', text: 'Dr. Gordon Townsend School'},
		{value: 'Dr. J.K. Mulloy School', text: 'Dr. J.K. Mulloy School'},
		{value: 'Dr. Martha Cohen School', text: 'Dr. Martha Cohen School'},
		{value: 'Dr. Oakley School', text: 'Dr. Oakley School'},
		{value: 'Dr. Roberta Bondar School', text: 'Dr. Roberta Bondar School'},
		{value: 'Earl Grey School', text: 'Earl Grey School'},
		{value: 'Edgemont School', text: 'Edgemont School'},
		{value: 'Elbow Park School', text: 'Elbow Park School'},
		{value: 'Elboya School', text: 'Elboya School'},
		{value: 'Emily Follensbee School', text: 'Emily Follensbee School'},
		{value: 'Eric Harvie School', text: 'Eric Harvie School'},
		{value: 'Erin Woods School', text: 'Erin Woods School'},
		{value: 'Ernest Manning High School', text: 'Ernest Manning High School'},
		{value: 'Ernest Morrow School', text: 'Ernest Morrow School'},
		{value: 'Ethel M. Johnson School', text: 'Ethel M. Johnson School'},
		{value: 'Eugene Coste School', text: 'Eugene Coste School'},
		{value: 'Evergreen School', text: 'Evergreen School'},
		{value: 'F.E. Osborne School', text: 'F.E. Osborne School'},
		{value: 'Fairview School', text: 'Fairview School'},
		{value: 'Falconridge School', text: 'Falconridge School'},
		{value: 'Fish Creek School', text: 'Fish Creek School'},
		{value: 'Forest Lawn High School', text: 'Forest Lawn High School'},
		{value: 'G.W. Skene School', text: 'G.W. Skene School'},
		{value: 'Georges P. Vanier School', text: 'Georges P. Vanier School'},
		{value: 'Glamorgan School', text: 'Glamorgan School'},
		{value: 'Glenbrook School', text: 'Glenbrook School'},
		{value: 'Glendale School', text: 'Glendale School'},
		{value: 'Glenmeadows School', text: 'Glenmeadows School'},
		{value: 'Grant MacEwan School', text: 'Grant MacEwan School'},
		{value: 'Griffith Woods School', text: 'Griffith Woods School'},
		{value: 'Guy Weadick School', text: 'Guy Weadick School'},
		{value: 'H.D. Cartwright School', text: 'H.D. Cartwright School'},
		{value: 'The Hamptons School', text: 'The Hamptons School'},
		{value: 'Harold Panabaker School', text: 'Harold Panabaker School'},
		{value: 'Haultain Memorial School', text: 'Haultain Memorial School'},
		{value: 'Hawkwood School', text: 'Hawkwood School'},
		{value: 'Haysboro School', text: 'Haysboro School'},
		{value: 'Henry Wise Wood High School', text: 'Henry Wise Wood High School'},
		{value: 'Hidden Valley School', text: 'Hidden Valley School'},
		{value: 'Highwood School', text: 'Highwood School'},
		{value: 'Hillhurst School', text: 'Hillhurst School'},
		{value: 'Hugh A. Bennett School', text: 'Hugh A. Bennett School'},
		{value: 'Huntington Hills School', text: 'Huntington Hills School'},
		{value: 'Ian Bazalgette School', text: 'Ian Bazalgette School'},
		{value: 'Jack James High School', text: 'Jack James High School'},
		{value: 'James Fowler High School', text: 'James Fowler High School'},
		{value: 'James Short Memorial School', text: 'James Short Memorial School'},
		{value: 'Janet Johnstone School', text: 'Janet Johnstone School'},
		{value: 'Jennie Elliott School', text: 'Jennie Elliott School'},
		{value: 'Joane Cardinal-Schubert High School', text: 'Joane Cardinal-Schubert High School'},
		{value: 'John G. Diefenbaker High School', text: 'John G. Diefenbaker High School'},
		{value: 'John Ware School', text: 'John Ware School'},
		{value: 'Keeler School', text: 'Keeler School'},
		{value: 'Kenneth D. Taylor School', text: 'Kenneth D. Taylor School'},
		{value: 'Killarney School', text: 'Killarney School'},
		{value: 'King George School', text: 'King George School'},
		{value: 'Lake Bonavista School', text: 'Lake Bonavista School'},
		{value: 'Langevin School', text: 'Langevin School'},
		{value: 'Le Roi Daniels School', text: 'Le Roi Daniels School'},
		{value: 'Lester B. Pearson High School', text: 'Lester B. Pearson High School'},
		{value: 'Lord Beaverbrook High School', text: 'Lord Beaverbrook High School'},
		{value: 'Louis Riel School', text: 'Louis Riel School'},
		{value: 'Louise Dean School', text: 'Louise Dean School'},
		{value: 'Manmeet Singh Bhullar School', text: 'Manmeet Singh Bhullar School'},
		{value: 'Maple Ridge School', text: 'Maple Ridge School'},
		{value: 'Marion Carson School', text: 'Marion Carson School'},
		{value: 'Marlborough School', text: 'Marlborough School'},
		{value: 'Marshall Springs School', text: 'Marshall Springs School'},
		{value: 'Mayland Heights School', text: 'Mayland Heights School'},
		{value: 'McKenzie Highlands School', text: 'McKenzie Highlands School'},
		{value: 'McKenzie Lake School', text: 'McKenzie Lake School'},
		{value: 'McKenzie Towne School', text: 'McKenzie Towne School'},
		{value: 'Midnapore School', text: 'Midnapore School'},
		{value: 'MidSun School', text: 'MidSun School'},
		{value: 'Monterey Park School', text: 'Monterey Park School'},
		{value: 'Mount Royal School', text: 'Mount Royal School'},
		{value: 'Mount View School', text: 'Mount View School'},
		{value: 'Mountain Park School', text: 'Mountain Park School'},
		{value: 'National Sport School', text: 'National Sport School'},
		{value: 'Nellie McClung School', text: 'Nellie McClung School'},
		{value: 'Nelson Mandela High School', text: 'Nelson Mandela High School'},
		{value: 'New Brighton School', text: 'New Brighton School'},
		{value: 'Nickle School', text: 'Nickle School'},
		{value: 'Niitsitapi Learning Centre', text: 'Niitsitapi Learning Centre'},
		{value: 'North Haven School', text: 'North Haven School'},
		{value: 'Northern Lights School', text: 'Northern Lights School'},
		{value: 'Nose Creek School', text: 'Nose Creek School'},
		{value: 'O.S. Geiger School', text: 'O.S. Geiger School'},
		{value: 'Olympic Heights School', text: 'Olympic Heights School'},
		{value: 'Panorama Hills School', text: 'Panorama Hills School'},
		{value: 'Patrick Airlie School', text: 'Patrick Airlie School'},
		{value: 'Penbrooke Meadows School', text: 'Penbrooke Meadows School'},
		{value: 'Peter Lougheed School', text: 'Peter Lougheed School'},
		{value: 'Piitoayis Family School', text: 'Piitoayis Family School'},
		{value: 'Pineridge School', text: 'Pineridge School'},
		{value: 'Prince Of Wales School', text: 'Prince Of Wales School'},
		{value: 'Queen Elizabeth High School', text: 'Queen Elizabeth High School'},
		{value: 'Queen Elizabeth School', text: 'Queen Elizabeth School'},
		{value: 'R.T. Alderman School', text: 'R.T. Alderman School'},
		{value: 'Radisson Park School', text: 'Radisson Park School'},
		{value: 'Ramsay School', text: 'Ramsay School'},
		{value: 'Ranchlands School', text: 'Ranchlands School'},
		{value: 'Richmond School', text: 'Richmond School'},
		{value: 'Rideau Park School', text: 'Rideau Park School'},
		{value: 'Riverbend School', text: 'Riverbend School'},
		{value: 'Robert Thirsk High School', text: 'Robert Thirsk High School'},
		{value: 'Robert Warren School', text: 'Robert Warren School'},
		{value: 'Roland Michener School', text: 'Roland Michener School'},
		{value: 'Ron Southern School', text: 'Ron Southern School'},
		{value: 'Rosedale School', text: 'Rosedale School'},
		{value: 'Rosemont School', text: 'Rosemont School'},
		{value: 'Rosscarrock School', text: 'Rosscarrock School'},
		{value: 'Royal Oak School', text: 'Royal Oak School'},
		{value: 'Rundle School', text: 'Rundle School'},
		{value: 'Saddle Ridge School', text: 'Saddle Ridge School'},
		{value: 'Sam Livingston School', text: 'Sam Livingston School'},
		{value: 'Samuel W. Shaw School', text: 'Samuel W. Shaw School'},
		{value: 'Scenic Acres School', text: 'Scenic Acres School'},
		{value: 'Senator Patrick Burns School', text: 'Senator Patrick Burns School'},
		{value: 'Sherwood School', text: 'Sherwood School'},
		{value: 'Sibylla Kiddle School', text: 'Sibylla Kiddle School'},
		{value: 'Silver Springs School', text: 'Silver Springs School'},
		{value: 'Simon Fraser School', text: 'Simon Fraser School'},
		{value: 'Simons Valley School', text: 'Simons Valley School'},
		{value: 'Sir John A. Macdonald School', text: 'Sir John A. Macdonald School'},
		{value: 'Sir John Franklin School', text: 'Sir John Franklin School'},
		{value: 'Sir Wilfrid Laurier School', text: 'Sir Wilfrid Laurier School'},
		{value: 'Sir Winston Churchill High School', text: 'Sir Winston Churchill High School'},
		{value: 'Somerset School', text: 'Somerset School'},
		{value: 'Stanley Jones School', text: 'Stanley Jones School'},
		{value: 'START Outreach', text: 'START Outreach'},
		{value: 'Sunalta School', text: 'Sunalta School'},
		{value: 'Sundance School', text: 'Sundance School'},
		{value: 'Sunnyside School', text: 'Sunnyside School'},
		{value: 'Taradale School', text: 'Taradale School'},
		{value: 'Ted Harrison School', text: 'Ted Harrison School'},
		{value: 'Terrace Road School', text: 'Terrace Road School'},
		{value: 'Terry Fox School', text: 'Terry Fox School'},
		{value: 'Thomas B. Riley School', text: 'Thomas B. Riley School'},
		{value: 'Thorncliffe School', text: 'Thorncliffe School'},
		{value: 'Tom Baines School', text: 'Tom Baines School'},
		{value: 'Tuscany School', text: 'Tuscany School'},
		{value: 'Twelve Mile Coulee School', text: 'Twelve Mile Coulee School'},
		{value: 'University School', text: 'University School'},
		{value: 'Valley Creek School', text: 'Valley Creek School'},
		{value: 'Valley View School', text: 'Valley View School'},
		{value: 'Varsity Acres School', text: 'Varsity Acres School'},
		{value: 'Vincent Massey School', text: 'Vincent Massey School'},
		{value: 'Vista Heights School', text: 'Vista Heights School'},
		{value: 'W.O. Mitchell School', text: 'W.O. Mitchell School'},
		{value: 'West Dalhousie School', text: 'West Dalhousie School'},
		{value: 'West Dover School', text: 'West Dover School'},
		{value: 'West Ridge School', text: 'West Ridge School'},
		{value: 'West Springs School', text: 'West Springs School'},
		{value: 'West View School', text: 'West View School'},
		{value: 'Westbrook Outreach', text: 'Westbrook Outreach'},
		{value: 'Western Canada High School', text: 'Western Canada High School'},
		{value: 'Westgate School', text: 'Westgate School'},
		{value: 'Wildwood School', text: 'Wildwood School'},
		{value: 'William Aberhart High School', text: 'William Aberhart High School'},
		{value: 'William D. Pratt School', text: 'William D. Pratt School'},
		{value: 'William Reid School', text: 'William Reid School'},
		{value: 'William Roper Hull School', text: 'William Roper Hull School'},
		{value: 'Willow Park School', text: 'Willow Park School'},
		{value: 'Wilma Hansen School', text: 'Wilma Hansen School'},
		{value: 'Wood\'s Homes - William Taylor Learning Centre', text: 'Wood\'s Homes - William Taylor Learning Centre'},
		{value: 'Woodbine School', text: 'Woodbine School'},
		{value: 'Woodlands School', text: 'Woodlands School'},
		{value: 'Woodman School', text: 'Woodman School'},
		{value: 'Young Adult Program / Adolescent Day Treatment Pro', text: 'Young Adult Program / Adolescent Day Treatment Pro'},
	],
    'Wolf Creek Public Schools': [
		{value: 'Alix Colony School', text: 'Alix Colony School'},
		{value: 'Alix-MAC School', text: 'Alix-MAC School'},
		{value: 'Bentley Colony School', text: 'Bentley Colony School'},
		{value: 'Bentley School', text: 'Bentley School'},
		{value: 'Bluffon School', text: 'Bluffon School'},
		{value: 'BRICK Learning Centre', text: 'BRICK Learning Centre'},
		{value: 'Centennial Centre Patient\'s School', text: 'Centennial Centre Patient\'s School'},
		{value: 'Clive School', text: 'Clive School'},
		{value: 'Crestomere School', text: 'Crestomere School'},
		{value: 'Eckville Elementary School', text: 'Eckville Elementary School'},
		{value: 'Eckville Jr/Sr High School', text: 'Eckville Jr/Sr High School'},
		{value: 'École James S. McCormick School', text: 'École James S. McCormick School'},
		{value: 'École Lacombe Junior High School', text: 'École Lacombe Junior High School'},
		{value: 'École Lacombe Upper Elementary School', text: 'École Lacombe Upper Elementary School'},
		{value: 'École Secondaire Lacombe Composite High School', text: 'École Secondaire Lacombe Composite High School'},
		{value: 'Ferrybank Colony School', text: 'Ferrybank Colony School'},
		{value: 'Iron Ridge Elementary Campus', text: 'Iron Ridge Elementary Campus'},
		{value: 'Iron Ridge Intermediate Campus', text: 'Iron Ridge Intermediate Campus'},
		{value: 'Iron Ridge Junior Campus', text: 'Iron Ridge Junior Campus'},
		{value: 'Lacombe Outreach School', text: 'Lacombe Outreach School'},
		{value: 'Leedale Colony School', text: 'Leedale Colony School'},
		{value: 'Mecca Glen School', text: 'Mecca Glen School'},
		{value: 'Pleasant Valley Colony School', text: 'Pleasant Valley Colony School'},
		{value: 'Ponoka Elementary School', text: 'Ponoka Elementary School'},
		{value: 'Ponoka Secondary Campus', text: 'Ponoka Secondary Campus'},
		{value: 'Rimbey Elementary School', text: 'Rimbey Elementary School'},
		{value: 'Rimbey Junior Senior High School', text: 'Rimbey Junior Senior High School'},
		{value: 'Terrace Ridge School', text: 'Terrace Ridge School'},
		{value: 'West Country Outreach School', text: 'West Country Outreach School'},
		{value: 'Wolf Creek Academy', text: 'Wolf Creek Academy'},
	],
    'Wild Rose School Divison': [
		{value: 'Aurora Elementary School', text: 'Aurora Elementary School'},
		{value: 'Breton Elementary School', text: 'Breton Elementary School'},
		{value: 'Breton High School', text: 'Breton High School'},
		{value: 'Caroline School', text: 'Caroline School'},
		{value: 'Condor School', text: 'Condor School'},
		{value: 'David Thompson High School', text: 'David Thompson High School'},
		{value: 'Drayton Christian School', text: 'Drayton Christian School'},
		{value: 'Drayton Valley Community Outreach School', text: 'Drayton Valley Community Outreach School'},
		{value: 'École Rocky Elementary', text: 'École Rocky Elementary'},
		{value: 'Evergreen Elementary School', text: 'Evergreen Elementary School'},
		{value: 'Frank Maddock High School', text: 'Frank Maddock High School'},
		{value: 'H.W. Pickup School', text: 'H.W. Pickup School'},
		{value: 'Lochearn Elementary School', text: 'Lochearn Elementary School'},
		{value: 'Pioneer Middle School', text: 'Pioneer Middle School'},
		{value: 'Rocky Christian School', text: 'Rocky Christian School'},
		{value: 'Visions West Outreach School', text: 'Visions West Outreach School'},
		{value: 'West Central High School', text: 'West Central High School'},
	],
    'Wetaskiwin School Division': [
		{value: 'Alder Flats Elementary School', text: 'Alder Flats Elementary School'},
		{value: 'Buck Mountain Central School', text: 'Buck Mountain Central School'},
		{value: 'C.B. McMurdo School - Wetaskiwin Outreach', text: 'C.B. McMurdo School - Wetaskiwin Outreach'},
		{value: 'Centennial School', text: 'Centennial School'},
		{value: 'Clear Vista School', text: 'Clear Vista School'},
		{value: 'Falun Elementary School', text: 'Falun Elementary School'},
		{value: 'Griffiths-Scott School', text: 'Griffiths-Scott School'},
		{value: 'Gwynne School', text: 'Gwynne School'},
		{value: 'Lakedell School', text: 'Lakedell School'},
		{value: 'Lynn Lauren Early Education School', text: 'Lynn Lauren Early Education School'},
		{value: 'Norwood School', text: 'Norwood School'},
		{value: 'Parkdale School', text: 'Parkdale School'},
		{value: 'Pigeon Lake Regional School', text: 'Pigeon Lake Regional School'},
		{value: 'Pine Haven Colony School', text: 'Pine Haven Colony School'},
		{value: 'Pipestone School', text: 'Pipestone School'},
		{value: 'Queen Elizabeth School', text: 'Queen Elizabeth School'},
		{value: 'Silver Creek Colony School', text: 'Silver Creek Colony School'},
		{value: 'Wetaskiwin Composite High School', text: 'Wetaskiwin Composite High School'},
		{value: 'Winfield School', text: 'Winfield School'},
	],
    'Westwind School Division': [
		{value: 'Cardston Elementary School', text: 'Cardston Elementary School'},
		{value: 'Cardston High School', text: 'Cardston High School'},
		{value: 'Cardston Junior High School', text: 'Cardston Junior High School'},
		{value: 'Colony Education', text: 'Colony Education'},
		{value: 'Magrath Elementary School', text: 'Magrath Elementary School'},
		{value: 'Magrath High School', text: 'Magrath High School'},
		{value: 'Mountain View School', text: 'Mountain View School'},
		{value: 'Raymond Elementary School', text: 'Raymond Elementary School'},
		{value: 'Raymond High School', text: 'Raymond High School'},
		{value: 'Raymond Junior High School', text: 'Raymond Junior High School'},
		{value: 'Spring Glen Elementary School', text: 'Spring Glen Elementary School'},
		{value: 'Spring Glen Junior High School', text: 'Spring Glen Junior High School'},
		{value: 'Stirling School', text: 'Stirling School'},
		{value: 'Westwind Alternate School', text: 'Westwind Alternate School'},
	],
    'St Paul\'s Education': [
		{value: 'Ashmont Elementary School', text: 'Ashmont Elementary School'},
		{value: 'Ashmont Secondary School', text: 'Ashmont Secondary School'},
		{value: 'École Elementaire St. Paul Elementary School', text: 'École Elementaire St. Paul Elementary School'},
		{value: 'École Mallaig Community School', text: 'École Mallaig Community School'},
		{value: 'École Racette Junior High School', text: 'École Racette Junior High School'},
		{value: 'Elk Point Elementary School', text: 'Elk Point Elementary School'},
		{value: 'Elk Point Outreach School', text: 'Elk Point Outreach School'},
		{value: 'F.G. Miller Jr/Sr High School', text: 'F.G. Miller Jr/Sr High School'},
		{value: 'Glen Avon School', text: 'Glen Avon School'},
		{value: 'Hairy Hill Colony School', text: 'Hairy Hill Colony School'},
		{value: 'Heinsburg Community School', text: 'Heinsburg Community School'},
		{value: 'Myrnam Outreach and Home Education Centre', text: 'Myrnam Outreach and Home Education Centre'},
		{value: 'New Myrnam School', text: 'New Myrnam School'},
		{value: 'Plain Lake Colony School', text: 'Plain Lake Colony School'},
		{value: 'St. Paul Alternate Education Centre (SPAEC)', text: 'St. Paul Alternate Education Centre (SPAEC)'},
		{value: 'St. Paul Regional High School', text: 'St. Paul Regional High School'},
		{value: 'Two Hills School', text: 'Two Hills School'},
		{value: 'Two Hills Mennonite School', text: 'Two Hills Mennonite School'},
	],
    'Praire Rose School Division': [
		{value: 'IF Cox School', text: 'IF Cox School'},
		{value: 'Margaret Wooding School', text: 'Margaret Wooding School'},
		{value: 'Parkside Jr High School', text: 'Parkside Jr High School'},
		{value: 'Eagle Butte High School', text: 'Eagle Butte High School'},
		{value: 'Prairie Mennonite Alternative School', text: 'Prairie Mennonite Alternative School'},
		{value: 'Seven Persons School', text: 'Seven Persons School'},
		{value: 'Irvine School', text: 'Irvine School'},
		{value: 'Schuler School', text: 'Schuler School'},
		{value: 'Ralston School', text: 'Ralston School'},
		{value: 'Jenner School', text: 'Jenner School'},
		{value: 'Bow Island Elementary School', text: 'Bow Island Elementary School'},
		{value: 'Burdett School', text: 'Burdett School'},
		{value: 'Senator Gershaw School', text: 'Senator Gershaw School'},
		{value: 'New Brigden School', text: 'New Brigden School'},
		{value: 'Oyen Public School', text: 'Oyen Public School'},
		{value: 'Warren Peers School', text: 'Warren Peers School'},
		{value: 'South Central High School', text: 'South Central High School'},
		{value: 'Foremost School', text: 'Foremost School'},
		{value: 'Coulee Collegiate', text: 'Coulee Collegiate'},
		{value: 'Prairie Rose Colony Schools', text: 'Prairie Rose Colony Schools'},
	],
    'Prairie Land School Division': [
		{value: 'Altario School', text: 'Altario School'},
		{value: 'Berry Creek Community School', text: 'Berry Creek Community School'},
		{value: 'Consort School', text: 'Consort School'},
		{value: 'Delia School', text: 'Delia School'},
		{value: 'Hope Christian School', text: 'Hope Christian School'},
		{value: 'J.C.Charyk School', text: 'J.C.Charyk School'},
		{value: 'Morrin School', text: 'Morrin School'},
		{value: 'Prairie Land Online School', text: 'Prairie Land Online School'},
		{value: 'Prairie Land Outreach School', text: 'Prairie Land Outreach School'},
		{value: 'Veteran School', text: 'Veteran School'},
		{value: 'Youngstown School', text: 'Youngstown School'},
		{value: 'Colonies of Hutterian Brethren', text: 'Colonies of Hutterian Brethren'},
	],
    'Peace Wapiti School Division': [
		{value: 'Alternative Education Program', text: 'Alternative Education Program'},
		{value: 'Beaverlodge Elementary', text: 'Beaverlodge Elementary'},
		{value: 'Beaverlodge Regional High', text: 'Beaverlodge Regional High'},
		{value: 'Bezanson School', text: 'Bezanson School'},
		{value: 'Bonanza School', text: 'Bonanza School'},
		{value: 'Clairmont Community School', text: 'Clairmont Community School'},
		{value: 'Eaglesham School', text: 'Eaglesham School'},
		{value: 'Elmworth School', text: 'Elmworth School'},
		{value: 'Harry Balfour School', text: 'Harry Balfour School'},
		{value: 'Helen E. Taylor School', text: 'Helen E. Taylor School'},
		{value: 'Hythe Regional School', text: 'Hythe Regional School'},
		{value: 'LaGlace School', text: 'LaGlace School'},
		{value: 'Peace Wapiti Academy', text: 'Peace Wapiti Academy'},
		{value: 'Penson School', text: 'Penson School'},
		{value: 'Ridgevalley School', text: 'Ridgevalley School'},
		{value: 'Robert W. Zahara', text: 'Robert W. Zahara'},
		{value: 'Rycroft School', text: 'Rycroft School'},
		{value: 'Savanna School', text: 'Savanna School'},
		{value: 'Sexsmith Secondary School', text: 'Sexsmith Secondary School'},
		{value: 'Spirit River Regional Academy', text: 'Spirit River Regional Academy'},
		{value: 'Teepee Creek School', text: 'Teepee Creek School'},
		{value: 'Wembley Elementary School', text: 'Wembley Elementary School'},
		{value: 'Whispering Ridge Community School', text: 'Whispering Ridge Community School'},
		{value: 'Woking School', text: 'Woking School'},
		{value: 'Hutterite Colony Schools', text: 'Hutterite Colony Schools'},
	],
    'Peace River School Division': [
		{value: 'Dixonville School', text: 'Dixonville School'},
		{value: 'EE Oliver Elementary School', text: 'EE Oliver Elementary School'},
		{value: 'Fairview Jr./Sr. High School', text: 'Fairview Jr./Sr. High School'},
		{value: 'Fairview Learning Store', text: 'Fairview Learning Store'},
		{value: 'Grimshaw Public School', text: 'Grimshaw Public School'},
		{value: 'Hines Creek Composite', text: 'Hines Creek Composite'},
		{value: 'Lloyd Garrison School', text: 'Lloyd Garrison School'},
		{value: 'Manning Elementary School', text: 'Manning Elementary School'},
		{value: 'Menno Simons Community School', text: 'Menno Simons Community School'},
		{value: 'Nampa Public School', text: 'Nampa Public School'},
		{value: 'Paul Rowe Jr./Sr. High School', text: 'Paul Rowe Jr./Sr. High School'},
		{value: 'Peace River High School', text: 'Peace River High School'},
		{value: 'Peace Regional Outreach Campus', text: 'Peace Regional Outreach Campus'},
		{value: 'Red Earth Creek School', text: 'Red Earth Creek School'},
		{value: 'Springfield School, École', text: 'Springfield School, École'},
		{value: 'TA Norris Middle School', text: 'TA Norris Middle School'},
		{value: 'Worsley Central School', text: 'Worsley Central School'},
		{value: 'Peace Home Learning Connection', text: 'Peace Home Learning Connection'},
		{value: 'Cleardale Colony School', text: 'Cleardale Colony School'},
		{value: 'Breaking Point Colony School', text: 'Breaking Point Colony School'},
		{value: 'Bear Canyon Colony School', text: 'Bear Canyon Colony School'},
	],
    'Parkland School Division': [
		{value: 'Brookwood School', text: 'Brookwood School'},
		{value: 'École Broxton Park School', text: 'École Broxton Park School'},
		{value: 'Copperhaven School', text: 'Copperhaven School'},
		{value: 'Graminia School', text: 'Graminia School'},
		{value: 'Greystone Centennial Middle School', text: 'Greystone Centennial Middle School'},
		{value: 'Millgrove School', text: 'Millgrove School'},
		{value: 'Parkland Village School', text: 'Parkland Village School'},
		{value: 'Prescott Learning Centre', text: 'Prescott Learning Centre'},
		{value: 'Spruce Grove Composite High School', text: 'Spruce Grove Composite High School'},
		{value: 'Woodhaven Middle School', text: 'Woodhaven Middle School'},
		{value: 'Blueberry School', text: 'Blueberry School'},
		{value: 'Connections for Learning', text: 'Connections for Learning'},
		{value: 'Forest Green School', text: 'Forest Green School'},
		{value: 'High Park School', text: 'High Park School'},
		{value: 'Memorial Composite High School', text: 'Memorial Composite High School'},
		{value: 'École Meridian Heights School', text: 'École Meridian Heights School'},
		{value: 'Muir Lake School', text: 'Muir Lake School'},
		{value: 'Stony Plain Central School', text: 'Stony Plain Central School'},
		{value: 'Duffield School', text: 'Duffield School'},
		{value: 'Entwistle School', text: 'Entwistle School'},
		{value: 'Tomahawk School', text: 'Tomahawk School'},
		{value: 'Wabumun School', text: 'Wabumun School'},
	],
    'Palliser School Division': [
		{value: 'Arrowwood Community School', text: 'Arrowwood Community School'},
		{value: 'Barons School', text: 'Barons School'},
		{value: 'Brant Christian School', text: 'Brant Christian School'},
		{value: 'Calgary Christian School', text: 'Calgary Christian School'},
		{value: 'Calgary Islamic School AJ', text: 'Calgary Islamic School AJ'},
		{value: 'Calgary Islamic School OBK', text: 'Calgary Islamic School OBK'},
		{value: 'Carmangay Outreach School', text: 'Carmangay Outreach School'},
		{value: 'Champion School', text: 'Champion School'},
		{value: 'Coalhurst Elementary School', text: 'Coalhurst Elementary School'},
		{value: 'Coalhurst High School', text: 'Coalhurst High School'},
		{value: 'County Central High School', text: 'County Central High School'},
		{value: 'Dorothy Dalgliesh School', text: 'Dorothy Dalgliesh School'},
		{value: 'Heritage Christian Academy', text: 'Heritage Christian Academy'},
		{value: 'Home Education', text: 'Home Education'},
		{value: 'Horizon Leadership Academy', text: 'Horizon Leadership Academy'},
		{value: 'Huntsville School', text: 'Huntsville School'},
		{value: 'Hutterite Colony Schools', text: 'Hutterite Colony Schools'},
		{value: 'Jennie Emery Elementary School', text: 'Jennie Emery Elementary School'},
		{value: 'John Davidson School', text: 'John Davidson School'},
		{value: 'Kate Andrews High School', text: 'Kate Andrews High School'},
		{value: 'Master\'s Academy and College', text: 'Master\'s Academy and College'},
		{value: 'Menno Simons Christian School', text: 'Menno Simons Christian School'},
		{value: 'Milo Community School', text: 'Milo Community School'},
		{value: 'National Sports School', text: 'National Sports School'},
		{value: 'Noble Central School', text: 'Noble Central School'},
		{value: 'Palliser Beyond Borders', text: 'Palliser Beyond Borders'},
		{value: 'Palliser Beyond Borders at Coaldale', text: 'Palliser Beyond Borders at Coaldale'},
		{value: 'Palliser Beyond Borders at Vulcan', text: 'Palliser Beyond Borders at Vulcan'},
		{value: 'Palliser Off Campus Education', text: 'Palliser Off Campus Education'},
		{value: 'Picture Butte High School', text: 'Picture Butte High School'},
		{value: 'R.I. Baker Middle School', text: 'R.I. Baker Middle School'},
		{value: 'Sunnyside School', text: 'Sunnyside School'},
		{value: 'Trinity Christian School', text: 'Trinity Christian School'},
		{value: 'Vulcan Prairieview Elementary School', text: 'Vulcan Prairieview Elementary School'},
	],
    'Northland School Division': [
		{value: 'Anzac Community School - Bill Woodward School', text: 'Anzac Community School - Bill Woodward School'},
		{value: 'Athabasca Delta Community School', text: 'Athabasca Delta Community School'},
		{value: 'Bishop Routhier School', text: 'Bishop Routhier School'},
		{value: 'Calling Lake School', text: 'Calling Lake School'},
		{value: 'Career Pathways School (Outreach)', text: 'Career Pathways School (Outreach)'},
		{value: 'Chipewyan Lake School', text: 'Chipewyan Lake School'},
		{value: 'Conklin Community School', text: 'Conklin Community School'},
		{value: 'Elizabeth School', text: 'Elizabeth School'},
		{value: 'Father R Perin School', text: 'Father R Perin School'},
		{value: 'Fort McKay School', text: 'Fort McKay School'},
		{value: 'Gift Lake School', text: 'Gift Lake School'},
		{value: 'Grouard Northland School', text: 'Grouard Northland School'},
		{value: 'Hillview School', text: 'Hillview School'},
		{value: 'JF Dion School', text: 'JF Dion School'},
		{value: 'Mistassiniy School', text: 'Mistassiniy School'},
		{value: 'Pddle Prairie School', text: 'Pddle Prairie School'},
		{value: 'Pelican Mountain School', text: 'Pelican Mountain School'},
		{value: 'St.Theresa School', text: 'St.Theresa School'},
		{value: 'Susa Creek School', text: 'Susa Creek School'},
	],
    'Northern Lights School Division': [
		{value: 'Ardmore School', text: 'Ardmore School'},
		{value: 'Art Smith Aviation Academy', text: 'Art Smith Aviation Academy'},
		{value: 'Aurora Middle School', text: 'Aurora Middle School'},
		{value: 'Bonnyville Centralized High School', text: 'Bonnyville Centralized High School'},
		{value: 'Caslan School', text: 'Caslan School'},
		{value: 'Cold Lake Elementary School', text: 'Cold Lake Elementary School'},
		{value: 'Cold Lake High School', text: 'Cold Lake High School'},
		{value: 'Cold Lake Middle School', text: 'Cold Lake Middle School'},
		{value: 'Duclos School', text: 'Duclos School'},
		{value: 'École Plamondon School', text: 'École Plamondon School'},
		{value: 'Glendon School', text: 'Glendon School'},
		{value: 'H.E. Bourgoin School', text: 'H.E. Bourgoin School'},
		{value: 'Iron River School', text: 'Iron River School'},
		{value: 'J.A. Williams High School', text: 'J.A. Williams High School'},
		{value: 'Kikino School', text: 'Kikino School'},
		{value: 'Nelson Heights Middle School', text: 'Nelson Heights Middle School'},
		{value: 'North Star Elementary School', text: 'North Star Elementary School'},
		{value: 'Northern Lights Outreach Schools', text: 'Northern Lights Outreach Schools'},
		{value: 'Trades Exposure Centre', text: 'Trades Exposure Centre'},
		{value: 'Vera M. Welsh Elementary School', text: 'Vera M. Welsh Elementary School'},
		{value: 'Wandering River School', text: 'Wandering River School'},
		{value: 'Bonnyville Outreach School', text: 'Bonnyville Outreach School'},
		{value: 'Cold Lake Outreach School', text: 'Cold Lake Outreach School'},
		{value: 'Crossroads Outreach School', text: 'Crossroads Outreach School'},
		{value: 'Fishing Lake Outreach School', text: 'Fishing Lake Outreach School'},
		{value: 'Journeys Learning Academy', text: 'Journeys Learning Academy'},
		{value: 'Lac La Biche Outreach School', text: 'Lac La Biche Outreach School'},
	],
    'Northern Gateway Public Schools': [
		{value: 'Darwell School', text: 'Darwell School'},
		{value: 'Elmer Elson Elementary School', text: 'Elmer Elson Elementary School'},
		{value: 'Fox Creek School', text: 'Fox Creek School'},
		{value: 'Grasmere School', text: 'Grasmere School'},
		{value: 'Harry Gray Elementary School', text: 'Harry Gray Elementary School'},
		{value: 'Hillside Jr/Sr High School', text: 'Hillside Jr/Sr High School'},
		{value: 'Hilltop Jr/Sr High School', text: 'Hilltop Jr/Sr High School'},
		{value: 'Mayerthorpe Jr/Sr High School', text: 'Mayerthorpe Jr/Sr High School'},
		{value: 'Onoway Elementary School', text: 'Onoway Elementary School'},
		{value: 'Onoway Jr/Sr High School', text: 'Onoway Jr/Sr High School'},
		{value: 'Oscar Adolphson Primary School', text: 'Oscar Adolphson Primary School'},
		{value: 'Pat Hardy Primary School', text: 'Pat Hardy Primary School'},
		{value: 'Percy Baxter Middle School', text: 'Percy Baxter Middle School'},
		{value: 'Rich Valley School', text: 'Rich Valley School'},
		{value: 'Rochfort Bridge Colony School', text: 'Rochfort Bridge Colony School'},
		{value: 'Sangudo Community School', text: 'Sangudo Community School'},
		{value: 'Twilight Colony School', text: 'Twilight Colony School'},
		{value: 'Valleyview Ranch Colony School', text: 'Valleyview Ranch Colony School'},
		{value: 'Whitecourt Central Elementary School', text: 'Whitecourt Central Elementary School'},
	],
    'Livingstone Range School Division': [
		{value: 'A.B. Daley Community School', text: 'A.B. Daley Community School'},
		{value: 'Canyon School', text: 'Canyon School'},
		{value: 'Colony Schools', text: 'Colony Schools'},
		{value: 'Crowsnest Consolidated High School', text: 'Crowsnest Consolidated High School'},
		{value: 'F.P. Walshe School', text: 'F.P. Walshe School'},
		{value: 'Granum School', text: 'Granum School'},
		{value: 'Horace Allen School', text: 'Horace Allen School'},
		{value: 'Isabelle Sellon School', text: 'Isabelle Sellon School'},
		{value: 'J.T. Foster High School', text: 'J.T. Foster High School'},
		{value: 'Livingstone School', text: 'Livingstone School'},
		{value: 'Livingstone Ski Academy', text: 'Livingstone Ski Academy'},
		{value: 'LRSD Pursuits Virtual School', text: 'LRSD Pursuits Virtual School'},
		{value: 'Matthew Halton High School', text: 'Matthew Halton High School'},
		{value: 'MHHS Gateway School', text: 'MHHS Gateway School'},
		{value: 'Stavely School', text: 'Stavely School'},
		{value: 'W.A. Day Elementary School', text: 'W.A. Day Elementary School'},
		{value: 'Walshe Crossroads Campus Outreach Program', text: 'Walshe Crossroads Campus Outreach Program'},
		{value: 'West Meadow Elementary School', text: 'West Meadow Elementary School'},
		{value: 'Willow Creek Composite High School', text: 'Willow Creek Composite High School'},
	],
    'Living Waters School Division': [
		{value: 'Holy Redeemer High', text: 'Holy Redeemer High'},
		{value: 'St. Francis of Assisi', text: 'St. Francis of Assisi'},
		{value: 'École St. Joseph', text: 'École St. Joseph'},
		{value: 'St. Mary of the Lake', text: 'St. Mary of the Lake'},
		{value: 'École St. Mary', text: 'École St. Mary'},
		{value: 'Vanier Community Catholic School', text: 'Vanier Community Catholic School'},
		{value: 'Across the Waters Outreach', text: 'Across the Waters Outreach'},
	],
    'Lakeland Catholic School District': [
		{value: 'Lakeland Catholic Online Learning (LCOL)', text: 'Lakeland Catholic Online Learning (LCOL)'},
		{value: 'Holy Cross Elementary School', text: 'Holy Cross Elementary School'},
		{value: 'St. Dominic Elementary School', text: 'St. Dominic Elementary School'},
		{value: 'Assumption Junior/Senior High School', text: 'Assumption Junior/Senior High School'},
		{value: 'École Notre Dame Elementary School', text: 'École Notre Dame Elementary School'},
		{value: 'École Dr. Bernard Brosseau Middle School', text: 'École Dr. Bernard Brosseau Middle School'},
		{value: 'École Notre Dame High School', text: 'École Notre Dame High School'},
		{value: 'Light of Christ Catholic School', text: 'Light of Christ Catholic School'},
		{value: 'Holy Family Catholic School', text: 'Holy Family Catholic School'},
	],
    'Horizon School Division': [
		{value: 'ACE Place Learning Centre', text: 'ACE Place Learning Centre'},
		{value: 'Arden T. Litt Centre for Learning', text: 'Arden T. Litt Centre for Learning'},
		{value: 'Barnwell School', text: 'Barnwell School'},
		{value: 'Central Elementary School', text: 'Central Elementary School'},
		{value: 'Chamberlain School', text: 'Chamberlain School'},
		{value: 'D.A. Ferguson Middle School', text: 'D.A. Ferguson Middle School'},
		{value: 'Dr. Hamman Elementary School', text: 'Dr. Hamman Elementary School'},
		{value: 'Enchant School', text: 'Enchant School'},
		{value: 'Erle Rivers High School', text: 'Erle Rivers High School'},
		{value: 'Hays School', text: 'Hays School'},
		{value: 'Horizon Colony Schools', text: 'Horizon Colony Schools'},
		{value: 'Horizon MAP School', text: 'Horizon MAP School'},
		{value: 'L.T. Westlake Fine Arts Elementary School', text: 'L.T. Westlake Fine Arts Elementary School'},
		{value: 'Lomond Community School', text: 'Lomond Community School'},
		{value: 'Milk River Elementary School', text: 'Milk River Elementary School'},
		{value: 'Taber Christian High School', text: 'Taber Christian High School'},
		{value: 'Taber Christian School', text: 'Taber Christian School'},
		{value: 'Taber Mennonite School', text: 'Taber Mennonite School'},
		{value: 'Vauxhall Elementary School', text: 'Vauxhall Elementary School'},
		{value: 'Vauxhall High School', text: 'Vauxhall High School'},
		{value: 'W.R. Myers High School', text: 'W.R. Myers High School'},
		{value: 'Warner School', text: 'Warner School'},
		{value: 'Armada Colony School', text: 'Armada Colony School'},
		{value: 'Bluegrass Colony School', text: 'Bluegrass Colony School'},
		{value: 'Cameron Farms Colony School', text: 'Cameron Farms Colony School'},
		{value: 'Copperfield Farms Colony School', text: 'Copperfield Farms Colony School'},
		{value: 'Delco Colony School', text: 'Delco Colony School'},
		{value: 'Elmspring Colony School', text: 'Elmspring Colony School'},
		{value: 'Enchant Colony School', text: 'Enchant Colony School'},
		{value: 'Evergreen Colony School', text: 'Evergreen Colony School'},
		{value: 'Fairlane Colony School', text: 'Fairlane Colony School'},
		{value: 'Gold Spring Colony School', text: 'Gold Spring Colony School'},
		{value: 'Hillridge Colony School', text: 'Hillridge Colony School'},
		{value: 'Kingsland Colony School', text: 'Kingsland Colony School'},
		{value: 'Lomond Colony School', text: 'Lomond Colony School'},
		{value: 'Midland Colony School', text: 'Midland Colony School'},
		{value: 'Miltow Colony School', text: 'Miltow Colony School'},
		{value: 'Oaklane Colony School', text: 'Oaklane Colony School'},
		{value: 'Prairie Home Colony School', text: 'Prairie Home Colony School'},
		{value: 'River Road Colony School', text: 'River Road Colony School'},
		{value: 'Sunnysite Colony School', text: 'Sunnysite Colony School'},
	],
    'Holy Family Catholic Regional Division': [
		{value: 'École Providence School', text: 'École Providence School'},
		{value: 'Glenmary School', text: 'Glenmary School'},
		{value: 'Good Shepherd School', text: 'Good Shepherd School'},
		{value: 'Holy Family CyberHigh', text: 'Holy Family CyberHigh'},
		{value: 'Holy Family School', text: 'Holy Family School'},
		{value: 'Rosary School', text: 'Rosary School'},
		{value: 'St.Andrew\'s School', text: 'St.Andrew\'s School'},
		{value: 'St.Francis School', text: 'St.Francis School'},
		{value: 'St.Stephen\'s School', text: 'St.Stephen\'s School'},
	],
    'High Prairie School Division': [
		{value: 'École Routhier School', text: 'École Routhier School'},
		{value: 'Georges P. Vanier School', text: 'Georges P. Vanier School'},
		{value: 'High Prairie Elementary School', text: 'High Prairie Elementary School'},
		{value: 'Prairie River Junior High School', text: 'Prairie River Junior High School'},
		{value: 'E.W. Pratt High School', text: 'E.W. Pratt High School'},
		{value: 'Prairie View Outreach School', text: 'Prairie View Outreach School'},
		{value: 'Joussard School', text: 'Joussard School'},
		{value: 'Kinuso School', text: 'Kinuso School'},
		{value: 'Kinuso Outreach School', text: 'Kinuso Outreach School'},
		{value: 'C.J. Schurter School', text: 'C.J. Schurter School'},
		{value: 'E.G. Wahlstrom School', text: 'E.G. Wahlstrom School'},
		{value: 'Roland Michener Secondary School', text: 'Roland Michener Secondary School'},
		{value: 'Lakeside Outreach School', text: 'Lakeside Outreach School'},
	],
    'Grasslands School Division': [
		{value: 'Alcome School', text: 'Alcome School'},
		{value: 'Bassano School', text: 'Bassano School'},
		{value: 'Brooks Composite High School', text: 'Brooks Composite High School'},
		{value: 'Brooks Jr High School', text: 'Brooks Jr High School'},
		{value: 'Bow City Colony', text: 'Bow City Colony'},
		{value: 'Clearview Colony', text: 'Clearview Colony'},
		{value: 'Fairville Colony', text: 'Fairville Colony'},
		{value: 'Lathom Colony', text: 'Lathom Colony'},
		{value: 'Newell Colony', text: 'Newell Colony'},
		{value: 'Springside Colony', text: 'Springside Colony'},
		{value: 'Springview Colony', text: 'Springview Colony'},
		{value: 'Duchess School', text: 'Duchess School'},
		{value: 'Eastbrook School', text: 'Eastbrook School'},
		{value: 'Gem School', text: 'Gem School'},
		{value: 'Griffin Park School', text: 'Griffin Park School'},
		{value: 'Rolling Hills School', text: 'Rolling Hills School'},
		{value: 'Rosemary School', text: 'Rosemary School'},
		{value: 'Sunrise School', text: 'Sunrise School'},
		{value: 'Tilley School', text: 'Tilley School'},
		{value: 'Uplands School', text: 'Uplands School'},
	],
    'Greater St Albert Catholic Schools': [
		{value: 'Albert Lacombe Catholic Elementary School', text: 'Albert Lacombe Catholic Elementary School'},
		{value: 'Neil M Ross Catholic Elementary School', text: 'Neil M Ross Catholic Elementary School'},
		{value: 'Bertha Kennedy Catholic Elementary School', text: 'Bertha Kennedy Catholic Elementary School'},
		{value: 'Richards S Fowler Catholic JR High School', text: 'Richards S Fowler Catholic JR High School'},
		{value: 'École Father Jan', text: 'École Father Jan'},
		{value: 'Sister Alphonse Academy', text: 'Sister Alphonse Academy'},
		{value: 'École Marie Poburan Elementary School', text: 'École Marie Poburan Elementary School'},
		{value: 'St. Gabriel Education Centre', text: 'St. Gabriel Education Centre'},
		{value: 'École Secondaire St. Albert Catholic High School', text: 'École Secondaire St. Albert Catholic High School'},
		{value: 'École Secondaire Sainte Marguerite D\'Youville Jr High', text: 'École Secondaire Sainte Marguerite D\'Youville Jr High'},
		{value: 'JJ Nearing Catholic Elementary School', text: 'JJ Nearing Catholic Elementary School'},
		{value: 'Vincent J Maloney Catholic Jr High', text: 'Vincent J Maloney Catholic Jr High'},
		{value: 'Vital Grandin Catholic Elementary School', text: 'Vital Grandin Catholic Elementary School'},
	],
    'Grande Yellowhead Public School Division': [
		{value: 'Crescent Valley Elementary School', text: 'Crescent Valley Elementary School'},
		{value: 'École Mountain View School', text: 'École Mountain View School'},
		{value: 'École Pine Grove Middle School', text: 'École Pine Grove Middle School'},
		{value: 'École Westhaven School', text: 'École Westhaven School'},
		{value: 'Evansview School', text: 'Evansview School'},
		{value: 'Fulham School', text: 'Fulham School'},
		{value: 'Grand Trunk High School', text: 'Grand Trunk High School'},
		{value: 'Grande Cache Community High School', text: 'Grande Cache Community High School'},
		{value: 'Harry Collinge High School', text: 'Harry Collinge High School'},
		{value: 'Jasper Elementary School', text: 'Jasper Elementary School'},
		{value: 'Jasper Junior/Senior High School', text: 'Jasper Junior/Senior High School'},
		{value: 'Mary Bergeron Elementary', text: 'Mary Bergeron Elementary'},
		{value: 'Niton Central School', text: 'Niton Central School'},
		{value: 'Palisades Stewardship Education Centre', text: 'Palisades Stewardship Education Centre'},
		{value: 'Parkland Composite High School', text: 'Parkland Composite High School'},
		{value: 'Sheldon Coates Elementary School', text: 'Sheldon Coates Elementary School'},
		{value: 'Summitview School', text: 'Summitview School'},
		{value: 'Virtual Learning', text: 'Virtual Learning'},
		{value: 'Wildwood School', text: 'Wildwood School'},
	],
    'Golden Hills School Division': [
		{value: 'Golden Hills International Program', text: 'Golden Hills International Program'},
		{value: 'Acme School', text: 'Acme School'},
		{value: 'Carbon School', text: 'Carbon School'},
		{value: 'Dr. Elliott School', text: 'Dr. Elliott School'},
		{value: 'Three Hills School', text: 'Three Hills School'},
		{value: 'Prairie Christian Academy', text: 'Prairie Christian Academy'},
		{value: 'Trochu Valley School', text: 'Trochu Valley School'},
		{value: 'Wheatland Crossing School', text: 'Wheatland Crossing School'},
		{value: 'Greentree Elementary School', text: 'Greentree Elementary School'},
		{value: 'Drumheller Valley Secondary School', text: 'Drumheller Valley Secondary School'},
		{value: 'Drumheller Outreach', text: 'Drumheller Outreach'},
		{value: 'École Brentwood Elementary', text: 'École Brentwood Elementary'},
		{value: 'Carseland School', text: 'Carseland School'},
		{value: 'Crowther Memorial Junior High School', text: 'Crowther Memorial Junior High School'},
		{value: 'George Freeman School', text: 'George Freeman School'},
		{value: 'Strathmore High School', text: 'Strathmore High School'},
		{value: 'Strathmore StoreFront School', text: 'Strathmore StoreFront School'},
		{value: 'Trinity Christian Academy', text: 'Trinity Christian Academy'},
		{value: 'Westmount School', text: 'Westmount School'},
		{value: 'Wheatland Elementary School', text: 'Wheatland Elementary School'},
		{value: 'Golden Hills Learning Academy', text: 'Golden Hills Learning Academy'},
		{value: 'NorthStar Academy', text: 'NorthStar Academy'},
		{value: 'Britestone School/Britestone Colony', text: 'Britestone School/Britestone Colony'},
		{value: 'Crawling Valley School/Ridgeland Colony', text: 'Crawling Valley School/Ridgeland Colony'},
		{value: 'Glenrose School/Wheatland Colony', text: 'Glenrose School/Wheatland Colony'},
		{value: 'Green Acres School/Green Acres Colony', text: 'Green Acres School/Green Acres Colony'},
		{value: 'Hines School/Stahlville Colony', text: 'Hines School/Stahlville Colony'},
		{value: 'Huxley School/Huxley Colony', text: 'Huxley School/Huxley Colony'},
		{value: 'Mountainview School/Mountainview Colony', text: 'Mountainview School/Mountainview Colony'},
		{value: 'Poplar Row School/Standard Colony', text: 'Poplar Row School/Standard Colony'},
		{value: 'Rising Sun School/Sunshine Colony', text: 'Rising Sun School/Sunshine Colony'},
		{value: 'Rosebud Creek Colony School/Hillview Colony', text: 'Rosebud Creek Colony School/Hillview Colony'},
		{value: 'Rosebud River School/Springvale Colony', text: 'Rosebud River School/Springvale Colony'},
		{value: 'Sandhills School/Sandhills Colony', text: 'Sandhills School/Sandhills Colony'},
		{value: 'Sayre School/Rosebud Colony', text: 'Sayre School/Rosebud Colony'},
		{value: 'Three Hills Colony School/Three Hills Colony', text: 'Three Hills Colony School/Three Hills Colony'},
		{value: 'Towers School/Cluny Colony', text: 'Towers School/Cluny Colony'},
		{value: 'Twin Creeks School/Twin Creeks Colony', text: 'Twin Creeks School/Twin Creeks Colony'},
		{value: 'Valleyview School/Torrington Colony', text: 'Valleyview School/Torrington Colony'},
		{value: 'Wintering Hills School/Wintering Hills Colony', text: 'Wintering Hills School/Wintering Hills Colony'},
		{value: 'Country Hills School/Midwest Colony', text: 'Country Hills School/Midwest Colony'},
		{value: 'Hutterite Education', text: 'Hutterite Education'},
	],
    'Conseil Scolaire FrancoSud': [
		{value: 'École Beausoleil ', text: 'École Beausoleil '},
		{value: 'École de la Rose sauvage ', text: 'École de la Rose sauvage '},
		{value: 'École de la Source', text: 'École de la Source'},
		{value: 'École du nouveau monde', text: 'École du nouveau monde'},
		{value: 'École La Mosaïque', text: 'École La Mosaïque'},
		{value: 'École francophone d\'Airdrie', text: 'École francophone d\'Airdrie'},
		{value: 'École La Vérendrye', text: 'École La Vérendrye'},
		{value: 'École Le Ruisseau', text: 'École Le Ruisseau'},
		{value: 'École Terre des Jeunes', text: 'École Terre des Jeunes'},
		{value: 'École Les Cyprès', text: 'École Les Cyprès'},
		{value: 'École Notre-Dame Des Monts', text: 'École Notre-Dame Des Monts'},
		{value: 'École Notre-Dame Des Vallées', text: 'École Notre-Dame Des Vallées'},
		{value: 'École Sainte-Marguerite-Bourgeoys', text: 'École Sainte-Marguerite-Bourgeoys'},
		{value: 'École Notre-Dame-De-La-Paix', text: 'École Notre-Dame-De-La-Paix'},
		{value: 'Siège social', text: 'Siège social'},
	],
    'Fort Vermilion School Division': [
		{value: 'At Home Learning Centre', text: 'At Home Learning Centre'},
		{value: 'Blue Hills Community School', text: 'Blue Hills Community School'},
		{value: 'Buffalo Head Prairie School', text: 'Buffalo Head Prairie School'},
		{value: 'Florence MacDougall Community School', text: 'Florence MacDougall Community School'},
		{value: 'Fort Vermilion Public School', text: 'Fort Vermilion Public School'},
		{value: 'High Level Public School', text: 'High Level Public School'},
		{value: 'Hill Crest Community School', text: 'Hill Crest Community School'},
		{value: 'La Crete Public School', text: 'La Crete Public School'},
		{value: 'Learning Stores Outreach', text: 'Learning Stores Outreach'},
		{value: 'Northern Home Education Centre', text: 'Northern Home Education Centre'},
		{value: 'Rainbow Lake School', text: 'Rainbow Lake School'},
		{value: 'Ridgeview Central School', text: 'Ridgeview Central School'},
		{value: 'Rocky Lane School', text: 'Rocky Lane School'},
		{value: 'Sandhills Elementary School', text: 'Sandhills Elementary School'},
		{value: 'Spirit of the North Community School', text: 'Spirit of the North Community School'},
		{value: 'St. Mary\'s Elementary School', text: 'St. Mary\'s Elementary School'},
		{value: 'Upper Hay River School', text: 'Upper Hay River School'},
	],
    'Fort McMurray Catholic Schools': [
		{value: 'St.Martha School', text: 'St.Martha School'},
		{value: 'Father JA Turcotte School', text: 'Father JA Turcotte School'},
		{value: 'Good Shepherd School', text: 'Good Shepherd School'},
		{value: 'Father Beauregard School', text: 'Father Beauregard School'},
		{value: 'Ecole St.Paul School', text: 'Ecole St.Paul School'},
		{value: 'St.Gabriel School', text: 'St.Gabriel School'},
		{value: 'Sister Mary Phillips School', text: 'Sister Mary Phillips School'},
		{value: 'St.Anne School', text: 'St.Anne School'},
		{value: 'St.Kateri School', text: 'St.Kateri School'},
		{value: 'Elsie Yanik Catholic School', text: 'Elsie Yanik Catholic School'},
		{value: 'Father Patrick Mercredi Catholic High School', text: 'Father Patrick Mercredi Catholic High School'},
		{value: 'Holy Trinity Catholic High School', text: 'Holy Trinity Catholic High School'},
	],
    'Foothills School Division': [
		{value: 'Blackie School', text: 'Blackie School'},
		{value: 'Cayley School', text: 'Cayley School'},
		{value: 'École Joe Clark School', text: 'École Joe Clark School'},
		{value: 'École Secondaire Highwood High School ', text: 'École Secondaire Highwood High School '},
		{value: 'École Senator Riley Middle School', text: 'École Senator Riley Middle School'},
		{value: 'Spitzee Elementary School', text: 'Spitzee Elementary School'},
		{value: 'Big Rock School', text: 'Big Rock School'},
		{value: 'Dr.Morris Gibson School', text: 'Dr.Morris Gibson School'},
		{value: 'École Okotoks Jr High School', text: 'École Okotoks Jr High School'},
		{value: 'École Percy Pegler School', text: 'École Percy Pegler School'},
		{value: 'École Secondaire Foothills Composite High School', text: 'École Secondaire Foothills Composite High School'},
		{value: 'Heritage Heights School', text: 'Heritage Heights School'},
		{value: 'Red Deer Lake School', text: 'Red Deer Lake School'},
		{value: 'Westmount School', text: 'Westmount School'},
		{value: 'Meadow Ridge School', text: 'Meadow Ridge School'},
		{value: 'C Ian McLaren School', text: 'C Ian McLaren School'},
		{value: 'Longview School', text: 'Longview School'},
		{value: 'Millarville Community School', text: 'Millarville Community School'},
		{value: 'Oilfields School', text: 'Oilfields School'},
		{value: 'Turner Valley School', text: 'Turner Valley School'},
		{value: 'Cameron Crossing', text: 'Cameron Crossing'},
		{value: 'Cayley Colony School', text: 'Cayley Colony School'},
		{value: 'High River Colony School', text: 'High River Colony School'},
		{value: 'MacMillan Colony School', text: 'MacMillan Colony School'},
	],
    'Elk Island Catholic Schools': [
		{value: 'Archbishop Jordan Catholic High School', text: 'Archbishop Jordan Catholic High School'},
		{value: 'Chesterton Academy of St. Isidore', text: 'Chesterton Academy of St. Isidore'},
		{value: 'École Our Lady of Perpetual Help Catholic School', text: 'École Our Lady of Perpetual Help Catholic School'},
		{value: 'École Père Kenneth Kearns Catholic Elementary School', text: 'École Père Kenneth Kearns Catholic Elementary School'},
		{value: 'EICS Summer School', text: 'EICS Summer School'},
		{value: 'Holy Redeemer Catholic School', text: 'Holy Redeemer Catholic School'},
		{value: 'Holy Spirit Catholic School', text: 'Holy Spirit Catholic School'},
		{value: 'Madonna Catholic School', text: 'Madonna Catholic School'},
		{value: 'Our Lady of Mount Pleasant Catholic School', text: 'Our Lady of Mount Pleasant Catholic School'},
		{value: 'Our Lady of the Angels Catholic School', text: 'Our Lady of the Angels Catholic School'},
		{value: 'St Isidore Learning Centre', text: 'St Isidore Learning Centre'},
		{value: 'St. André Bessette Catholic School', text: 'St. André Bessette Catholic School'},
		{value: 'St. John Paul II Catholic School', text: 'St. John Paul II Catholic School'},
		{value: 'St. John XXIII Catholic School', text: 'St. John XXIII Catholic School'},
		{value: 'St. Luke Catholic School', text: 'St. Luke Catholic School'},
		{value: 'St. Martin\'s Catholic School', text: 'St. Martin\'s Catholic School'},
		{value: 'St. Mary\'s Catholic School', text: 'St. Mary\'s Catholic School'},
		{value: 'St. Nicholas Catholic School', text: 'St. Nicholas Catholic School'},
		{value: 'St. Patrick Catholic School', text: 'St. Patrick Catholic School'},
		{value: 'St. Theresa Catholic School', text: 'St. Theresa Catholic School'},
	],
    'Conseil Scolaire Centre-Nord': [
		{value: 'École À la Découverte', text: 'École À la Découverte'},
		{value: 'École Alexandre-Taché', text: 'École Alexandre-Taché'},
		{value: 'École Boréal', text: 'École Boréal'},
		{value: 'École Citadelle', text: 'École Citadelle'},
		{value: 'École Claudette-et-Denis-Tardif', text: 'École Claudette-et-Denis-Tardif'},
		{value: 'École des Fondateur', text: 'École des Fondateur'},
		{value: 'École Desrochers', text: 'École Desrochers'},
		{value: 'École Joseph-Moreau', text: 'École Joseph-Moreau'},
		{value: 'École La Mission', text: 'École La Mission'},
		{value: 'École La Prairie', text: 'École La Prairie'},
		{value: 'École Maurice-Lavallée', text: 'École Maurice-Lavallée'},
		{value: 'École Michaëlle-Jean', text: 'École Michaëlle-Jean'},
		{value: 'École Notre-Dame', text: 'École Notre-Dame'},
		{value: 'École Père-Lacombe', text: 'École Père-Lacombe'},
		{value: 'École Gabrielle-Roy', text: 'École Gabrielle-Roy'},
		{value: 'École Saint-Christophe', text: 'École Saint-Christophe'},
		{value: 'École Sainte-Jeanne-d’Arc', text: 'École Sainte-Jeanne-d’Arc'},
		{value: 'École Sans-Frontières', text: 'École Sans-Frontières'},
		{value: 'École La Trinité', text: 'École La Trinité'},
		{value: 'École Quatre-Saisons', text: 'École Quatre-Saisons'},
	],
    'Clearview Public Schools': [
		{value: 'Big Valley School', text: 'Big Valley School'},
		{value: 'Botha School', text: 'Botha School'},
		{value: 'Brownfield School', text: 'Brownfield School'},
		{value: 'Byemoor School', text: 'Byemoor School'},
		{value: 'Coronation School', text: 'Coronation School'},
		{value: 'Donalda School', text: 'Donalda School'},
		{value: 'Erskine School', text: 'Erskine School'},
		{value: 'Gus Wetter School', text: 'Gus Wetter School'},
		{value: 'Stettler Elementary School', text: 'Stettler Elementary School'},
		{value: 'WM E Hay Stettler Secondary Campus', text: 'WM E Hay Stettler Secondary Campus'},
		{value: 'Colony Schools', text: 'Colony Schools'},
		{value: 'CARS', text: 'CARS'},
	],
    'Christ the Redeemer Catholic Schools': [
		{value: 'Holy Family Academy', text: 'Holy Family Academy'},
		{value: 'Christ The King Academy', text: 'Christ The King Academy'},
		{value: 'St.Joseph\'s Collegiate', text: 'St.Joseph\'s Collegiate'},
		{value: 'St.Luke\'s Outreach Centre', text: 'St.Luke\'s Outreach Centre'},
		{value: 'Our Lady of the Snows Catholic Academy', text: 'Our Lady of the Snows Catholic Academy'},
		{value: 'St.Anthony\'s School', text: 'St.Anthony\'s School'},
		{value: 'Holy Spirit Academy', text: 'Holy Spirit Academy'},
		{value: 'Notre Dame Collegiate', text: 'Notre Dame Collegiate'},
		{value: 'École Good Shepherd School', text: 'École Good Shepherd School'},
		{value: 'St.Mary\'s School', text: 'St.Mary\'s School'},
		{value: 'St.Francis of Assisi Academy', text: 'St.Francis of Assisi Academy'},
		{value: 'St.John Paul II Collegiate', text: 'St.John Paul II Collegiate'},
		{value: 'Holy Trinity Academy', text: 'Holy Trinity Academy'},
		{value: 'Assumption School', text: 'Assumption School'},
		{value: 'Sacred Heart Academy', text: 'Sacred Heart Academy'},
		{value: 'Holy Cross Collegiate', text: 'Holy Cross Collegiate'},
		{value: 'The Centre for Learning at Home', text: 'The Centre for Learning at Home'},
		{value: 'St.Paul\'s Academy', text: 'St.Paul\'s Academy'},
	],
    'Aspen View Public Schools': [
		{value: 'Athabasca Colony', text: 'Athabasca Colony'},
		{value: 'Boyle School', text: 'Boyle School'},
		{value: 'Centre for Alternative and Virtual Education', text: 'Centre for Alternative and Virtual Education'},
		{value: 'Deep Creek Colony', text: 'Deep Creek Colony'},
		{value: 'Edwin Parr Composite School', text: 'Edwin Parr Composite School'},
		{value: 'Grassland School', text: 'Grassland School'},
		{value: 'HA Kostash School', text: 'HA Kostash School'},
		{value: 'Kihew House', text: 'Kihew House'},
		{value: 'Landing Trail Intermediate School', text: 'Landing Trail Intermediate School'},
		{value: 'New Pine Colony', text: 'New Pine Colony'},
		{value: 'Rochester School', text: 'Rochester School'},
		{value: 'Smoky Lake Colony', text: 'Smoky Lake Colony'},
		{value: 'Smith School', text: 'Smith School'},
		{value: 'Thorhild Central School', text: 'Thorhild Central School'},
		{value: 'Vilna School', text: 'Vilna School'},
		{value: 'Whispering Hills Primary School', text: 'Whispering Hills Primary School'},
	],
    'Battle River School Division': [
		{value: 'Bashaw School', text: 'Bashaw School'},
		{value: 'Bawlf School', text: 'Bawlf School'},
		{value: 'CW Seats School', text: 'CW Seats School'},
		{value: 'Camrose Outreach School', text: 'Camrose Outreach School'},
		{value: 'Central High Sedgewick Public School', text: 'Central High Sedgewick Public School'},
		{value: 'Chester Ronning School', text: 'Chester Ronning School'},
		{value: 'Colony Schools', text: 'Colony Schools'},
		{value: 'Daysland School', text: 'Daysland School'},
		{value: 'Ecole Camrose Composite High School', text: 'Ecole Camrose Composite High School'},
		{value: 'Ecole Charlie Killam School', text: 'Ecole Charlie Killam School'},
		{value: 'Ecole Sifton School', text: 'Ecole Sifton School'},
		{value: 'Forestburg School', text: 'Forestburg School'},
		{value: 'Hay Lakes School', text: 'Hay Lakes School'},
		{value: 'Jack Stuart School', text: 'Jack Stuart School'},
		{value: 'Killam Public School', text: 'Killam Public School'},
		{value: 'New Norway School', text: 'New Norway School'},
		{value: 'Round Hill School', text: 'Round Hill School'},
		{value: 'Ryley School', text: 'Ryley School'},
		{value: 'Sparling School', text: 'Sparling School'},
		{value: 'Tofield School', text: 'Tofield School'},
		{value: 'Viking School', text: 'Viking School'},
		{value: 'At-Home Learning', text: 'At-Home Learning'},
	],
    'Black Gold School Division': [
		{value: 'Home-Based School', text: 'Home-Based School'},
		{value: 'Outreach - Beaumont', text: 'Outreach - Beaumont'},
		{value: 'Outreach - Leduc', text: 'Outreach - Leduc'},
		{value: 'Caledonia Park School', text: 'Caledonia Park School'},
		{value: 'Calmar Elementary School', text: 'Calmar Elementary School'},
		{value: 'Calmar Secondary School', text: 'Calmar Secondary School'},
		{value: 'Covenant Christian School', text: 'Covenant Christian School'},
		{value: 'East Elementary School', text: 'East Elementary School'},
		{value: 'Ecole Beau Meadow School', text: 'Ecole Beau Meadow School'},
		{value: 'Ecole Bellevue School', text: 'Ecole Bellevue School'},
		{value: 'Ecole Champs Vallee School', text: 'Ecole Champs Vallee School'},
		{value: 'Ecole Coloniale Estates School', text: 'Ecole Coloniale Estates School'},
		{value: 'Ecole Corinthia Park School', text: 'Ecole Corinthia Park School'},
		{value: 'Ecole Dansereau Meadows School', text: 'Ecole Dansereau Meadows School'},
		{value: 'Ecole J E Lapointe School', text: 'Ecole J E Lapointe School'},
		{value: 'Ecole Leduc Estates School', text: 'Ecole Leduc Estates School'},
		{value: 'Ecole Leduc JR High School', text: 'Ecole Leduc JR High School'},
		{value: 'Ecole Scondaire Beaumont Composite High School', text: 'Ecole Scondaire Beaumont Composite High School'},
		{value: 'John Maland High School', text: 'John Maland High School'},
		{value: 'Leduc Composite High School', text: 'Leduc Composite High School'},
		{value: 'Linsford Park School', text: 'Linsford Park School'},
		{value: 'New Humble Centre School', text: 'New Humble Centre School'},
		{value: 'New Sarepta Community High School', text: 'New Sarepta Community High School'},
		{value: 'New Sarepta Elementary School', text: 'New Sarepta Elementary School'},
		{value: 'Riverview Middle School', text: 'Riverview Middle School'},
		{value: 'Robina Baker Elementary School', text: 'Robina Baker Elementary School'},
		{value: 'Thorsby Elementary School', text: 'Thorsby Elementary School'},
		{value: 'Thorsby Jr/Senior High School', text: 'Thorsby Jr/Senior High School'},
		{value: 'Warburg Hutterite Colony School', text: 'Warburg Hutterite Colony School'},
		{value: 'Warburg School', text: 'Warburg School'},
		{value: 'West Haven Public School', text: 'West Haven Public School'},
		{value: 'Willow Park School', text: 'Willow Park School'},
	],
    'Canadian Rockies Public Schools': [
		{value: 'Banff Elementary School', text: 'Banff Elementary School'},
		{value: 'Banff Community High School', text: 'Banff Community High School'},
		{value: 'Alpenglow School', text: 'Alpenglow School'},
		{value: 'Exshaw School', text: 'Exshaw School'},
		{value: 'Elizabeth Rummel School', text: 'Elizabeth Rummel School'},
		{value: 'Lawrence Grassi Middle School', text: 'Lawrence Grassi Middle School'},
		{value: 'Canmore Collegiate High School', text: 'Canmore Collegiate High School'},
	],
    'Chinooks Edge School Division': [
		{value: 'Bowden Grandview School', text: 'Bowden Grandview School'},
		{value: 'Carstairs Elementary School', text: 'Carstairs Elementary School'},
		{value: 'Hugh Sutherland School', text: 'Hugh Sutherland School'},
		{value: 'Neudorf Hutterite', text: 'Neudorf Hutterite'},
		{value: 'Cremona School', text: 'Cremona School'},
		{value: 'Delburne School', text: 'Delburne School'},
		{value: 'Didsbury High School', text: 'Didsbury High School'},
		{value: 'Didsbury Career High School', text: 'Didsbury Career High School'},
		{value: 'Ross Ford Elementary School', text: 'Ross Ford Elementary School'},
		{value: 'Westglen School', text: 'Westglen School'},
		{value: 'Elnora School', text: 'Elnora School'},
		{value: 'Ecole Innisfail High School', text: 'Ecole Innisfail High School'},
		{value: 'Ecole Innisfail Middle School', text: 'Ecole Innisfail Middle School'},
		{value: 'Ecole John Wilson Elementary', text: 'Ecole John Wilson Elementary'},
		{value: 'Innisfail Career High School', text: 'Innisfail Career High School'},
		{value: 'Rainbow Colony School', text: 'Rainbow Colony School'},
		{value: 'Ecole Deer Meadow School', text: 'Ecole Deer Meadow School'},
		{value: 'Ecole Olds Elementary School', text: 'Ecole Olds Elementary School'},
		{value: 'Horizon School', text: 'Horizon School'},
		{value: 'Off Campus Learning Centre', text: 'Off Campus Learning Centre'},
		{value: 'Olds Career High School', text: 'Olds Career High School'},
		{value: 'Olds High School', text: 'Olds High School'},
		{value: 'Olds Koinonia Christian School', text: 'Olds Koinonia Christian School'},
		{value: 'Reed Ranch School', text: 'Reed Ranch School'},
		{value: 'Jessie Duncan School', text: 'Jessie Duncan School'},
		{value: 'Penhold Elementary School', text: 'Penhold Elementary School'},
		{value: 'Penhold Crossing Secondary School', text: 'Penhold Crossing Secondary School'},
		{value: 'Gasoline Alley Career High School', text: 'Gasoline Alley Career High School'},
		{value: 'Pine Hill Hutterite School', text: 'Pine Hill Hutterite School'},
		{value: 'Popular Ridge School', text: 'Popular Ridge School'},
		{value: 'Spruce View School', text: 'Spruce View School'},
		{value: 'River Valley School', text: 'River Valley School'},
		{value: 'Sundre High School', text: 'Sundre High School'},
		{value: 'Sundre Learning Centre', text: 'Sundre Learning Centre'},
		{value: 'Beacon Hill Elementary School', text: 'Beacon Hill Elementary School'},
		{value: 'CP Blakely School', text: 'CP Blakely School'},
		{value: 'Ecole HJ Cody School', text: 'Ecole HJ Cody School'},
		{value: 'Ecole Fox Run School', text: 'Ecole Fox Run School'},
		{value: 'Ecole Steffie Woima Elementary School', text: 'Ecole Steffie Woima Elementary School'},
		{value: 'Sylvan Lake Career High School', text: 'Sylvan Lake Career High School'},
	],
	'Catholic District School Board of Eastern Ontario': [
		{value: 'Bishop Macdonell', text: 'Bishop Macdonell'},
		{value: 'Holy Cross Catholic School', text: 'Holy Cross Catholic School'},
		{value: 'Holy Name of Mary Catholic School', text: 'Holy Name of Mary Catholic School'},
		{value: 'Holy Trinity Catholic Secondary School', text: 'Holy Trinity Catholic Secondary School'},
		{value: 'Iona Academy', text: 'Iona Academy'},
		{value: 'J.L. Jordan Catholic School', text: 'J.L. Jordan Catholic School'},
		{value: 'Mother Teresa Catholic School', text: 'Mother Teresa Catholic School'},
		{value: 'Notre Dame Catholic High School', text: 'Notre Dame Catholic High School'},
		{value: 'Our Lady of Good Counsel Catholic School', text: 'Our Lady of Good Counsel Catholic School'},
		{value: 'Pope John Paul II Catholic School', text: 'Pope John Paul II Catholic School'},
		{value: 'Sacred Heart Catholic School', text: 'Sacred Heart Catholic School'},
		{value: 'Sacred Heart of Jesus Catholic School', text: 'Sacred Heart of Jesus Catholic School'},
		{value: 'St. Andrew\'s Catholic School', text: 'St. Andrew\'s Catholic School'},
		{value: 'St. Anne Catholic School', text: 'St. Anne Catholic School'},
		{value: 'St. Edward Catholic School', text: 'St. Edward Catholic School'},
		{value: 'St. Finnan\'s Catholic School', text: 'St. Finnan\'s Catholic School'},
		{value: 'St. Francis de Sales Catholic School', text: 'St. Francis de Sales Catholic School'},
		{value: 'St. Francis Xavier Catholic High School', text: 'St. Francis Xavier Catholic High School'},
		{value: 'St. Francis Xavier Catholic School', text: 'St. Francis Xavier Catholic School'},
		{value: 'St. Gregory Catholic School', text: 'St. Gregory Catholic School'},
		{value: 'St. James Catholic Education Centre', text: 'St. James Catholic Education Centre'},
		{value: 'St. John Bosco Catholic School', text: 'St. John Bosco Catholic School'},
		{value: 'St. John Catholic High School', text: 'St. John Catholic High School'},
		{value: 'St. John Catholic School', text: 'St. John Catholic School'},
		{value: 'St. Joseph Catholic School', text: 'St. Joseph Catholic School'},
		{value: 'St. Joseph Catholic School (Gananoque)', text: 'St. Joseph Catholic School (Gananoque)'},
		{value: 'St. Joseph Catholic Secondary School', text: 'St. Joseph Catholic Secondary School'},
		{value: 'St. Jude Catholic School', text: 'St. Jude Catholic School'},
		{value: 'St. Luke Catholic High School', text: 'St. Luke Catholic High School'},
		{value: 'St. Mark Catholic School', text: 'St. Mark Catholic School'},
		{value: 'St. Mary Catholic High School', text: 'St. Mary Catholic High School'},
		{value: 'St. Mary Catholic School', text: 'St. Mary Catholic School'},
		{value: 'St. Mary Catholic School (Chesterville)', text: 'St. Mary Catholic School (Chesterville)'},
		{value: 'St. Mary-St. Cecilia Catholic School', text: 'St. Mary-St. Cecilia Catholic School'},
		{value: 'St. Matthew Catholic Secondary School', text: 'St. Matthew Catholic Secondary School'},
		{value: 'St. Michael Catholic High School', text: 'St. Michael Catholic High School'},
		{value: 'St. Patrick Catholic School', text: 'St. Patrick Catholic School'},
		{value: 'St. Peter Catholic School', text: 'St. Peter Catholic School'},
		{value: 'St. Thomas Aquinas Catholic High School', text: 'St. Thomas Aquinas Catholic High School'},
	],
	'Huron Perth Catholic District School Board': [
		{value: 'Blessed Carlo Acutis Continuing Education School', text:'Blessed Carlo Acutis Continuing Education School'},
		{value: 'Holy Name of Mary, St. Marys', text:'Holy Name of Mary, St. Marys'},
		{value: 'Jeanne Sauvé , Stratford (French Immersion)', text:'Jeanne Sauvé , Stratford (French Immersion)'},
		{value: 'Our Lady of Mount Carmel', text:'Our Lady of Mount Carmel'},
		{value: 'Precious Blood, Exeter', text:'Precious Blood, Exeter'},
		{value: 'Sacred Heart, Wingham', text:'Sacred Heart, Wingham'},
		{value: 'St. Aloysius, Stratford', text:'St. Aloysius, Stratford'},
		{value: 'St. Ambrose, Stratford', text:'St. Ambrose, Stratford'},
		{value: 'St. Anne\'s Catholic Secondary School', text:'St. Anne\'s Catholic Secondary School'},
		{value: 'St. Boniface, Zurich', text:'St. Boniface, Zurich'},
		{value: 'St. Columban', text:'St. Columban'},
		{value: 'St. James, Seaforth', text:'St. James, Seaforth'},
		{value: 'St. Joseph\'s, Clinton', text:'St. Joseph\'s, Clinton'},
		{value: 'St. Joseph\'s, Stratford', text:'St. Joseph\'s, Stratford'},
		{value: 'St. Mary\'s, Goderich (French Immersion)', text:'St. Mary\'s, Goderich (French Immersion)'},
		{value: 'St. Mary\'s, Listowel', text:'St. Mary\'s, Listowel'},
		{value: 'St. Michael Catholic Secondary School', text:'St. Michael Catholic Secondary School'},
		{value: 'St. Patrick\'s, Dublin', text:'St. Patrick\'s, Dublin'},
		{value: 'St. Patrick\'s, Kinkora', text:'St. Patrick\'s, Kinkora'},
	],
	'Renfrew County District School Board': [
		{value: 'A.J. Charbonneau Public School', text:'A.J. Charbonneau Public School'},
		{value: 'Admaston Public School', text:'Admaston Public School'},
		{value: 'Arnprior District High School', text:'Arnprior District High School'},
		{value: 'Beachburg Public School', text:'Beachburg Public School'},
		{value: 'Central Public School', text:'Central Public School'},
		{value: 'Champlain Discovery Public School', text:'Champlain Discovery Public School'},
		{value: 'Cobden Public School', text:'Cobden Public School'},
		{value: 'Eganville Public School', text:'Eganville Public School'},
		{value: 'Fellowes High School', text:'Fellowes High School'},
		{value: 'Herman Street Public School', text:'Herman Street Public School'},
		{value: 'Highview Public School', text:'Highview Public School'},
		{value: 'Killaloe Public School', text:'Killaloe Public School'},
		{value: 'Mackenzie Community School', text:'Mackenzie Community School'},
		{value: 'Mackenzie Community School', text:'Mackenzie Community School'},
		{value: 'Madawaska Valley District High School', text:'Madawaska Valley District High School'},
		{value: 'McNab Public School', text:'McNab Public School'},
		{value: 'Opeongo High School', text:'Opeongo High School'},
		{value: 'Palmer Rapids Public School', text:'Palmer Rapids Public School'},
		{value: 'Pine View Public School', text:'Pine View Public School'},
		{value: 'Queen Elizabeth Public School', text:'Queen Elizabeth Public School'},
		{value: 'Renfrew Collegiate Institute ', text:'Renfrew Collegiate Institute '},
		{value: 'Renfrew Collegiate Intermediate School', text:'Renfrew Collegiate Intermediate School'},
		{value: 'Rockwood Public School', text:'Rockwood Public School'},
		{value: 'Sherwood Public School', text:'Sherwood Public School'},
		{value: 'Valour JK-12 School', text:'Valour JK-12 School'},
		{value: 'Walter Zadow Public School', text:'Walter Zadow Public School'},
		{value: 'Whitney Public School', text:'Whitney Public School'},
	],
	'Surrey Schools': [
		{value: 'A.H.P. Matthew', text:'A.H.P. Matthew'},
		{value: 'A.J. McLellan', text:'A.J. McLellan'},
		{value: 'Adams Road', text:'Adams Road'},
		{value: 'Bayridge', text:'Bayridge'},
		{value: 'Bear Creek', text:'Bear Creek'},
		{value: 'Beaver Creek', text:'Beaver Creek'},
		{value: 'Berkshire Park', text:'Berkshire Park'},
		{value: 'Betty Huff', text:'Betty Huff'},
		{value: 'Bonaccord', text:'Bonaccord'},
		{value: 'Bothwell', text:'Bothwell'},
		{value: 'Boundary Park', text:'Boundary Park'},
		{value: 'Bridgeview', text:'Bridgeview'},
		{value: 'Brookside', text:'Brookside'},
		{value: 'Cambridge', text:'Cambridge'},
		{value: 'Cedar Hills', text:'Cedar Hills'},
		{value: 'Chantrell Creek', text:'Chantrell Creek'},
		{value: 'Chimney Hill', text:'Chimney Hill'},
		{value: 'Cindrich', text:'Cindrich'},
		{value: 'City Central Learning Centre', text:'City Central Learning Centre'},
		{value: 'Clayton', text:'Clayton'},
		{value: 'Clayton Heights', text:'Clayton Heights'},
		{value: 'Cloverdale Learning Centre', text:'Cloverdale Learning Centre'},
		{value: 'Cloverdale Traditional', text:'Cloverdale Traditional'},
		{value: 'Coast Meridian', text:'Coast Meridian'},
		{value: 'Colebrook', text:'Colebrook'},
		{value: 'Cougar Creek', text:'Cougar Creek'},
		{value: 'Coyote Creek', text:'Coyote Creek'},
		{value: 'Creekside', text:'Creekside'},
		{value: 'David Brankin', text:'David Brankin'},
		{value: 'Dogwood', text:'Dogwood'},
		{value: 'Don Christian', text:'Don Christian'},
		{value: 'Douglas', text:'Douglas'},
		{value: 'Dr. F.D. Sinclair', text:'Dr. F.D. Sinclair'},
		{value: 'École Earl Marriott', text:'École Earl Marriott'},
		{value: 'École Kwantlen Park', text:'École Kwantlen Park'},
		{value: 'École Panorama Ridge', text:'École Panorama Ridge'},
		{value: 'École Salish', text:'École Salish'},
		{value: 'East Kensington', text:'East Kensington'},
		{value: 'École Crescent Park', text:'École Crescent Park'},
		{value: 'École Erma Stephenson', text:'École Erma Stephenson'},
		{value: 'École Fraser Wood', text:'École Fraser Wood'},
		{value: 'École Frost Road', text:'École Frost Road'},
		{value: 'École Henry Bose', text:'École Henry Bose'},
		{value: 'École Jessie Lee', text:'École Jessie Lee'},
		{value: 'École K.B. Woodward', text:'École K.B. Woodward'},
		{value: 'École Laronde', text:'École Laronde'},
		{value: 'École Martha Currie', text:'École Martha Currie'},
		{value: 'École Ocean Cliff', text:'École Ocean Cliff'},
		{value: 'École Peace Arch', text:'École Peace Arch'},
		{value: 'École Riverdale', text:'École Riverdale'},
		{value: 'École Simon Cunningham', text:'École Simon Cunningham'},
		{value: 'École Sunrise Ridge', text:'École Sunrise Ridge'},
		{value: 'École Woodward Hill', text:'École Woodward Hill'},
		{value: 'Edgewood', text:'Edgewood'},
		{value: 'Education Services School', text:'Education Services School'},
		{value: 'Elgin Park', text:'Elgin Park'},
		{value: 'Ellendale', text:'Ellendale'},
		{value: 'Enver Creek', text:'Enver Creek'},
		{value: 'Fleetwood Park', text:'Fleetwood Park'},
		{value: 'Forsyth Road', text:'Forsyth Road'},
		{value: 'Frank Hurt', text:'Frank Hurt'},
		{value: 'Fraser Heights', text:'Fraser Heights'},
		{value: 'George Greenaway', text:'George Greenaway'},
		{value: 'Georges Vanier', text:'Georges Vanier'},
		{value: 'Goldstone Park', text:'Goldstone Park'},
		{value: 'Grandview Heights', text:'Grandview Heights'},
		{value: 'Green Timbers', text:'Green Timbers'},
		{value: 'Guildford Learning Centre', text:'Guildford Learning Centre'},
		{value: 'Guildford Park', text:'Guildford Park'},
		{value: 'H.T. Thrift', text:'H.T. Thrift'},
		{value: 'Hall\'s Prairie', text:'Hall\'s Prairie'},
		{value: 'Harold Bishop', text:'Harold Bishop'},
		{value: 'Hazelgrove', text:'Hazelgrove'},
		{value: 'Hillcrest', text:'Hillcrest'},
		{value: 'Hjorth Road', text:'Hjorth Road'},
		{value: 'Holly', text:'Holly'},
		{value: 'Hyland', text:'Hyland'},
		{value: 'J.T. Brown', text:'J.T. Brown'},
		{value: 'James Ardiel', text:'James Ardiel'},
		{value: 'Janice Churchill', text:'Janice Churchill'},
		{value: 'Johnston Heights', text:'Johnston Heights'},
		{value: 'Katzie', text:'Katzie'},
		{value: 'Kennedy Trail', text:'Kennedy Trail'},
		{value: 'Kirkbride', text:'Kirkbride'},
		{value: 'L.A. Matheson', text:'L.A. Matheson'},
		{value: 'Latimer Road', text:'Latimer Road'},
		{value: 'Lena Shaw', text:'Lena Shaw'},
		{value: 'Lord Tweedsmuir', text:'Lord Tweedsmuir'},
		{value: 'M.B. Sanford', text:'M.B. Sanford'},
		{value: 'Maddaugh', text:'Maddaugh'},
		{value: 'Maple Green', text:'Maple Green'},
		{value: 'Martha Jane Norris', text:'Martha Jane Norris'},
		{value: 'Mary Jane Shannon', text:'Mary Jane Shannon'},
		{value: 'McLeod Road Traditional', text:'McLeod Road Traditional'},
		{value: 'Morgan', text:'Morgan'},
		{value: 'Mountainview Montessori', text:'Mountainview Montessori'},
		{value: 'Newton', text:'Newton'},
		{value: 'North Ridge', text:'North Ridge'},
		{value: 'North Surrey', text:'North Surrey'},
		{value: 'North Surrey Learning Centre', text:'North Surrey Learning Centre'},
		{value: 'Old Yale Road', text:'Old Yale Road'},
		{value: 'Pacific Heights', text:'Pacific Heights'},
		{value: 'Panorama Park', text:'Panorama Park'},
		{value: 'Port Kells', text:'Port Kells'},
		{value: 'Prince Charles', text:'Prince Charles'},
		{value: 'Princess Margaret', text:'Princess Margaret'},
		{value: 'Queen Elizabeth', text:'Queen Elizabeth'},
		{value: 'Ray Shepherd', text:'Ray Shepherd'},
		{value: 'Rosemary Heights', text:'Rosemary Heights'},
		{value: 'Royal Heights', text:'Royal Heights'},
		{value: 'SAIL (@Brookside)', text:'SAIL (@Brookside)'},
		{value: 'SAIL Surrey Academy of Innovative Learning', text:'SAIL Surrey Academy of Innovative Learning'},
		{value: 'Semiahmoo', text:'Semiahmoo'},
		{value: 'Semiahmoo Trail', text:'Semiahmoo Trail'},
		{value: 'Senator Reid', text:'Senator Reid'},
		{value: 'Serpentine Heights', text:'Serpentine Heights'},
		{value: 'South Meridian', text:'South Meridian'},
		{value: 'South Surrey/ White Rock Learning Centre', text:'South Surrey/ White Rock Learning Centre'},
		{value: 'Strawberry Hill', text:'Strawberry Hill'},
		{value: 'Sullivan', text:'Sullivan'},
		{value: 'Sullivan Heights', text:'Sullivan Heights'},
		{value: 'Sunnyside', text:'Sunnyside'},
		{value: 'Surrey Centre', text:'Surrey Centre'},
		{value: 'Surrey Traditional', text:'Surrey Traditional'},
		{value: 'T.E. Scott', text:'T.E. Scott'},
		{value: 'Tamanawis', text:'Tamanawis'},
		{value: 'W.E. Kinvig', text:'W.E. Kinvig'},
		{value: 'Walnut Road', text:'Walnut Road'},
		{value: 'Westerman', text:'Westerman'},
		{value: 'White Rock', text:'White Rock'},
		{value: 'William F. Davidson', text:'William F. Davidson'},
		{value: 'William Watson', text:'William Watson'},
		{value: 'Woodland Park', text:'Woodland Park'},
	],
	'Upper Grand District School Board': [
		{value: 'Aberfoyle Public School', text:'Aberfoyle Public School'},
		{value: 'Alma Public School', text:'Alma Public School'},
		{value: 'Arbour Vista Public School', text:'Arbour Vista Public School'},
		{value: 'Arthur Public School', text:'Arthur Public School'},
		{value: 'Brant Avenue Public School', text:'Brant Avenue Public School'},
		{value: 'Brisbane Public School', text:'Brisbane Public School'},
		{value: 'Centennial Collegiate Vocational Institute', text:'Centennial Collegiate Vocational Institute'},
		{value: 'Centennial Hylands Elementary School', text:'Centennial Hylands Elementary School'},
		{value: 'Central Public School', text:'Central Public School'},
		{value: 'Centre Dufferin District High School', text:'Centre Dufferin District High School'},
		{value: 'Centre Peel Public School', text:'Centre Peel Public School'},
		{value: 'Centre Wellington District High School', text:'Centre Wellington District High School'},
		{value: 'College Heights Secondary School', text:'College Heights Secondary School'},
		{value: 'Credit Meadows Elementary School', text:'Credit Meadows Elementary School'},
		{value: 'Drayton Heights Public School', text:'Drayton Heights Public School'},
		{value: 'East Garafraxa Public School', text:'East Garafraxa Public School'},
		{value: 'ECPP (Education and Community Partnership Programs), Youth Options and SAL (Supervised Alternative Learning)', text:'ECPP (Education and Community Partnership Programs), Youth Options and SAL (Supervised Alternative Learning)'},
		{value: 'Edward Johnson Public School', text:'Edward Johnson Public School'},
		{value: 'Elora Public School', text:'Elora Public School'},
		{value: 'Eramosa Public School', text:'Eramosa Public School'},
		{value: 'Erin District High School', text:'Erin District High School'},
		{value: 'Erin Public School', text:'Erin Public School'},
		{value: 'Fred A. Hamilton Public School', text:'Fred A. Hamilton Public School'},
		{value: 'Gateway Drive Public School', text:'Gateway Drive Public School'},
		{value: 'Glenbrook Elementary School', text:'Glenbrook Elementary School'},
		{value: 'Grand Valley and District Public School', text:'Grand Valley and District Public School'},
		{value: 'Guelph Collegiate Vocational Institute', text:'Guelph Collegiate Vocational Institute'},
		{value: 'Guelph Lake Public School', text:'Guelph Lake Public School'},
		{value: 'Harris Mill Public School', text:'Harris Mill Public School'},
		{value: 'Hyland Heights Elementary School', text:'Hyland Heights Elementary School'},
		{value: 'Island Lake Public School', text:'Island Lake Public School'},
		{value: 'J.D. Hogarth Public School', text:'J.D. Hogarth Public School'},
		{value: 'James McQueen Public School', text:'James McQueen Public School'},
		{value: 'Jean Little Public School', text:'Jean Little Public School'},
		{value: 'John Black Public School', text:'John Black Public School'},
		{value: 'John F. Ross Collegiate Vocational Institute', text:'John F. Ross Collegiate Vocational Institute'},
		{value: 'John Galt Public School', text:'John Galt Public School'},
		{value: 'John McCrae Public School', text:'John McCrae Public School'},
		{value: 'June Avenue Public School', text:'June Avenue Public School'},
		{value: 'Ken Danby Public School', text:'Ken Danby Public School'},
		{value: 'Kenilworth Public School', text:'Kenilworth Public School'},
		{value: 'King George Public School', text:'King George Public School'},
		{value: 'Kortright Hills Public School', text:'Kortright Hills Public School'},
		{value: 'Laurelwoods Elementary School', text:'Laurelwoods Elementary School'},
		{value: 'Maryborough Public School', text:'Maryborough Public School'},
		{value: 'Minto-Clifford Public School', text:'Minto-Clifford Public School'},
		{value: 'Mitchell Woods Public School', text:'Mitchell Woods Public School'},
		{value: 'Mono-Amaranth Public School', text:'Mono-Amaranth Public School'},
		{value: 'Montgomery Village Public School', text:'Montgomery Village Public School'},
		{value: 'Norwell District Secondary School', text:'Norwell District Secondary School'},
		{value: 'Orangeville District Secondary School', text:'Orangeville District Secondary School'},
		{value: 'Ottawa Crescent Public School', text:'Ottawa Crescent Public School'},
		{value: 'Paisley Road Public School', text:'Paisley Road Public School'},
		{value: 'Palmerston Public School', text:'Palmerston Public School'},
		{value: 'Parkinson Centennial Public School', text:'Parkinson Centennial Public School'},
		{value: 'Ponsonby Public School', text:'Ponsonby Public School'},
		{value: 'Primrose Elementary School', text:'Primrose Elementary School'},
		{value: 'Princess Elizabeth Public School', text:'Princess Elizabeth Public School'},
		{value: 'Princess Margaret Public School', text:'Princess Margaret Public School'},
		{value: 'Priory Park Public School', text:'Priory Park Public School'},
		{value: 'Remote Schools', text:'Remote Schools'},
		{value: 'Rickson Ridge Public School', text:'Rickson Ridge Public School'},
		{value: 'Rockwood Centennial Public School', text:'Rockwood Centennial Public School'},
		{value: 'Ross R MacKay Public School', text:'Ross R MacKay Public School'},
		{value: 'Salem Public School', text:'Salem Public School'},
		{value: 'Sir Isaac Brock Public School', text:'Sir Isaac Brock Public School'},
		{value: 'Spencer Avenue Elementary School', text:'Spencer Avenue Elementary School'},
		{value: 'Taylor Evans Public School', text:'Taylor Evans Public School'},
		{value: 'UGDSB Elementary Remote School', text:'UGDSB Elementary Remote School'},
		{value: 'UGDSB Secondary Remote School', text:'UGDSB Secondary Remote School'},
		{value: 'Victoria Cross Public School', text:'Victoria Cross Public School'},
		{value: 'Victoria Terrace Public School', text:'Victoria Terrace Public School'},
		{value: 'Victory Public School', text:'Victory Public School'},
		{value: 'Waverley Drive Public School', text:'Waverley Drive Public School'},
		{value: 'Wellington Heights Secondary School', text:'Wellington Heights Secondary School'},
		{value: 'Westminster Woods Public School', text:'Westminster Woods Public School'},
		{value: 'Westside Secondary School', text:'Westside Secondary School'},
		{value: 'Westwood Public School', text:'Westwood Public School'},
		{value: 'William C. Winegard Public School', text:'William C. Winegard Public School'},
		{value: 'Willow Road Public School', text:'Willow Road Public School'},
	],
	'Halton District School Board': [
		{value:'Abbey Lane Public School', text:'Abbey Lane Public School'},
		{value:'Abbey Park High School', text:'Abbey Park High School'},
		{value:'Acton District School', text:'Acton District School'},
		{value:'Acton Elementary (Gr.7 & Gr.8)', text:'Acton Elementary (Gr.7 & Gr.8)'},
		{value:'Aldershot Elementary', text:'Aldershot Elementary'},
		{value:'Aldershot High School', text:'Aldershot High School'},
		{value:'Alexander\'s Public School', text:'Alexander\'s Public School'},
		{value:'Alton Village Public School', text:'Alton Village Public School'},
		{value:'Anne J. MacArthur Public School', text:'Anne J. MacArthur Public School'},
		{value:'Boyne Public School', text:'Boyne Public School'},
		{value:'Brant Hills Public School', text:'Brant Hills Public School'},
		{value:'Brookdale Public School', text:'Brookdale Public School'},
		{value:'Brookville Public School', text:'Brookville Public School'},
		{value:'Bruce T. Lindley Public School', text:'Bruce T. Lindley Public School'},
		{value:'Bruce Trail Public School', text:'Bruce Trail Public School'},
		{value:'Burlington Central Elementary (Gr.7 & Gr.8)', text:'Burlington Central Elementary (Gr.7 & Gr.8)'},
		{value:'Burlington Central High School', text:'Burlington Central High School'},
		{value:'C.H. Norton Public School', text:'C.H. Norton Public School'},
		{value:'Captain R. Wilson', text:'Captain R. Wilson'},
		{value:'Centennial Public School', text:'Centennial Public School'},
		{value:'Central PS (JK-Gr.6)', text:'Central PS (JK-Gr.6)'},
		{value:'Charles R. Beaudoin', text:'Charles R. Beaudoin'},
		{value:'Chris Hadfield Public School', text:'Chris Hadfield Public School'},
		{value:'Clarksdale Public School', text:'Clarksdale Public School'},
		{value:'Craig Kielburger Secondary School', text:'Craig Kielburger Secondary School'},
		{value:'Dr. Charles Best Public School', text:'Dr. Charles Best Public School'},
		{value:'Dr. David R. Williams Public School', text:'Dr. David R. Williams Public School'},
		{value:'Dr. Frank J. Hayden Secondary School', text:'Dr. Frank J. Hayden Secondary School'},
		{value:'E. J. James Public School', text:'E. J. James Public School'},
		{value:'E. W. Foster Public School', text:'E. W. Foster Public School'},
		{value:'Eastview Public School', text:'Eastview Public School'},
		{value:'Elsie MacGill Secondary School', text:'Elsie MacGill Secondary School'},
		{value:'Emily Carr Public School', text:'Emily Carr Public School'},
		{value:'Escarpment View Public School', text:'Escarpment View Public School'},
		{value:'Ethel Gardiner Public School', text:'Ethel Gardiner Public School'},
		{value:'Falgarwood Public School', text:'Falgarwood Public School'},
		{value:'Florence Meares Public School', text:'Florence Meares Public School'},
		{value:'Forest Trail Public School', text:'Forest Trail Public School'},
		{value:'Frontenac Public School', text:'Frontenac Public School'},
		{value:'Garth Webb Secondary School', text:'Garth Webb Secondary School'},
		{value:'Gary Allan High School(Formally Adul, Alt. Ed)', text:'Gary Allan High School(Formally Adul, Alt. Ed)'},
		{value:'George Kennedy Public School', text:'George Kennedy Public School'},
		{value:'Georgetown District High School', text:'Georgetown District High School'},
		{value:'Gladys Speers Public School', text:'Gladys Speers Public School'},
		{value:'Glen Williams Public School', text:'Glen Williams Public School'},
		{value:'Glenview Public School', text:'Glenview Public School'},
		{value:'Harrison Public School', text:'Harrison Public School'},
		{value:'Hawthorne Village Public School', text:'Hawthorne Village Public School'},
		{value:'Heritage Glen Public School', text:'Heritage Glen Public School'},
		{value:'Irma Coulson Public School', text:'Irma Coulson Public School'},
		{value:'Iroquois Ridge High School', text:'Iroquois Ridge High School'},
		{value:'J.M. Denyes Public School', text:'J.M. Denyes Public School'},
		{value:'James W. Hill Public School', text:'James W. Hill Public School'},
		{value:'John T. Tuck Public School', text:'John T. Tuck Public School'},
		{value:'John William Boich Public School', text:'John William Boich Public School'},
		{value:'Joseph Gibbons Public School', text:'Joseph Gibbons Public School'},
		{value:'Joshua Creek Public School', text:'Joshua Creek Public School'},
		{value:'Kilbride Public School', text:'Kilbride Public School'},
		{value:'King\'s Road Public School', text:'King\'s Road Public School'},
		{value:'Lakeshore Public School', text:'Lakeshore Public School'},
		{value:'Limehouse Public School', text:'Limehouse Public School'},
		{value:'M. M. Robinson High School', text:'M. M. Robinson High School'},
		{value:'Maple Grove Public School', text:'Maple Grove Public School'},
		{value:'Maplehurst Public School', text:'Maplehurst Public School'},
		{value:'Martin Street Public School', text:'Martin Street Public School'},
		{value:'McKenzie-Smith Bennett Public School', text:'McKenzie-Smith Bennett Public School'},
		{value:'Milton District High School', text:'Milton District High School'},
		{value:'Mohawk Gardens Public School', text:'Mohawk Gardens Public School'},
		{value:'Montclair Public School', text:'Montclair Public School'},
		{value:'Munn\'s Public School', text:'Munn\'s Public School'},
		{value:'Nelson High School', text:'Nelson High School'},
		{value:'New Central Public School', text:'New Central Public School'},
		{value:'Night School', text:'Night School'},
		{value:'Oakville Trafalgar High School', text:'Oakville Trafalgar High School'},
		{value:'Oakwood Public School', text:'Oakwood Public School'},
		{value:'Oodenawi Public School', text:'Oodenawi Public School'},
		{value:'Orchard Park Public School', text:'Orchard Park Public School'},
		{value:'P.L. Robertson Public School', text:'P.L. Robertson Public School'},
		{value:'Palermo Public School', text:'Palermo Public School'},
		{value:'Park Public School', text:'Park Public School'},
		{value:'Paul A. Fisher Public School', text:'Paul A. Fisher Public School'},
		{value:'Pauline Johnson Public School', text:'Pauline Johnson Public School'},
		{value:'Pilgrim Wood Public School', text:'Pilgrim Wood Public School'},
		{value:'Pine Grove Public School', text:'Pine Grove Public School'},
		{value:'Pineland Public School', text:'Pineland Public School'},
		{value:'Pineview Public School', text:'Pineview Public School'},
		{value:'Post\'s Corners Public School', text:'Post\'s Corners Public School'},
		{value:'River Oaks Public School', text:'River Oaks Public School'},
		{value:'Robert Baldwin Public School', text:'Robert Baldwin Public School'},
		{value:'Robert Little Public School', text:'Robert Little Public School'},
		{value:'Rolling Meadows Public School', text:'Rolling Meadows Public School'},
		{value:'Ryerson Public School', text:'Ryerson Public School'},
		{value:'Sam Sherratt Public School', text:'Sam Sherratt Public School'},
		{value:'Sheridan Public School', text:'Sheridan Public School'},
		{value:'Silver Creek Public School', text:'Silver Creek Public School'},
		{value:'Sir E. MacMillan Public School', text:'Sir E. MacMillan Public School'},
		{value:'Stewarttown Public School', text:'Stewarttown Public School'},
		{value:'Summer School', text:'Summer School'},
		{value:'Sunningdale Public School', text:'Sunningdale Public School'},
		{value:'Syl Apps School and Section 20 Programs', text:'Syl Apps School and Section 20 Programs'},
		{value:'T. A. Blakelock High School', text:'T. A. Blakelock High School'},
		{value:'Tecumseh Public School', text:'Tecumseh Public School'},
		{value:'Tiger Jeet Singh Public School', text:'Tiger Jeet Singh Public School'},
		{value:'Tom Thomson Public School', text:'Tom Thomson Public School'},
		{value:'Viola Desmond Public School', text:'Viola Desmond Public School'},
		{value:'Virtual School Secondary', text:'Virtual School Secondary'},
		{value:'W. H. Morden Public School', text:'W. H. Morden Public School'},
		{value:'W. I. Dick Middle School', text:'W. I. Dick Middle School'},
		{value:'West Oak Public School', text:'West Oak Public School'},
		{value:'White Oaks Secondary School', text:'White Oaks Secondary School'},
	],
	'Calgary Academy': [
		{value:'Calgary Academy', text:'Calgary Academy'},
	],
	'Strathcona-Tweedsmuir School': [
		{value:'Strathcona-Tweedsmuir School', text:'Strathcona-Tweedsmuir School'},
	],
	'Kawartha Pine Ridge District School Board': [
		{value:'Adam Scott Collegiate Vocational Institute', text:'Adam Scott Collegiate Vocational Institute'},
		{value:'Adam Scott Intermediate School', text:'Adam Scott Intermediate School'},
		{value:'Apsley Central Public School', text:'Apsley Central Public School'},
		{value:'Baltimore Public School', text:'Baltimore Public School'},
		{value:'Beatrice Strong Public School', text:'Beatrice Strong Public School'},
		{value:'Bowmanville High School', text:'Bowmanville High School'},
		{value:'Brighton Public School', text:'Brighton Public School'},
		{value:'Buckhorn Public School', text:'Buckhorn Public School'},
		{value:'Burnham Public School', text:'Burnham Public School'},
		{value:'C.R. Gummow Public School', text:'C.R. Gummow Public School'},
		{value:'Camborne Public School', text:'Camborne Public School'},
		{value:'Campbellford District High School', text:'Campbellford District High School'},
		{value:'Central Public School', text:'Central Public School'},
		{value:'Charles Bowman Public School', text:'Charles Bowman Public School'},
		{value:'Chemong Public School', text:'Chemong Public School'},
		{value:'CIS - Clarington (Bowmanville)', text:'CIS - Clarington (Bowmanville)'},
		{value:'CIS - Northumberland (Cobourg)', text:'CIS - Northumberland (Cobourg)'},
		{value:'Clarington Central Intermediate School', text:'Clarington Central Intermediate School'},
		{value:'Clarington Central Secondary School', text:'Clarington Central Secondary School'},
		{value:'Clarke High School', text:'Clarke High School'},
		{value:'Cobourg Collegiate Institute', text:'Cobourg Collegiate Institute'},
		{value:'Colborne Public School', text:'Colborne Public School'},
		{value:'Courtice Intermediate School', text:'Courtice Intermediate School'},
		{value:'Courtice North Public School', text:'Courtice North Public School'},
		{value:'Courtice Secondary School', text:'Courtice Secondary School'},
		{value:'Crestwood Intermediate School', text:'Crestwood Intermediate School'},
		{value:'Crestwood Secondary School', text:'Crestwood Secondary School'},
		{value:'Dale Road Senior Public School', text:'Dale Road Senior Public School'},
		{value:'Dr. Emily Stowe Public School', text:'Dr. Emily Stowe Public School'},
		{value:'Dr. G.J. MacGillivray Public School', text:'Dr. G.J. MacGillivray Public School'},
		{value:'Dr. M.S. Hawkins Senior Public School', text:'Dr. M.S. Hawkins Senior Public School'},
		{value:'Dr. Ross Tilley Public School', text:'Dr. Ross Tilley Public School'},
		{value:'Duke of Cambridge Public School', text:'Duke of Cambridge Public School'},
		{value:'East Northumberland Secondary School', text:'East Northumberland Secondary School'},
		{value:'Edmison Heights Public School', text:'Edmison Heights Public School'},
		{value:'Enniskillen Public School', text:'Enniskillen Public School'},
		{value:'Ganaraska Trail Public School', text:'Ganaraska Trail Public School'},
		{value:'Grafton Public School', text:'Grafton Public School'},
		{value:'Hampton Junior Public School', text:'Hampton Junior Public School'},
		{value:'Harold Longworth Public School', text:'Harold Longworth Public School'},
		{value:'Hastings Public School', text:'Hastings Public School'},
		{value:'Havelock-Belmont Public School', text:'Havelock-Belmont Public School'},
		{value:'Highland Heights Public School', text:'Highland Heights Public School'},
		{value:'Hillcrest Public School', text:'Hillcrest Public School'},
		{value:'James Strath Public School', text:'James Strath Public School'},
		{value:'John M. James Public School', text:'John M. James Public School'},
		{value:'Kaawaate East City Public School', text:'Kaawaate East City Public School'},
		{value:'Kawartha Heights Public School', text:'Kawartha Heights Public School'},
		{value:'Keith Wightman Public School', text:'Keith Wightman Public School'},
		{value:'Kenner Collegiate Vocational Institute', text:'Kenner Collegiate Vocational Institute'},
		{value:'Kenner Intermediate School', text:'Kenner Intermediate School'},
		{value:'Kent Public School', text:'Kent Public School'},
		{value:'Lakefield District Public School', text:'Lakefield District Public School'},
		{value:'Lydia Trull Public School', text:'Lydia Trull Public School'},
		{value:'M.J. Hobbs Senior Public School', text:'M.J. Hobbs Senior Public School'},
		{value:'Merwin Greer Public School', text:'Merwin Greer Public School'},
		{value:'Millbrook/South Cavan Public School', text:'Millbrook/South Cavan Public School'},
		{value:'Murray Centennial Public School', text:'Murray Centennial Public School'},
		{value:'Newcastle Public School', text:'Newcastle Public School'},
		{value:'North Cavan Public School', text:'North Cavan Public School'},
		{value:'North Hope Central Public School', text:'North Hope Central Public School'},
		{value:'North Shore Public School', text:'North Shore Public School'},
		{value:'Northumberland Hills Public School', text:'Northumberland Hills Public School'},
		{value:'Norwood District High School', text:'Norwood District High School'},
		{value:'Norwood District Intermediate School', text:'Norwood District Intermediate School'},
		{value:'Norwood District Public School', text:'Norwood District Public School'},
		{value:'Orono Public School', text:'Orono Public School'},
		{value:'Otonabee Valley Public School', text:'Otonabee Valley Public School'},
		{value:'Percy Centennial Public School', text:'Percy Centennial Public School'},
		{value:'Peterborough Alternative and Continuing Education (PACE) at PCVS', text:'Peterborough Alternative and Continuing Education (PACE) at PCVS'},
		{value:'Plainville Public School', text:'Plainville Public School'},
		{value:'Port Hope High School', text:'Port Hope High School'},
		{value:'Prince of Wales Public School', text:'Prince of Wales Public School'},
		{value:'Queen Elizabeth Public School', text:'Queen Elizabeth Public School'},
		{value:'Queen Mary Public School', text:'Queen Mary Public School'},
		{value:'R.F. Downey Public School', text:'R.F. Downey Public School'},
		{value:'Roger Neilson Public School', text:'Roger Neilson Public School'},
		{value:'Roseneath Centennial Public School', text:'Roseneath Centennial Public School'},
		{value:'S.T. Worden Public School', text:'S.T. Worden Public School'},
		{value:'Smithfield Public School', text:'Smithfield Public School'},
		{value:'Spring Valley Public School', text:'Spring Valley Public School'},
		{value:'Stockdale Public School', text:'Stockdale Public School'},
		{value:'Terry Fox Public School', text:'Terry Fox Public School'},
		{value:'The Pines Senior Public School', text:'The Pines Senior Public School'},
		{value:'Thomas A. Stewart Secondary School', text:'Thomas A. Stewart Secondary School'},
		{value:'Vincent Massey Public School', text:'Vincent Massey Public School'},
		{value:'Virtual Elementary School', text:'Virtual Elementary School'},
		{value:'Virtual High School', text:'Virtual High School'},
		{value:'Warsaw Public School', text:'Warsaw Public School'},
		{value:'Waverley Public School', text:'Waverley Public School'},
		{value:'Westmount Public School', text:'Westmount Public School'},
	],
	'Langley School District #35': [
		{value:'Alex Hope Elementary', text:'Alex Hope Elementary'},
		{value:'Alice Brown Elementary', text:'Alice Brown Elementary'},
		{value:'Belmont Elementary', text:'Belmont Elementary'},
		{value:'Blacklock Fine Arts Elementary', text:'Blacklock Fine Arts Elementary'},
		{value:'Coghlan Fundamental Elementary', text:'Coghlan Fundamental Elementary'},
		{value:'Donna Gabriel Robins Elementary', text:'Donna Gabriel Robins Elementary'},
		{value:'Dorothy Peacock Elementary', text:'Dorothy Peacock Elementary'},
		{value:'Douglas Park Community Elementary', text:'Douglas Park Community Elementary'},
		{value:'Fort Langley Elementary', text:'Fort Langley Elementary'},
		{value:'Glenwood Elementary', text:'Glenwood Elementary'},
		{value:'Gordon Greenwood Elementary', text:'Gordon Greenwood Elementary'},
		{value:'James Hill Elementary', text:'James Hill Elementary'},
		{value:'James Kennedy Elementary', text:'James Kennedy Elementary'},
		{value:'Langley Fine Arts Elementary', text:'Langley Fine Arts Elementary'},
		{value:'Langley Fundamental Elementary', text:'Langley Fundamental Elementary'},
		{value:'Langley Meadows Community Elementary', text:'Langley Meadows Community Elementary'},
		{value:'Lynn Fripps Elementary', text:'Lynn Fripps Elementary'},
		{value:'Nicomekl Community Elementary', text:'Nicomekl Community Elementary'},
		{value:'Noel Booth Elementary', text:'Noel Booth Elementary'},
		{value:'North Otter Elementary', text:'North Otter Elementary'},
		{value:'Parkside Centennial Elementary', text:'Parkside Centennial Elementary'},
		{value:'Peterson Road Elementary', text:'Peterson Road Elementary'},
		{value:'R.C. Garnett Demonstration Elementary', text:'R.C. Garnett Demonstration Elementary'},
		{value:'Richard Bulpitt Elementary', text:'Richard Bulpitt Elementary'},
		{value:'Shortreed Community Elementary', text:'Shortreed Community Elementary'},
		{value:'Simonds Elementary', text:'Simonds Elementary'},
		{value:'Topham Elementary', text:'Topham Elementary'},
		{value:'U-Connect', text:'U-Connect'},
		{value:'Uplands Elementary', text:'Uplands Elementary'},
		{value:'West Langley Elementary', text:'West Langley Elementary'},
		{value:'Willoughby Elementary', text:'Willoughby Elementary'},
		{value:'Wix-Brown Elementary', text:'Wix-Brown Elementary'},
		{value:'Betty Gilbert Middle School', text:'Betty Gilbert Middle School'},
		{value:'H.D. Stafford Middle School', text:'H.D. Stafford Middle School'},
		{value:'Langley Fundamental Middle/Secondary', text:'Langley Fundamental Middle/Secondary'},
		{value:'Peter Ewart Middle School', text:'Peter Ewart Middle School'},
		{value:'Yorkson Creek Middle School', text:'Yorkson Creek Middle School'},
		{value:'Aldergrove Community Secondary', text:'Aldergrove Community Secondary'},
		{value:'Brookswood Secondary', text:'Brookswood Secondary'},
		{value:'D.W. Poppy Secondary', text:'D.W. Poppy Secondary'},
		{value:'Langley Education Centre', text:'Langley Education Centre'},
		{value:'Langley Fine Arts', text:'Langley Fine Arts'},
		{value:'Langley Secondary', text:'Langley Secondary'},
		{value:'R.E. Mountain Secondary', text:'R.E. Mountain Secondary'},
		{value:'Vanguard', text:'Vanguard'},
		{value:'Walnut Grove Secondary', text:'Walnut Grove Secondary'},
	],
	'Sturgeon Public School Division': [
		{value:'Bon Accord Community School', text:'Bon Accord Community School'},
		{value:'Camilla School', text:'Camilla School'},
		{value:'Four Winds Public School', text:'Four Winds Public School'},
		{value:'Gibbons School', text:'Gibbons School'},
		{value:'Guthrie School', text:'Guthrie School'},
		{value:'Landing Trail School', text:'Landing Trail School'},
		{value:'Learning Centres', text:'Learning Centres'},
		{value:'Legal Public School', text:'Legal Public School'},
		{value:'Lilian Schick School', text:'Lilian Schick School'},
		{value:'Morinville Colony School', text:'Morinville Colony School'},
		{value:'Morinville Public School', text:'Morinville Public School'},
		{value:'Namao School', text:'Namao School'},
		{value:'Oak Hill School', text:'Oak Hill School'},
		{value:'Ochre Park School', text:'Ochre Park School'},
		{value:'Redwater School', text:'Redwater School'},
		{value:'Sturgeon Composite High School', text:'Sturgeon Composite High School'},
		{value:'Sturgeon Heights School', text:'Sturgeon Heights School'},
	],
	'St. Thomas Aquinas Roman Catholic Separate School Division': [
		{value: 'Académie Saint-André Academy', text: 'Académie Saint-André Academy'},
		{value: 'Christ the King School', text: 'Christ the King School'},
		{value: 'École Mother d\'Youville School', text: 'École Mother d\'Youville School'},
		{value: 'École Notre Dame School', text: 'École Notre Dame School'},
		{value: 'Father Lacombe Catholic School', text: 'Father Lacombe Catholic School'},
		{value: 'Father Leduc Catholic School', text: 'Father Leduc Catholic School'},
		{value: 'Holy Trinity Academy', text: 'Holy Trinity Academy'},
		{value: 'Sacred Heart School', text: 'Sacred Heart School'},
		{value: 'St. Anthony School', text: 'St. Anthony School'},
		{value: 'St. Augustine School', text: 'St. Augustine School'},
		{value: 'St. Benedict School', text: 'St. Benedict School'},
		{value: 'STAR Catholic Outreach School', text: 'STAR Catholic Outreach School'},
	],
};

export function schools(schoolBoard) {
	const otherSchool = {value: 'other', text: 'Other'}
	var schoolList = [];

	if(schoolBoardList[schoolBoard])
		schoolList = [...schoolBoardList[schoolBoard]];
		schoolList.sort(function(a,b) {
			return a.value.localeCompare(b.value);
		});
		schoolList.unshift(otherSchool);

	return schoolList || [];
}

export function schoolFields(position) {
	return [
		{
	        key_path: ['applicant', position, 'additional_data', 'school_other'],
	        as: 'name of school you are attending',
	        show_if: [{
				key_path: ['application', 'additional_data', 'school'],
				value: 'other'
	        }],
		},
		{
            key_path: ['applicant', position, 'additional_data', 'school_other'],
            as: 'other: name of school you are attending',
            do_not_show_if: [{
				key_path: ['application', 'additional_data', 'school'],
				value: 'other'
            }],
            show_if: [{
				key_path: ['applicant', position, 'additional_data', 'school'],
				value: 'other'
            }],
		},
  	];
}

export function schoolBoardSchools(position) {
	const schoolBoardNames = Object.keys(schoolBoardList);
	let completeList = [];

	schoolBoardNames.forEach(function(school) {
		const singleElement = {
			key_path: ['applicant', position, 'additional_data', 'school'],
            as: 'name of school you are attending',
            type: 'dropdown',
            options: schools(school),
            show_if: [{
				key_path: ['application', 'additional_data', 'school'],
				value: school
            }],
		}        
        completeList.push(singleElement);
	});

	return completeList;
}


// WEBPACK FOOTER //
// ./src/helpers/schools.js